import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { doc, getDoc, collection, getDocs, query, updateDoc, where, orderBy, setDoc, deleteDoc, runTransaction } from 'firebase/firestore';
import { db } from '../../../firebase.init';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDoorOpen, faArrowLeft, faCircleCheck, faFilePdf, faTrash, faDownload, faEdit, faPoundSign, faStar, faWrench, faRuler, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './DoorResiDetail.css';
import { Accordion, Modal, Button, Form, Row, Col, InputGroup, OverlayTrigger, Tooltip, } from "react-bootstrap";
import defaultImage from '../../Assets/default.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getStorage, ref, uploadBytes, getMetadata, getDownloadURL, deleteObject } from "firebase/storage";
import ClipLoader from "react-spinners/ClipLoader";
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../../firebase.init';
import { QRCodeCanvas } from 'qrcode.react';
import { isMobile as IsMobileReact } from 'react-device-detect';
import { format, set } from 'date-fns';
import EstimateModal from '../DoorDetails/EstimateModal';
import ReactModal from "react-modal";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useUserRole } from '../../../hooks/useUserRole';
import PhotoSelector from "../DoorDetails/PhotoSelector";
import { createPortal } from "react-dom";

const DoorResiDetails = () => {
    // const { uid, doorId } = useParams();
    const [user, loadingAuth] = useAuthState(auth);

    let { uid: paramUid = "", doorId: paramDoorId = "" } = useParams();

    let { uid } = useParams();
    uid = uid || "NTH9OfVK2pgYs8SUduUI";
    const userData = useUserRole();
    const canBypassPasscode = [
        'admin',
        'manager',
        'inspection',
        'coordinator',
        'remedial',
        'reviewer',
        'inspector',
        'carpenter',
    ].includes(userData?.role);

    const doorIdMap = {
        1: "22b60159-dd2a-460f-9115-f9b96dfe2c90",
        2: "4930eae5-f631-43fc-a201-593a61aa3ea6",
    };

    const doorId = doorIdMap[paramDoorId] || paramDoorId;
    // console.log("UID:", uid);
    // console.log("Door ID:", doorId);


    const location = useLocation();
    const navigate = useNavigate();
    const [report, setReport] = useState(null);
    const [buildingData, setBuildingData] = useState(null);
    const [doorReports, setDoorReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [originalIndex, setOriginalIndex] = useState(location.state?.originalIndex || null);
    const [isSavingPasscode, setIsSavingPasscode] = useState(false);
    const isSavingPasscodeRef = useRef(false);

    const [passcodeModalType, setPasscodeModalType] = useState(null);
    const [storedPasscode, setStoredPasscode] = useState("");
    const [passcodeVerified, setPasscodeVerified] = useState(false);
    const [passcodeInput, setPasscodeInput] = useState("");
    const [newPasscode, setNewPasscode] = useState("");
    const [passcodeError, setPasscodeError] = useState("");
    const [protectedDoorNumber, setProtectedDoorNumber] = useState("");
    const [
        showPdfPhotoPicker,
        setShowPdfPhotoPicker
    ] = useState(false);

    const isMobile = window.innerWidth < 768;
    const [reportUidToUse, setReportUidToUse] = useState(null);

    const [activeKey1, setactiveKey1] = useState(null);
    const [showFullInfo, setShowFullInfo] = useState(false);
    const toggleInfo = () => {
        setShowFullInfo(!showFullInfo);
    };
    const [canScrollLeft, setCanScrollLeft] = useState(false);

    const [canScrollRight, setCanScrollRight] = useState(false);

    const [selectedDoorImage, setSelectedDoorImage] = useState(null);
    const [zoom, setZoom] = useState(1);
    const [pan, setPan] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const imageRef = useRef(null);
    const thumbRef = useRef(null);
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [mediaType, setMediaType] = useState("image");
    const [activeTab, setActiveTab] = useState("required");
    const [canScrollUp, setCanScrollUp] = useState(false);
    const [canScrollDown, setCanScrollDown] = useState(false);
    const [overlaidImages, setOverlaidImages] = useState({});
    const [isLoadingOverlay, setIsLoadingOverlay] = useState(false);
    const [overlayEnabled, setOverlayEnabled] = useState(true);
    const [highlightedClass, setHighlightedClass] = useState(null);
    const [highlightedNumber, setHighlightedNumber] = useState(null);
    const [bothImageIndex, setBothImageIndex] = useState(0);
    const overlayCacheRef = useRef({});
    const [breakdownFilter, setBreakdownFilter] = useState('all');

    const autoPlayIntervalRef = useRef(null);
    const hoverIntervalRef = useRef(null);
    const autoPlayIndexRef = useRef(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(false);
    const filteredItemsForAutoPlay = useRef([]);
    const hardwareItemsRef = useRef([]);
    const currentPlayItemsRef = useRef([]);
    const isHoveringRef = useRef(false);
    const previousMediaRef = useRef(null);
    const previousMediaTypeRef = useRef(null);
    const hoverImageListRef = useRef([]);
    const hoverCurrentIndexRef = useRef(0);
    const [isOverlayLoadingBlocking, setIsOverlayLoadingBlocking] = useState(false);

    const allItemsRef = useRef([]);
    const [showInfoPopup, setShowInfoPopup] = useState(false);
    const [popupContent, setPopupContent] = useState({ title: '', description: '' });

    const certificationInfo = {
        FD30: {
            title: 'FD30 Fire Door',

            plainEnglish:
                'FD30 means the fire door or doorset is designed and evidenced to provide at least 30 minutes of fire resistance in terms of integrity when tested to the relevant fire-resistance standard.',

            technicalNote:
                'The fire-resistance performance relates to the tested or assessed door assembly or doorset configuration. The door leaf, frame, glazing, intumescent seals, ironmongery and installation can all affect the achieved performance. A visible door leaf or label alone should not be assumed to confirm that the complete installed doorset achieves FD30 performance.',

            legislation:
                'Approved Document B; BS 8214:2026',

            sourceUrl:
                'https://www.gov.uk/government/publications/fire-safety-approved-document-b'
        },

        FD60: {
            title: 'FD60 Fire Door',

            plainEnglish:
                'FD60 means the fire door or doorset is designed and evidenced to provide at least 60 minutes of fire resistance in terms of integrity when tested to the relevant fire-resistance standard.',

            technicalNote:
                'The fire-resistance performance relates to the tested or assessed door assembly or doorset configuration. The door leaf, frame, glazing, intumescent seals, ironmongery and installation should be compatible with the evidence supporting the FD60 rating.',

            legislation:
                'Approved Document B; BS 8214:2026',

            sourceUrl:
                'https://www.gov.uk/government/publications/fire-safety-approved-document-b'
        },

        Nominal: {
            title: 'Nominal Fire Door',

            plainEnglish:
                'A nominal fire door is an existing door for which current certification or traceable test evidence may not be available, but which may nevertheless be considered capable of providing a degree of fire resistance based on its construction, condition and a competent assessment.',

            technicalNote:
                'A nominal fire door should not automatically be treated as equivalent to a certified FD30 or FD60 doorset. Its suitability should be considered as part of the fire risk assessment and should take account of the door leaf, frame, gaps, seals, self-closing device, hinges, glazing, ironmongery, damage and overall condition.',

            legislation:
                'Regulatory Reform (Fire Safety) Order 2005; Fire Safety (England) Regulations 2022 where applicable; BS 8214:2026',

            sourceUrl:
                'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance'
        },

        No: {
            title: 'No Certification Identified',

            plainEnglish:
                'No means that no satisfactory certification, identification or other evidence confirming a fire-resistance rating was identified from the information available during the inspection.',

            technicalNote:
                'This does not by itself prove that the door has no fire resistance. It means that a specific fire-resistance classification could not be verified from the certification, markings or supporting evidence available at the time of inspection. Further investigation or competent assessment may be required.',

            legislation:
                'Approved Document B; BS 8214:2026',

            sourceUrl:
                'https://www.gov.uk/government/publications/fire-safety-approved-document-b'
        }
    };

    const openCertificationInfo = (certification) => {
        let value = String(certification || 'Nominal').trim();

        if (
            ['assumed', 'nominal'].includes(
                value.toLowerCase()
            )
        ) {
            value = 'Nominal';
        }

        const matchedKey = Object.keys(certificationInfo).find(
            key => key.toLowerCase() === value.toLowerCase()
        );

        const content = matchedKey
            ? certificationInfo[matchedKey]
            : {
                title: value,
                plainEnglish:
                    'No additional explanation is currently available for this certification value.',
                technicalNote:
                    'Refer to available certification evidence, manufacturer documentation and the relevant fire risk assessment.',
                legislation:
                    'BS 8214 Fire Door Installation Guide; Approved Document B',
                sourceUrl:
                    'https://www.gov.uk/government/publications/fire-safety-approved-document-b'
            };

        setPopupContent(content);
        setShowInfoPopup(true);
    };

    const workInfoDatabase = [
        {
            keywords: ['repair door closer', 'door closer repair', 'closer repair'],
            title: 'Repair Door Closer',
            category: 'Door closer / self-closing device',
            plainEnglish: 'The door closer is the part that pulls the fire door shut after someone opens it. If it is damaged, leaking, loose, sticking or unreliable, the door may stay open or fail to shut fully. A fire door only protects people when it closes fully into the frame.',
            technicalNote: 'Where the door is required to self-close, the self-closing device must be effective and must close the door fully into the frame from any angle, including from fully open and from around 15 degrees. FireChecked should specify a controlled door-closing device suitable for the leaf size, weight, location and usage, normally to BS EN 1154 or supported by doorset evidence. Perko or concealed chain closers should not be accepted by default; they should only be retained or installed where the fire risk assessment, fire strategy, manufacturer evidence or competent person specifically confirms suitability, and the door passes the closing test.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 3 and 6.7(h)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['adjust door closer', 'door closer adjust', 'closer adjustment'],
            title: 'Adjust Door Closer',
            category: 'Door closer / self-closing device',
            plainEnglish: 'The closer is fitted, but it is not set correctly. The door may close too slowly, slam, stop before the latch catches, or fail when opened only slightly. Adjustment is needed so the door shuts safely, fully and reliably every time.',
            technicalNote: 'The self-closing device must overcome latch resistance, smoke seals, floor friction and normal door movement so that the door returns fully into the frame. Adjustment must not compromise safe escape use, accessibility or the fire door\'s tested arrangement. For FireChecked reports, Perko/concealed chain closers should only be accepted where specifically justified by the fire risk assessment, fire strategy or competent assessment, and only if they close the door fully from the required test positions.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(h)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['install new door closer', 'new door closer', 'fit door closer', 'install closer'],
            title: 'Install New Door Closer',
            category: 'Door closer / self-closing device',
            plainEnglish: 'There is no suitable closer fitted. This means the door relies on people remembering to shut it. In a fire, an open door can allow smoke and flames to spread into corridors, stairs or escape routes. A suitable closer makes the door shut automatically.',
            technicalNote: 'Where the fire risk assessment, fire strategy, door location or Regulation 10 check requires self-closing, a suitable controlled door-closing device should be installed. The closer must be compatible with the fire rating, size, weight and use of the door. FireChecked should normally specify a controlled overhead closer to BS EN 1154 or another closer supported by doorset evidence. Perko or concealed chain closers should not be used as the default solution unless specifically justified by the fire risk assessment, fire strategy or competent specification.',
            legislation: 'RRO 2005 Articles 14 and 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(h)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace door closer', 'door closer replace', 'closer replacement'],
            title: 'Replace Door Closer',
            category: 'Door closer / self-closing device',
            plainEnglish: 'The existing closer is not suitable or cannot be made to work properly. It may be too weak, too strong, damaged, worn out, leaking, or the wrong type for the door. Replacement is needed so the fire door closes fully and consistently.',
            technicalNote: 'A closer is not compliant simply because one is present. It must be effective for the door leaf size, weight, usage level, latch resistance, seals and location. If it cannot reliably close the door fully into the frame from the required positions, it should be replaced with a suitable controlled door-closing device compatible with the fire door evidence. Perko/concealed chain closers should only be retained where specifically accepted by the fire risk assessment, fire strategy, manufacturer evidence or competent person.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 6.4 and 6.7(h)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['install intumescent strips', 'intumescent strips', 'intumescent seals', 'fit intumescent'],
            title: 'Install Intumescent Strips',
            category: 'Seals / smoke control',
            plainEnglish: 'Intumescent strips are fire seals fitted around the edge of a fire door or frame. When exposed to heat, they expand and help seal the gap between the door and frame. This helps slow the spread of fire and hot smoke.',
            technicalNote: 'Where required by the fire risk assessment, original fire strategy, door specification or doorset evidence, intumescent strips must be present, continuous, correctly located and compatible with the required fire rating. The absence of strips on an older existing flat entrance door does not automatically mean the door is unfit, but the door must remain adequate to resist fire and smoke spread as determined by the fire risk assessment.',
            legislation: 'RRO 2005 Articles 9 and 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 3.3, 3.4, 6.7(f) and note at 1.0',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace damaged intumescent strip', 'damaged intumescent', 'intumescent damaged'],
            title: 'Replace Damaged Intumescent Strip',
            category: 'Seals / smoke control',
            plainEnglish: 'The intumescent strip is present but damaged. It may be split, loose, crushed, painted over or missing sections. If it cannot expand correctly during a fire, it may not seal the gap around the door.',
            technicalNote: 'Intumescent strips and smoke seals, where required or present, should be undamaged, continuous, correctly seated, not painted over and capable of making contact with the door edge or frame. Damaged or incomplete seals should be replaced with compatible fire-rated products suitable for the door\'s rating and tested or assessed arrangement.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(f)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace missing intumescent strip', 'missing intumescent', 'intumescent missing'],
            title: 'Replace Missing Intumescent Strip',
            category: 'Seals / smoke control',
            plainEnglish: 'A section of fire seal is missing. This leaves part of the door edge unprotected. In a fire, that gap can allow heat, smoke or flames to pass through sooner than expected.',
            technicalNote: 'Where intumescent protection forms part of the required door specification, missing sections should be replaced with compatible seals matching the required size, rating and location. Replacement should maintain the tested or assessed performance of the doorset and be carried out by a competent person.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(f)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['intumescent strip installed incorrectly', 'incorrect intumescent', 'intumescent wrong'],
            title: 'Intumescent Strip Installed Incorrectly',
            category: 'Seals / smoke control',
            plainEnglish: 'The fire seal has been fitted in the wrong place, cut short, fitted badly, painted over, installed the wrong way, or does not line up with the door or frame. A fire seal only works properly when it is fitted correctly.',
            technicalNote: 'Incorrectly installed intumescent strips may not activate or seal the door edge as intended. The strip must be the correct type, size, orientation and position for the door leaf or frame. Installation should follow the door manufacturer\'s evidence, product instructions, fire risk assessment and competent fire door specification.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(f)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace drop down seal', 'drop down seal', 'bottom seal', 'threshold seal'],
            title: 'Replace Drop Down Seal',
            category: 'Seals / smoke control',
            plainEnglish: 'A drop-down seal is fitted at the bottom of the door. When the door closes, the seal drops down to reduce the gap under the door. If it is damaged, missing, stuck or not working, smoke can pass underneath the door more easily.',
            technicalNote: 'Where a drop-down seal forms part of the fire or smoke control strategy, it must operate correctly when the door closes and must not prevent the door from closing or latching. A defective seal should be replaced with a compatible fire-rated or smoke-rated product suitable for the door type, threshold condition and required performance. The replacement should activate consistently, seal the threshold effectively and not create excessive friction that prevents self-closing.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 6.7(f), 6.7(g) and 6.7(h)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['screws missing from hinge', 'missing screws hinge', 'hinge screws missing'],
            title: 'Screws Missing From Hinge',
            category: 'Hinges / fixings',
            plainEnglish: 'The hinges hold the full weight of the door. If screws are missing, the door can drop, twist or stop closing properly. A fire door needs to stay securely fixed in its frame during normal use and during a fire.',
            technicalNote: 'Missing hinge screws are a defect because the hinge may not secure the door leaf correctly. This can affect alignment, gaps, closing action and the ability of the door to remain in position during fire exposure. Missing screws should be replaced with suitable fire door hinge screws of the correct size, material and fixing depth, compatible with the hinge, frame and doorset specification.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(e)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: [
                'replace escutcheon',
                'escutcheon',
                'replace key escutcheon',
                'replace euro escutcheon',
                'missing escutcheon',
                'damaged escutcheon'
            ],
            title: 'Replace Escutcheon',
            category: 'Ironmongery / Lock Protection',
            plainEnglish: 'An escutcheon is the protective plate or surround fitted around a keyhole or lock cylinder. If it is missing, damaged or loose, the lock area may not be properly protected and the fire door may no longer match its approved fire door specification.',
            technicalNote: 'Where an escutcheon forms part of a fire door assembly, it should be securely fixed and compatible with the installed lockset and doorset. Damaged, loose or missing escutcheons should be replaced with a suitable fire-rated or manufacturer-approved component that maintains the integrity of the door leaf and the lock preparation. Any replacement should not enlarge existing cut-outs or compromise the fire performance of the door assembly.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 6.7(d) and 6.7(i)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['loose screws on hinge', 'hinge screws loose', 'loose hinge screws'],
            title: 'Loose Screws on Hinge',
            category: 'Hinges / fixings',
            plainEnglish: 'Loose hinge screws mean the door is not being held firmly. The door may move, drop, scrape the floor or fail to close into the frame. This can stop the fire door from working correctly.',
            technicalNote: 'Hinge fixings must be secure so that the door remains aligned and closes correctly. Loose screws can cause excessive gaps, failed latching, frame damage and hinge movement. Loose screws should be tightened or replaced; where fixing holes are damaged, repair should use a suitable fire door repair method by a competent person.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(e)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['install third fire rated hinge', 'third hinge', 'additional hinge', 'third fire hinge'],
            title: 'Install Third Fire Rated Hinge',
            category: 'Hinges / fixings',
            plainEnglish: 'The door does not have enough suitable hinges. A heavy fire door normally needs enough hinges to hold it straight and stable. If there are too few hinges, the door can drop or twist, which may create gaps or stop it closing properly.',
            technicalNote: 'The number, size and type of hinges should be suitable for the door leaf weight, height, usage and fire rating. Many timber fire doors require three suitable fire-rated hinges unless the manufacturer\'s evidence states otherwise. Any additional hinge must be fire-rated, correctly positioned, compatible with the doorset evidence and fitted with suitable intumescent protection where required.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; BS EN 1935 as hardware standard reference; GOV.UK fire door guidance section 6.7(e)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace broken hinge', 'broken hinge', 'hinge broken', 'damaged hinge'],
            title: 'Replace Broken Hinge',
            category: 'Hinges / fixings',
            plainEnglish: 'A broken hinge can stop the door sitting correctly in the frame. It can also prevent the door from closing or latching. If the hinge fails, the door may not stay in place during a fire.',
            technicalNote: 'Hinges form part of the fire door assembly and must remain secure, aligned and operational. A broken hinge should be replaced with a suitable fire-rated hinge matching the fire rating, door weight, usage category and manufacturer evidence. Intumescent hinge pads should be installed where required by the tested or assessed arrangement.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; BS EN 1935 as hardware standard reference; GOV.UK fire door guidance section 6.7(e)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace non-compliant hinge', 'non compliant hinge', 'incorrect hinge', 'wrong hinge'],
            title: 'Replace Non-Compliant Hinge',
            category: 'Hinges / fixings',
            plainEnglish: 'The hinge may be the wrong type, not fire-rated, too small, badly fitted, or unsuitable for the weight of the door. Even if the door leaf is fire-rated, the wrong hinges can stop the whole doorset performing properly.',
            technicalNote: 'Hinges must be compatible with the fire-resisting doorset and should normally be fire-rated and suitable for the required duty. Non-compliant hinges should be replaced with hinges that meet the relevant fire door specification, doorset evidence and hardware standard, commonly BS EN 1935 for single-axis hinges. Hinge pads or intumescent protection should be fitted where required.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; BS EN 1935 as hardware standard reference; GOV.UK fire door guidance section 6.7(e)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace non-compliant locks', 'non compliant locks', 'incorrect locks', 'wrong locks', 'replace locks'],
            title: 'Replace Non-Compliant Locks',
            category: 'Locks / escape hardware',
            plainEnglish: 'The lock or latch is not suitable for a fire door. It may have left holes in the door, stop the door closing properly, or fail to hold the door shut. A fire door should close securely into the frame so it can resist smoke and fire.',
            technicalNote: 'Locks, latches and other ironmongery must be compatible with the fire door assembly and must not compromise the door leaf\'s fire resistance. Non-compliant locks may create unprotected penetrations, excessive morticing, failed latching or weak points. Replacement should use suitable fire-rated or fire-tested ironmongery with intumescent protection where required, maintaining the tested or assessed performance of the doorset.',
            legislation: 'RRO 2005 Articles 14 and 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 6.7(c), 6.7(e) and 6.7(h)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['install keyless exit', 'keyless exit', 'keyless lock', 'thumb turn'],
            title: 'Install Keyless Exit',
            category: 'Locks / escape hardware',
            plainEnglish: 'A keyless exit means people can leave without needing a key. This is important on escape routes because, during a fire, people may panic, visibility may be poor, and a key may not be available. The door can still remain secure from the outside while allowing safe escape from inside.',
            technicalNote: 'Where a door forms part of a means of escape, the escape side should be capable of being opened readily without requiring a key unless specifically justified by the fire risk assessment. Escape hardware must also remain compatible with the fire door\'s fire resistance, smoke control and security requirements. The design should support safe evacuation while maintaining the integrity of the fire-resisting doorset.',
            legislation: 'RRO 2005 Articles 14 and 17; GOV.UK fire door guidance sections 3 and 6.7(e)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['upgrade non-compliant letterbox', 'letterbox', 'letter plate', 'non compliant letterbox'],
            title: 'Upgrade Non-Compliant LetterBox',
            category: 'Ironmongery / letterbox',
            plainEnglish: 'A letterbox is an opening through the door. If it is not suitable for a fire door, damaged, loose, missing a flap, or jammed open, smoke and fire can pass through it. A compliant letterbox helps keep the opening protected.',
            technicalNote: 'Letterboxes fitted in fire doors must be suitable for use in fire-resisting doors and should be installed in accordance with the product evidence and door specification. The letterbox should remain firmly closed, not jammed open, and should not create an unprotected penetration through the door leaf. Any upgrade should use a compatible fire-rated letterplate or letterbox assembly with appropriate intumescent protection where required.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(b)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace damaged door', 'damaged door leaf', 'door damaged', 'door replacement'],
            title: 'Replace Damaged Door',
            category: 'Door leaf',
            plainEnglish: 'The door leaf is the main moving part of the fire door. If it is badly damaged, split, warped, holed, cut, delaminated or weakened, it may not hold back fire and smoke. If the damage is too serious to repair, the door should be replaced.',
            technicalNote: 'The door leaf must remain structurally sound and capable of achieving the fire resistance required by the fire risk assessment, fire strategy or original design. Significant damage, warping, holes, delamination, excessive alteration or loss of core integrity may make repair unsuitable. Replacement should be with a compatible fire-resisting doorset or door assembly installed by a competent person.',
            legislation: 'RRO 2005 Articles 9 and 17; Fire Safety Act 2021 section 1 where applicable; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 3.3, 6.7(a) and 6.7(c)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['repair damaged door', 'door repair', 'repair door leaf'],
            title: 'Repair Damaged Door',
            category: 'Door leaf',
            plainEnglish: 'The door is damaged, but the damage may be repairable. Small areas of damage can sometimes be made good using suitable fire-rated repair methods. The repair must not weaken the door or stop it working as a fire door.',
            technicalNote: 'Minor defects may be repaired where the repair method is suitable for a fire-resisting door and does not compromise the door leaf, seals, hardware, glazing or certification evidence. Repairs should be completed by a competent person using appropriate fire-rated materials and methods. Cosmetic repair alone is not sufficient where the damage affects fire or smoke performance.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 3.4, 6.4 and 6.7(c)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace non-compliant door', 'non compliant door', 'incorrect door', 'wrong door'],
            title: 'Replace Non-Compliant Door',
            category: 'Door leaf',
            plainEnglish: 'The door is not suitable for the job it needs to do. It may not be fire-rated, may have been altered too much, may not fit the frame, or may not be capable of holding back fire and smoke. In this case, the safest option is to replace it with a suitable fire door.',
            technicalNote: 'A door should be replaced where it cannot be verified as adequate by the fire risk assessment, has been altered beyond acceptable limits, cannot be repaired to a competent standard, or does not provide the required fire and smoke resistance for its location. Replacement should follow the fire strategy and should use a suitable certified or appropriately evidenced fire-resisting doorset or door assembly installed by a competent contractor.',
            legislation: 'RRO 2005 Articles 9 and 17; Fire Safety Act 2021 section 1 where applicable; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 3.3, 3.4, 6.2 and 6.7(a)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['repair damaged door frame', 'door frame repair', 'frame damaged'],
            title: 'Repair Damaged Door Frame',
            category: 'Door frame',
            plainEnglish: 'The frame is the fixed part around the door. If it is cracked, loose, split or damaged, the door may not close properly or seal correctly. A good fire door will not work properly if the frame around it is damaged.',
            technicalNote: 'The frame forms part of the fire door assembly and must remain securely fixed, aligned and capable of supporting the door, hinges, seals, latch and glazing arrangement. Frame damage should be repaired using a suitable fire door repair method. Repairs must not reduce the fire resistance of the doorset or create excessive gaps between the door and frame.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 6.7(c) and 6.7(g)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace damaged door frame', 'door frame replacement', 'frame replace'],
            title: 'Replace Damaged Door Frame',
            category: 'Door frame',
            plainEnglish: 'The frame is too badly damaged to repair. If the frame cannot hold the door correctly, the whole fire door may fail even if the door leaf itself is in good condition. A replacement frame may be needed to restore the door\'s fire performance.',
            technicalNote: 'Where the frame is structurally damaged, distorted, inadequately fixed, excessively cut, or no longer capable of supporting the door assembly, replacement may be required. The replacement frame must be compatible with the fire door leaf, seals, hardware and required fire rating. Installation should follow the tested or assessed doorset specification and be carried out by a competent person.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 6.7(c) and 6.7(g)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace cracked glass', 'cracked glass', 'glass cracked', 'broken glass'],
            title: 'Replace Cracked Glass',
            category: 'Glazing',
            plainEnglish: 'Fire-rated glass is designed to resist fire for a set period. If the glass is cracked, it may fail much sooner in a fire. Cracked glass should be replaced with suitable fire-rated glass, not ordinary glass.',
            technicalNote: 'Fire-resisting glazing must remain intact and capable of resisting fire and smoke spread for the required period. Cracked or damaged glass should be replaced with glazing that matches the required fire rating, type, thickness and tested glazing system. The replacement must include compatible beads, seals, liners and fixings where required.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 6.7(c) and 6.7(d)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace non-compliant glass', 'non compliant glass', 'wrong glass', 'incorrect glass'],
            title: 'Replace Non-Compliant Glass',
            category: 'Glazing',
            plainEnglish: 'The glass may look normal, but it may not be suitable for a fire door. Ordinary safety glass is not the same as fire-rated glass. If the wrong glass is fitted, it can break quickly in a fire and leave an opening through the door.',
            technicalNote: 'Glazing in a fire door must be fire-resisting and compatible with the tested or assessed door construction. Non-compliant glass should be replaced with suitable fire-rated glazing supported by appropriate evidence. The entire glazing system, including glass, beads, glazing liner, seals and fixings, must be suitable for the door\'s fire rating.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(d)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['refix loose glazing beads', 'loose glazing beads', 'glazing beads loose'],
            title: 'Refix Loose Glazing Beads',
            category: 'Glazing',
            plainEnglish: 'Glazing beads are the strips that hold the glass in the door. If they are loose, the glass may move or fall out, especially in a fire. The beads need to be fixed securely so the glass stays in place.',
            technicalNote: 'Glazing beads form part of the fire-resisting glazing system. Loose beads should be securely refixed using the correct fixings, spacing and method for the tested or assessed arrangement. Refixing must not damage the glass, door leaf or glazing seals, and the completed system must retain the required fire resistance.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(d)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['replace glazing beads', 'glazing beads replace', 'new glazing beads'],
            title: 'Replace Glazing Beads',
            category: 'Glazing',
            plainEnglish: 'The glazing beads are damaged, missing, loose, incorrect or unsuitable. If the beads cannot hold the glass correctly, the glass may fail during a fire. They should be replaced with the correct fire-rated glazing beads.',
            technicalNote: 'Glazing beads must be compatible with the fire-rated glazing system and the door\'s fire rating. Damaged, missing or non-compliant beads should be replaced with suitable fire-rated beads, fixings and glazing seals in accordance with the tested or assessed specification. Standard decorative beads should not be used unless supported by the fire door evidence.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(d)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['clear blocked ventilation gaps', 'blocked ventilation', 'ventilation blocked', 'clear ventilation'],
            title: 'Clear Blocked Ventilation Gaps',
            category: 'Ventilation / grilles',
            plainEnglish: 'Some service cupboards, risers or plant doors need ventilation so equipment does not overheat and airflow is maintained. If ventilation gaps or grilles are blocked, the cupboard may not work as intended. However, ventilation in a fire door must be properly designed so it does not allow fire and smoke to spread.',
            technicalNote: 'Ventilation grilles, transfer grilles and air paths in fire-resisting doors must be assessed against the fire strategy and door specification. Where ventilation is required, it should normally be provided by a suitable fire-rated or intumescent air transfer grille. Blocked ventilation should be cleared only where the ventilation provision is intended and does not compromise fire compartmentation, smoke control or escape route protection.',
            legislation: 'RRO 2005 Articles 9 and 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance sections 6.7(e) and 6.12',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['adjust gaps', 'adjust gap', 'gap adjustment', 'adjust gap top', 'adjust gap bottom', 'adjust gap lock', 'adjust gap hinge', 'gap'],
            title: 'Adjust Gaps',
            category: 'Gaps / alignment',
            plainEnglish: 'The gaps around the door are too large or uneven. Fire doors need controlled gaps so the door can close properly and the seals can work. If the gaps are too big, smoke and fire can pass through more easily.',
            technicalNote: 'Door-to-frame gaps should be controlled so they remain within accepted fire door tolerances and the door can close fully without binding. GOV.UK fire door guidance states that the industry standard is that the gap should never be more than 4 mm, except at the bottom where the gap should be as small as practicable while ensuring the door is unlikely to snag on the floor. Excessive or uneven gaps may require hinge adjustment, frame repair, door realignment, threshold sealing or competent remedial works. Smoke control doors may require tighter threshold control depending on the fire risk assessment and specification.',
            legislation: 'RRO 2005 Article 17; Fire Safety (England) Regulations 2022 Regulation 10; GOV.UK fire door guidance section 6.7(g)',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        },
        {
            keywords: ['install additional gaps', 'additional gaps', 'gap needed'],
            title: 'Install Additional Gaps If Needed',
            category: 'Gaps / alignment',
            plainEnglish: 'The clearances around the fire door do not comply with recommended tolerances and may affect the ability of the door to close correctly or maintain effective smoke and fire sealing. Excessively tight gaps can prevent self-closing, while excessive gaps may allow smoke and flames to spread.',
            technicalNote: 'Adjustments should be carried out to achieve compliant perimeter and threshold gaps in accordance with manufacturer certification and British Standards guidance.',
            legislation: 'BS 8214 Fire Door Installation Guide; Approved Document B',
            sourceUrl: 'https://www.gov.uk/government/publications/fire-safety-england-regulations-2022-fire-door-guidance/fire-safety-england-regulations-2022-fire-door-guidance'
        }
    ];

    const findWorkInfo = (searchText) => {
        if (!searchText) return null;

        const textLower = searchText.toLowerCase().trim();

        let match = workInfoDatabase.find(item =>
            item.keywords.some(keyword => keyword === textLower)
        );

        if (match) return match;

        match = workInfoDatabase.find(item =>
            item.keywords.some(keyword => textLower.includes(keyword))
        );

        if (match) return match;

        match = workInfoDatabase.find(item =>
            item.keywords.some(keyword => keyword.includes(textLower))
        );

        if (match) return match;

        const cleanText = textLower.replace(/replace|install|new|the|a|an/g, '').trim();
        if (cleanText !== textLower) {
            match = workInfoDatabase.find(item =>
                item.keywords.some(keyword => keyword.includes(cleanText) || cleanText.includes(keyword))
            );
        }

        return match || null;
    };

    const WorkInfoPopup = ({ show, onClose, content }) => {
        if (!show || !content) return null;

        return (
            <div
                className="position-fixed top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center"
                style={{
                    background: 'rgba(0,0,0,0.75)',
                    backdropFilter: 'blur(12px)',
                    zIndex: 9999,
                    animation: 'fadeIn 0.2s ease'
                }}
                onClick={onClose}
            >
                <div
                    className="bg-white rounded-4 shadow-xl m-3"
                    style={{
                        width: '100%',
                        maxWidth: '600px',
                        maxHeight: '85vh',
                        overflow: 'hidden',
                        animation: 'slideUp 0.3s ease'
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div
                        className="px-4 py-3 border-bottom"
                        style={{ background: '#f8f9fa' }}
                    >
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <h5
                                    className="fw-bold mb-1"
                                    style={{
                                        fontSize: '1.25rem',
                                        color: '#1a1a2e'
                                    }}
                                >
                                    {content.title}
                                </h5>
                            </div>

                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                style={{ fontSize: '0.8rem' }}
                            />
                        </div>
                    </div>

                    <div
                        className="p-4"
                        style={{
                            maxHeight: 'calc(85vh - 140px)',
                            overflowY: 'auto'
                        }}
                    >
                        {content.plainEnglish && (
                            <div className="mb-4">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <h6
                                        className="fw-bold mb-0"
                                        style={{ color: '#0d6efd' }}
                                    >
                                        Plain English Explanation
                                    </h6>
                                </div>

                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: '0.95rem',
                                        lineHeight: '1.6',
                                        color: '#2c3e50'
                                    }}
                                >
                                    {content.plainEnglish}
                                </p>
                            </div>
                        )}

                        {content.technicalNote && (
                            <div className="mb-4">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <h6
                                        className="fw-bold mb-0"
                                        style={{ color: '#198754' }}
                                    >
                                        Technical Compliance Note
                                    </h6>
                                </div>

                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: '0.95rem',
                                        lineHeight: '1.6',
                                        color: '#2c3e50'
                                    }}
                                >
                                    {content.technicalNote}
                                </p>
                            </div>
                        )}

                        {content.legislation && (
                            <div className="mb-4">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <h6
                                        className="fw-bold mb-0"
                                        style={{ color: '#dc3545' }}
                                    >
                                        Relevant Legislation & Guidance
                                    </h6>
                                </div>

                                <div
                                    style={{
                                        fontSize: '0.9rem',
                                        lineHeight: '1.6',
                                        color: '#495057'
                                    }}
                                >
                                    {content.legislation
                                        .split(';')
                                        .map((item, idx) => (
                                            <div key={idx} className="mb-1">
                                                • {item.trim()}
                                            </div>
                                        ))}
                                </div>
                            </div>
                        )}

                        {content.sourceUrl && (
                            <div className="mb-3 pt-2 border-top">
                                <div className="d-flex align-items-center gap-2">
                                    <span style={{ fontSize: '1rem' }}>🔗</span>

                                    <a
                                        href={content.sourceUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            fontSize: '0.8rem',
                                            color: '#6c757d',
                                            textDecoration: 'none'
                                        }}
                                        className="hover-underline"
                                    >
                                        Source: GOV.UK Fire Door Guidance
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>

                    <div
                        className="px-4 py-3 border-top"
                        style={{ background: '#f8f9fa' }}
                    >
                        <button
                            type="button"
                            className="btn btn-primary w-100 py-2 rounded-3 fw-semibold"
                            onClick={onClose}
                            style={{ fontSize: '0.9rem' }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const showInfo = (workText, itemTitle, itemSub) => {
        let match = findWorkInfo(workText);

        if (!match && itemTitle) {
            match = findWorkInfo(itemTitle);
        }

        if (!match && itemSub) {
            match = findWorkInfo(itemSub);
        }

        if (match) {
            setPopupContent({
                title: match.title,
                category: match.category,
                plainEnglish: match.plainEnglish,
                technicalNote: match.technicalNote,
                legislation: match.legislation,
                sourceUrl: match.sourceUrl
            });
            setShowInfoPopup(true);
        } else {
            setPopupContent({
                title: workText || itemTitle || 'Work Item',
                category: 'General',
                plainEnglish: 'No detailed information available for this work item.',
                technicalNote: 'Please refer to the fire risk assessment or consult a competent person.',
                legislation: 'Refer to RRO 2005 and Fire Safety (England) Regulations 2022',
                sourceUrl: null
            });
            setShowInfoPopup(true);
        }
    };

    const getHardwareItem = (title) => {
        return allItemsRef.current.find(i => i.title === title && i.type === 'hardware');
    };

    const getCategoryClass = (title) => {
        const hardwareItem = getHardwareItem(title);
        if (hardwareItem?.categoryClasses?.length > 0) {
            return hardwareItem.categoryClasses[0].cls;
        }

        const classMap = {
            'Hinges': 'hinge',
            'Door Closer': 'door_closer',
            'Closer': 'door_closer',
            'Locks & Security': 'mortice_lock',
            'Glazing': 'glass',
            'Accessories': 'letter_box',
            'Intumescent Seals': 'doorStrips',
            'Seals & Vent': 'drop_down_seal',
            'Door & Frame': 'door_damage',
            'Internal Check': 'ventilation'
        };
        return classMap[title] || null;
    };


    const findTargetCard = (workText) => {
        const textLower = workText.toLowerCase();
        let targetItem = null;
        let targetTitle = '';


        if (textLower.includes('adjust gap')) {
            if (textLower.includes('top')) targetTitle = 'Top Side Gap';
            else if (textLower.includes('bottom')) targetTitle = 'Bottom Side Gap';
            else if (textLower.includes('lock')) targetTitle = 'Lock Side Gap';
            else if (textLower.includes('hinge')) targetTitle = 'Hinge Side Gap';
        }

        else if (textLower.includes('intumescent') || textLower.includes('strip')) {
            targetTitle = 'Intumescent Seals';
        }

        else if (textLower.includes('closer')) {

            const closerCard = filteredItemsForAutoPlay.current.find(i => i.title === 'Closer');
            if (closerCard) {
                targetTitle = 'Closer';
            } else {
                targetTitle = 'Door Closer';
            }
        }

        else if (textLower.includes('internal check') || textLower.includes('vent')) {
            targetTitle = 'Internal Check';
            const internalCheckExists = filteredItemsForAutoPlay.current.some(i => i.title === 'Internal Check');
            if (!internalCheckExists) targetTitle = 'Seals & Vent';
        }

        else if (textLower.includes('hinge')) {
            targetTitle = 'Hinges';
        }

        else if (textLower.includes('door') && (textLower.includes('repair') || textLower.includes('replace') || textLower.includes('damage'))) {
            targetTitle = 'Door & Frame';
        }

        else if (textLower.includes('lock') || textLower.includes('keyless')) {
            targetTitle = 'Locks & Security';
        }

        else if (textLower.includes('letterbox') || textLower.includes('letter box')) {
            targetTitle = 'Accessories';
        }

        else if (textLower.includes('glass')) {
            targetTitle = 'Glazing';
        }
        else {
            const foundItem = filteredItemsForAutoPlay.current.find(i => i.sub === workText);
            if (foundItem) {
                targetItem = foundItem;
                targetTitle = foundItem.title;
            }
        }

        if (targetTitle && !targetItem) {
            targetItem = filteredItemsForAutoPlay.current.find(i => i.title === targetTitle) ||
                allItemsRef.current.find(i => i.title === targetTitle);
        }

        if (targetItem) {
            const cardNumber = filteredItemsForAutoPlay.current.findIndex(i => i.title === targetItem.title) + 1;
            return { targetItem, cardNumber: cardNumber > 0 ? cardNumber : null };
        }

        return { targetItem: null, cardNumber: null };
    };


    const buildImageList = (item) => {
        const imageList = [];
        const title = item.title;

        const pullPhoto = report?.doorPullPhotoLink;
        const pushPhoto = report?.doorPushPhotoLink;
        const certPhoto = report?.doorCertPhotoLink;
        const hinge1 = report?.hingePhotoLink;
        const hinge2 = report?.hingePhotoLink2;
        const hinge3 = report?.hingePhotoLink3;
        const lockPhoto1 = report?.lockPhotoLink;
        const lockPhoto2 = report?.lockPhotoLink2;
        const lockPhoto3 = report?.lockPhotoLink3;
        const letterPhoto = report?.letterBoxPhotoLink;
        const glassStamp = report?.glassFireStampLink;
        const damagePhotos = [report?.doorDamageLink, report?.doorDamageLink2, report?.doorDamageLink3, report?.doorDamageLink4, report?.doorDamageLink5].filter(Boolean);


        if (title === 'Internal Check' || title === 'Seals & Vent') {
            if (pushPhoto) imageList.push(pushPhoto);
            if (pullPhoto) imageList.push(pullPhoto);
        }
        else if (title === 'Intumescent Seals') {
            if (certPhoto) imageList.push(certPhoto);
            else if (pushPhoto) imageList.push(pushPhoto);
        }
        else if (title === 'Hinges') {
            const pullR = report?.aiAnnotations?.find(a => a.id === 'pullAiAnnotations')?.regions || [];
            const pushR = report?.aiAnnotations?.find(a => a.id === 'pushAiAnnotations')?.regions || [];
            const hinge1 = report?.hingePhotoLink;
            const hinge2 = report?.hingePhotoLink2;
            const hinge3 = report?.hingePhotoLink3;

            if (pullR.some(r => r.cls === 'hinge') && pullPhoto) imageList.push(pullPhoto);
            if (pushR.some(r => r.cls === 'hinge') && pushPhoto) imageList.push(pushPhoto);

            if (hinge1) imageList.push(getDisplayUrl(hinge1, 'hingePhotoLink'));
            if (hinge2) imageList.push(getDisplayUrl(hinge2, 'hingePhotoLink2'));
            if (hinge3) imageList.push(getDisplayUrl(hinge3, 'hingePhotoLink3'));

            if (imageList.length === 0) {
                if (pullPhoto) imageList.push(pullPhoto);
                if (pushPhoto) imageList.push(pushPhoto);
                if (hinge1) imageList.push(getDisplayUrl(hinge1, 'hingePhotoLink'));
                if (hinge2) imageList.push(getDisplayUrl(hinge2, 'hingePhotoLink2'));
                if (hinge3) imageList.push(getDisplayUrl(hinge3, 'hingePhotoLink3'));
            }
        }
        else if (title === 'Normal Screws' || title === 'Missing Screws' || title === 'Loose Screws') {
            if (hinge1) imageList.push(hinge1);
            if (hinge2) imageList.push(hinge2);
            if (hinge3) imageList.push(hinge3);
        }
        else if (title === 'Door Closer' || title === 'Closer') {
            if (pushPhoto) imageList.push(pushPhoto);
        }
        else if (title === 'Locks & Security') {
            if (pushPhoto) imageList.push(pushPhoto);
            if (lockPhoto1) imageList.push(lockPhoto1);
            if (lockPhoto2) imageList.push(lockPhoto2);
            if (lockPhoto3) imageList.push(lockPhoto3);
        }
        else if (title === 'Glazing') {
            if (pushPhoto) imageList.push(pushPhoto);
            if (glassStamp) imageList.push(glassStamp);
        }
        else if (title === 'Handles & Push Pad') {
            if (pullPhoto) imageList.push(pullPhoto);
            if (pushPhoto) imageList.push(pushPhoto);
        }
        else if (title === 'Accessories') {
            if (pushPhoto) imageList.push(pushPhoto);
            if (letterPhoto) imageList.push(letterPhoto);
        }
        else if (title === 'Door & Frame') {
            imageList.push(...damagePhotos);
            if (imageList.length === 0 && pullPhoto) imageList.push(pullPhoto);
        }
        else if (title?.includes('Gap')) {
            if (pullPhoto) imageList.push(pullPhoto);
        }
        else {
            if (pullPhoto) imageList.push(pullPhoto);
            if (pushPhoto) imageList.push(pushPhoto);
        }

        return [...new Set(imageList)];
    };

    const navigateToAIBreakdown = (workText) => {

        setActiveTab('breakdown');
        setBreakdownFilter('fail');

        const { targetItem, cardNumber } = findTargetCard(workText);

        if (targetItem && cardNumber) {

            const hardwareItem = getHardwareItem(targetItem.title);
            const hoverItem = {
                ...targetItem,
                num: cardNumber,
                categoryClasses: hardwareItem?.categoryClasses || targetItem.categoryClasses || []
            };

            handleAIItemHover(hoverItem);

            setTimeout(() => {
                const element = document.querySelector(`[data-ai-item="${cardNumber}"]`);
                if (element) {
                    // element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    // element.style.transition = 'all 0.2s ease';
                    // element.style.boxShadow = '0 0 0 2px #0d6efd';
                    setTimeout(() => {
                        element.style.boxShadow = '';
                    }, 1500);
                }
            }, 200);

            setTimeout(() => {
                setHighlightedNumber(null);
                setHighlightedClass(null);
            }, 5000);
        }
    };

    const stopAutoPlay = (restoreImage = true) => {
        if (autoPlayIntervalRef.current) {
            clearInterval(autoPlayIntervalRef.current);
            autoPlayIntervalRef.current = null;
        }
        if (hoverIntervalRef.current) {
            clearInterval(hoverIntervalRef.current);
            hoverIntervalRef.current = null;
        }
        setIsAutoPlaying(false);

        if (restoreImage) {
            setHighlightedClass(null);
            setHighlightedNumber(null);
        }
    };

    const startAutoPlay = () => {

        if (isLoadingOverlay) {
            setIsOverlayLoadingBlocking(true);
            return;
        }

        const items = hardwareItemsRef.current;

        if (!items || items.length === 0) {
            // console.log('No hardware items for auto-play');
            return;
        }
        if (!overlayEnabled) {
            // console.log('Overlay not enabled');
            return;
        }
        if (isHoveringRef.current) {
            // console.log('Currently hovering');
            return;
        }

        const playItems = items.filter(item => item.categoryClasses?.length > 0);
        if (playItems.length === 0) {
            // console.log('No hardware items with category classes');
            return;
        }

        setIsOverlayLoadingBlocking(false);

        currentPlayItemsRef.current = playItems;

        if (autoPlayIntervalRef.current) clearInterval(autoPlayIntervalRef.current);
        if (hoverIntervalRef.current) clearInterval(hoverIntervalRef.current);

        autoPlayIndexRef.current = 0;
        setIsAutoPlaying(true);

        const showItem = (index) => {
            if (isHoveringRef.current || !overlayEnabled) return;

            const item = playItems[index];
            if (!item) return;

            const currentDisplayedItems = filteredItemsForAutoPlay.current;
            const displayedIndex = currentDisplayedItems.findIndex(displayedItem =>
                displayedItem.title === item.title
            );

            if (displayedIndex !== -1) {
                setHighlightedNumber(displayedIndex + 1);
            } else {
                setHighlightedNumber(null);
            }

            const firstClass = item.categoryClasses?.[0]?.cls || null;
            setHighlightedClass(firstClass);

            const imageList = buildImageList(item);
            if (imageList.length === 0) return;

            setSelectedMedia(imageList[0]);
            setMediaType('image');

            if (hoverIntervalRef.current) {
                clearInterval(hoverIntervalRef.current);
                hoverIntervalRef.current = null;
            }

            if (imageList.length > 1) {
                let imgIdx = 0;
                hoverIntervalRef.current = setInterval(() => {
                    if (isHoveringRef.current || !overlayEnabled) {
                        clearInterval(hoverIntervalRef.current);
                        hoverIntervalRef.current = null;
                        return;
                    }
                    imgIdx = (imgIdx + 1) % imageList.length;
                    setSelectedMedia(imageList[imgIdx]);
                    setMediaType('image');
                }, 1200);
            }
        };

        showItem(0);

        autoPlayIntervalRef.current = setInterval(() => {
            if (isHoveringRef.current || !overlayEnabled) return;
            autoPlayIndexRef.current = (autoPlayIndexRef.current + 1) % playItems.length;
            if (hoverIntervalRef.current) {
                clearInterval(hoverIntervalRef.current);
                hoverIntervalRef.current = null;
            }
            showItem(autoPlayIndexRef.current);
        }, 3000);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (hardwareItemsRef.current.length > 0 && !isAutoPlaying && overlayEnabled && activeTab === 'breakdown' && !isHoveringRef.current) {
                // startAutoPlay();
            }
        }, 200);
        return () => clearTimeout(timer);
    }, [report?.aiAnnotations, breakdownFilter]);

    useEffect(() => {
        if (!isLoadingOverlay && report?.aiAnnotations && overlayEnabled && activeTab === 'breakdown') {

            const timer = setTimeout(() => {
                if (!isHoveringRef.current && overlayEnabled && !isLoadingOverlay && hardwareItemsRef.current.length > 0) {

                    if (isOverlayLoadingBlocking || !isAutoPlaying) {
                        // startAutoPlay();
                    }
                }
            }, 500);
            return () => clearTimeout(timer);
        } else if (isLoadingOverlay) {

            if (isAutoPlaying) {
                stopAutoPlay(true);
            }
        }
    }, [isLoadingOverlay, overlayEnabled, activeTab, report?.aiAnnotations]);

    useEffect(() => {
        if (!overlayEnabled) {
            stopAutoPlay(true);
        }
    }, [overlayEnabled]);

    useEffect(() => {
        if (activeTab !== 'breakdown') {
            stopAutoPlay(true);
        } else if (activeTab === 'breakdown' && overlayEnabled && !isLoadingOverlay && !isAutoPlaying) {

            const timer = setTimeout(() => {
                if (!isHoveringRef.current && overlayEnabled && !isLoadingOverlay && hardwareItemsRef.current.length > 0) {
                    // startAutoPlay();
                }
            }, 600);
            return () => clearTimeout(timer);
        }
    }, [activeTab]);

    useEffect(() => {
        return () => {
            if (autoPlayIntervalRef.current) clearInterval(autoPlayIntervalRef.current);
            if (hoverIntervalRef.current) clearInterval(hoverIntervalRef.current);
        };
    }, []);

    const handleAIItemHover = (item) => {
        if (!item) return;

        setHighlightedNumber(item.num);

        let highlightClass = null;
        if (item.categoryClasses?.length > 0) {
            highlightClass = item.categoryClasses[0].cls;
        } else {
            highlightClass = getCategoryClass(item.title);
        }

        const imageList = buildImageList(item);
        if (imageList.length === 0) return;

        isHoveringRef.current = true;
        stopAutoPlay(false);

        if (highlightedClass === null) {
            previousMediaRef.current = selectedMedia;
            previousMediaTypeRef.current = mediaType;
        }

        setHighlightedClass(highlightClass);

        if (imageList.length === 1) {
            setSelectedMedia(imageList[0]);
            setMediaType('image');
            return;
        }

        hoverImageListRef.current = imageList;
        hoverCurrentIndexRef.current = 0;
        setSelectedMedia(imageList[0]);
        setMediaType('image');

        if (hoverIntervalRef.current) clearInterval(hoverIntervalRef.current);
        hoverIntervalRef.current = setInterval(() => {
            hoverCurrentIndexRef.current = (hoverCurrentIndexRef.current + 1) % imageList.length;
            setSelectedMedia(imageList[hoverCurrentIndexRef.current]);
            setMediaType('image');
        }, 2500);
    };


    const handleAIItemLeave = () => {
        isHoveringRef.current = false;
        if (hoverIntervalRef.current) {
            clearInterval(hoverIntervalRef.current);
            hoverIntervalRef.current = null;
        }
        setHighlightedClass(null);
        setHighlightedNumber(null);
        if (previousMediaRef.current) {
            setSelectedMedia(previousMediaRef.current);
            setMediaType(previousMediaTypeRef.current || 'image');
        }
        previousMediaRef.current = null;
        previousMediaTypeRef.current = null;
        if (overlayEnabled && activeTab === 'breakdown' && !isLoadingOverlay) {
            const timer = setTimeout(() => {
                if (!isHoveringRef.current && overlayEnabled && !isLoadingOverlay) {
                    // startAutoPlay();
                }
            }, 2000);
            return () => clearTimeout(timer);
        }
    };

    useEffect(() => {
        if (report?.doorPullPhotoLink && !selectedMedia) {
            setSelectedMedia(report.doorPullPhotoLink);
            setMediaType('image');
        }
    }, [report]);

    const handleMouseDown = (e) => {
        if (zoom <= 1) return;
        e.preventDefault();
        setIsDragging(true);
        setDragStart({
            x: e.clientX - pan.x,
            y: e.clientY - pan.y
        });
    };

    const handleMouseMoveDrag = (e) => {
        if (!isDragging || zoom <= 1) return;
        e.preventDefault();

        const newX = e.clientX - dragStart.x;
        const newY = e.clientY - dragStart.y;

        const maxPanX = (zoom - 1) * 300;
        const maxPanY = (zoom - 1) * 300;

        setPan({
            x: Math.max(-maxPanX, Math.min(maxPanX, newX)),
            y: Math.max(-maxPanY, Math.min(maxPanY, newY))
        });
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseLeaveImage = () => {
        setIsDragging(false);
    };

    const resetZoom = () => {
        setZoom(1);
        setPan({ x: 0, y: 0 });
        setIsDragging(false);
    };

    useEffect(() => {
        const handleGlobalMouseUp = () => {
            setIsDragging(false);
        };

        window.addEventListener('mouseup', handleGlobalMouseUp);
        return () => {
            window.removeEventListener('mouseup', handleGlobalMouseUp);
        };
    }, []);

    useEffect(() => {
        resetZoom();
    }, [selectedMedia]);


    const COLORS = {
        GREEN: [0, 255, 0],
        RED: [255, 0, 0],
        YELLOW: [255, 200, 0],
        GREY: [160, 160, 160],
        BLACK: [30, 30, 30]
    };

    const workNeededList = (doorReport) => {
        const raw = (doorReport?.workNeeded || "").trim();
        if (!raw) return [];
        return raw.split("|").map(e => e.trim()).filter(Boolean);
    };

    const workContains = (doorReport, items) => {
        const workList = workNeededList(doorReport);
        return items.some(i => workList.some(w => w.includes(i)));
    };

    const hasReplaceIn = (doorReport, items) => {
        const workList = workNeededList(doorReport);
        return items.some(i =>
            workList.some(w =>
                w.includes(i) && (w.toLowerCase().includes("replace") || w.toLowerCase().includes("install"))
            )
        );
    };

    const hasRepairIn = (doorReport, items) => {
        const workList = workNeededList(doorReport);
        const repairKeywords = ["repair", "adjust", "tighten", "refix"];
        return items.some(i =>
            workList.some(w =>
                w.includes(i) && repairKeywords.some(k => w.toLowerCase().includes(k))
            )
        );
    };

    const countCls = (doorReport, annotationId, cls) => {
        const annotations = doorReport?.aiAnnotations || [];
        const annotation = annotations.find(a => a.id === annotationId);
        if (!annotation?.regions) return 0;
        return annotation.regions.filter(r => r.cls === cls).length;
    };

    const hasCls = (doorReport, cls) => {
        return countCls(doorReport, "pushAiAnnotations", cls) > 0 ||
            countCls(doorReport, "pullAiAnnotations", cls) > 0;
    };

    const damageMultiple = (doorReport, prefix) => {
        const multiples = doorReport?.damageMultiples || [];
        for (const item of multiples) {
            if (String(item).toLowerCase().startsWith(prefix.toLowerCase())) {
                return String(item).substring(prefix.length).trim();
            }
        }
        return null;
    };

    const damageMultipleColor = (value) => {
        if (value === null) return COLORS.GREEN;
        const v = value.toLowerCase();
        if (v === "pass") return COLORS.GREEN;
        if (v === "none") return COLORS.GREY;
        if (v.includes("repair")) return COLORS.YELLOW;
        if (v.includes("replace") || v.includes("fail")) return COLORS.RED;
        return COLORS.GREY;
    };

    const DOOR_ITEMS = ["Replace Damaged Door", "Repair Damaged Door", "Replace Non-Compliant Door", "Other (Door)"];
    const FRAME_ITEMS = ["Repair Damaged Door Frame", "Replace damaged door frame", "Other (Frame)"];
    const GLASS_ITEMS = ["Replace Cracked Glass", "Replace Non-Compliant Glass", "Refix Loose Glazing Beads", "Replace Glazing Beads", "Other (Glass)"];
    const CLOSER_ITEMS = ["Repair Door Closer", "Adjust Door Closer", "Install New Door Closer", "Replace Door Closer"];
    const HINGE_ITEMS = ["Screws Missing From Hinge", "Tighten Hinge", "Install Third Fire Rated Hinge", "Replace Broken Hinge", "Replace Non-Compliant Hinge"];
    const LOCK_ITEMS = ["Replace Non-Compliant Locks"];
    const STRIP_ITEMS = ["Install Intumescent Strips", "Replace Damaged Intumescent Strip", "Replace Missing Intumescent Strip", "Intumescent Strip Installed Incorrectly"];

    const doorLabelColor = (doorReport) => {
        const depthStr = (doorReport?.doorDimDepth || "").trim();
        const depth = depthStr ? parseFloat(depthStr) : 0.0;
        const hasRepl = hasReplaceIn(doorReport, DOOR_ITEMS);
        const hasRep = hasRepairIn(doorReport, DOOR_ITEMS);
        if (hasRepl || depth < 44) return COLORS.RED;
        if (hasRep) return COLORS.YELLOW;
        const certif = (doorReport?.doorCertif || "").toUpperCase();
        if (["FD30", "FD60", "FD120"].some(fd => certif.includes(fd)) || depth >= 44) return COLORS.GREEN;
        return COLORS.RED;
    };

    const frameLabelColor = (doorReport) => {
        if (hasReplaceIn(doorReport, FRAME_ITEMS)) return COLORS.RED;
        if (hasRepairIn(doorReport, FRAME_ITEMS)) return COLORS.YELLOW;
        return COLORS.GREEN;
    };

    const glassLabelColor = (doorReport) => {
        const dm = damageMultiple(doorReport, "Glass");
        if (dm !== null) return damageMultipleColor(dm);
        const hasGlass = countCls(doorReport, "pushAiAnnotations", "glass") > 0 ||
            countCls(doorReport, "pullAiAnnotations", "glass") > 0 ||
            countCls(doorReport, "pullAiAnnotations", "safety_glass") > 0 ||
            Boolean((doorReport?.glassFireStampLink || "").trim());
        if (!hasGlass) return COLORS.GREY;
        if (hasReplaceIn(doorReport, GLASS_ITEMS)) return COLORS.RED;
        if (hasRepairIn(doorReport, GLASS_ITEMS)) return COLORS.YELLOW;
        return COLORS.GREEN;
    };

    const closerLabelColor = (doorReport) => {
        const hasCloserVal = hasCls(doorReport, "door_closer");
        const hasPerko = (doorReport?.closerType || "").toLowerCase().includes("perko");
        const closeAsIntended = doorReport?.doorCloseAsIntented;
        if (!hasCloserVal && !hasPerko && closeAsIntended === null) return COLORS.GREY;
        const workList = workNeededList(doorReport);
        const hasInstallReplace = CLOSER_ITEMS.some(i =>
            workList.some(w => w.includes(i) && (w.toLowerCase().includes("install") || w.toLowerCase().includes("replace")))
        );
        if (hasInstallReplace || (!hasCloserVal && !hasPerko)) return COLORS.RED;
        const hasAdjust = CLOSER_ITEMS.some(i =>
            workList.some(w => w.includes(i) && (w.toLowerCase().includes("adjust") || w.toLowerCase().includes("repair")))
        );
        if (hasAdjust || hasPerko) return COLORS.YELLOW;
        return COLORS.GREEN;
    };

    const hingeLabelColor = (doorReport) => {
        const missing = ["hingeAiAnnotations", "hinge2AiAnnotations", "hinge3AiAnnotations"].reduce((sum, id) => {
            const ann = (doorReport?.aiAnnotations || []).find(a => a.id === id);
            return sum + (ann?.regions || []).filter(r => r.cls === "missing").length;
        }, 0);
        const normal = ["hingeAiAnnotations", "hinge2AiAnnotations", "hinge3AiAnnotations"].reduce((sum, id) => {
            const ann = (doorReport?.aiAnnotations || []).find(a => a.id === id);
            return sum + (ann?.regions || []).filter(r => r.cls === "normal").length;
        }, 0);
        const photoCount = ["hingePhotoLink", "hingePhotoLink2", "hingePhotoLink3"].filter(k => {
            const val = (doorReport?.[k] || "").trim();
            return val !== "" && val !== "null";
        }).length;
        const expected = photoCount * 8;
        const hingesWorking = Boolean(doorReport?.hingesWorking);
        const doorHeight = parseFloat(doorReport?.doorDimHeight || 0);
        const hingeThreshold = doorHeight <= 1200 ? 2 : 3;
        const hasReplaceHinge = HINGE_ITEMS.some(i => {
            const workList = workNeededList(doorReport);
            return workList.some(w => w.includes(i) && (w.toLowerCase().includes("replace") || w.toLowerCase().includes("install")));
        });
        if (hasReplaceHinge) return COLORS.RED;
        if (!hingesWorking && (missing > 0 || normal < expected)) return COLORS.RED;
        if (workContains(doorReport, HINGE_ITEMS)) return COLORS.YELLOW;
        const push = countCls(doorReport, "pushAiAnnotations", "hinge");
        const pull = countCls(doorReport, "pullAiAnnotations", "hinge");
        if (Math.max(push, pull) >= hingeThreshold) return COLORS.GREEN;
        return COLORS.YELLOW;
    };

    const lockLabelColor = (doorReport, cls, side) => {
        if (cls === "yale_lock" && side === "push") return COLORS.YELLOW;
        if ((doorReport?.doorLocation || "").toLowerCase().includes("cupboard")) return COLORS.GREEN;
        const hasLock = ["keyless_exit", "yale_lock", "night_latch", "mortice_lock", "external_lock"].some(c => hasCls(doorReport, c));
        if (!hasLock) return COLORS.GREY;
        const hasKeyless = hasCls(doorReport, "keyless_exit");
        const hasNightLatch = hasCls(doorReport, "night_latch");
        const hasMortise = hasCls(doorReport, "mortice_lock");
        const isFlatFront = doorReport?.doorLocation === "Flat Front Door";
        if (hasKeyless) return COLORS.GREEN;
        if (isFlatFront && hasNightLatch) return COLORS.GREEN;
        if (hasMortise && !hasKeyless && !hasNightLatch) return COLORS.RED;
        if (hasNightLatch || hasMortise) return COLORS.YELLOW;
        return COLORS.RED;
    };

    const smokeLabelColor = (doorReport) => {
        const hasStrips = Boolean(doorReport?.doorStrips);
        const workList = workNeededList(doorReport);
        const hasInstall = STRIP_ITEMS.some(i =>
            workList.some(w => w.includes(i) && (w.toLowerCase().includes("replace") || w.toLowerCase().includes("install")))
        );
        if (!hasStrips || hasInstall) return COLORS.RED;
        if (workContains(doorReport, STRIP_ITEMS)) return COLORS.YELLOW;
        return COLORS.GREEN;
    };

    const gapLabelColor = (doorReport) => {
        const dm = damageMultiple(doorReport, "Ventilation Gaps");
        if (dm !== null) return damageMultipleColor(dm);
        const parse = (key) => { try { return parseFloat(doorReport?.[key] || ""); } catch { return null; } };
        const std = (v) => { if (v === null) return COLORS.RED; if (v >= 1 && v <= 4) return COLORS.GREEN; return COLORS.RED; };
        const bottom = (v) => { if (v === null) return COLORS.RED; if (v >= 1 && v <= 8) return COLORS.GREEN; return COLORS.RED; };
        const colors = [std(parse("fD3")), std(parse("fD1")), std(parse("fD2")), bottom(parse("fD4"))];
        if (colors.some(c => c === COLORS.RED)) return COLORS.RED;
        if (colors.some(c => c === COLORS.YELLOW)) return COLORS.YELLOW;
        return COLORS.GREEN;
    };

    const componentColor = (cls, doorReport, side) => {
        const LOCK_CLASSES = ["keyless_exit", "night_latch", "mortice_lock", "external_lock", "yale_lock", "code_lock", "emergency_lock", "padlock", "keep_locked", "bolt_latch"];
        const CLOSER_CLASSES = ["door_closer"];
        const HANDLE_CLASSES = ["door_handle", "pull_handle", "door_knob", "push_pad"];
        const ACCESSORY_CLASSES = ["door_number", "door_bell", "knocker", "spyhole", "letter_box", "signage"];
        const FIRE_CLASSES = ["fire_exit", "keep_clear"];
        const SEAL_CLASSES = ["drop_down_seal", "ventilation"];
        const DOOR_FRAME_CLASSES = ["door", "door_damage", "frame_damage", "door_latch"];

        if (cls === "hinge") return hingeLabelColor(doorReport);
        if (LOCK_CLASSES.includes(cls)) return lockLabelColor(doorReport, cls, side);
        if (CLOSER_CLASSES.includes(cls)) return closerLabelColor(doorReport);
        if (cls === "safety_glass" || cls === "glass") return glassLabelColor(doorReport);
        if (HANDLE_CLASSES.includes(cls)) return COLORS.GREEN;
        if (ACCESSORY_CLASSES.includes(cls)) return COLORS.GREEN;
        if (FIRE_CLASSES.includes(cls)) return COLORS.GREEN;
        if (SEAL_CLASSES.includes(cls)) return smokeLabelColor(doorReport);
        if (DOOR_FRAME_CLASSES.includes(cls)) return frameLabelColor(doorReport);
        return COLORS.GREEN;
    };

    const getClassCategory = (cls) => {

        if (['hinge'].includes(cls))
            return { number: 1, name: 'Hinges', color: [255, 80, 80] };

        if (['keyless_exit', 'yale_lock', 'night_latch', 'mortice_lock', 'external_lock', 'mortice_cover', 'code_lock', 'emergency_lock', 'padlock', 'keep_locked', 'bolt_latch'].includes(cls))
            return { number: 2, name: 'Locks & Security', color: [220, 80, 140] };

        if (['door_closer'].includes(cls))
            return { number: 3, name: 'Door Closer', color: [140, 0, 200] };

        if (['glass', 'safety_glass'].includes(cls))
            return { number: 4, name: 'Glazing', color: [60, 180, 220] };

        if (['door_handle', 'pull_handle', 'door_knob', 'push_pad'].includes(cls))
            return { number: 5, name: 'Handles & Push', color: [240, 120, 80] };

        if (['door_number', 'door_bell', 'knocker', 'spyhole', 'letter_box', 'signage'].includes(cls))
            return { number: 6, name: 'Door Accessories', color: [80, 120, 220] };

        if (['fire_exit', 'keep_clear', 'keep_locked', 'keep_shut'].includes(cls))
            return { number: 7, name: 'Fire & Signage', color: [0, 160, 160] };

        if (['drop_down_seal', 'ventilation'].includes(cls))
            return { number: 8, name: 'Seals & Ventilation', color: [240, 180, 40] };

        if (['door', 'door_damage', 'frame_damage', 'door_latch'].includes(cls))
            return { number: 9, name: 'Door & Frame', color: [140, 180, 80] };

        if (['normal', 'missing', 'reflection', 'screws'].includes(cls))
            return { number: 10, name: 'Hinge Screws', color: [255, 127, 80] };

        return { number: 0, name: 'Other', color: [120, 120, 120] };
    };

    const applyOverlayOnCanvas = (imageElement, regions, mode, doorReport, side, highlightClass = null) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = imageElement.naturalWidth;
        canvas.height = imageElement.naturalHeight;
        ctx.drawImage(imageElement, 0, 0);
        const imgW = canvas.width;
        const imgH = canvas.height;

        const numberColors = {
            1: [255, 60, 60],    // Red - Hinges
            2: [220, 60, 130],   // Pink - Locks
            3: [130, 0, 200],    // Purple - Closer
            4: [50, 170, 220],   // Cyan - Glazing
            5: [240, 120, 80],   // Salmon - Handles
            6: [80, 120, 220],   // Blue - Accessories
            7: [0, 160, 160],    // Teal - Fire & Signage
            8: [240, 180, 40],   // Gold - Seals
            9: [140, 180, 80],   // Olive - Door & Frame
            10: [0, 200, 100],   // Green - Normal Screws
            11: [255, 50, 50],   // Bright Red - Missing Screws
            12: [255, 180, 0],   // Orange - Reflection
            13: [255, 100, 0],   // Dark Orange - Loose Screws
            0: [120, 120, 120],  // Grey - Other
        };

        const categoryMap = {
            hinges: { number: 1, classes: ['hinge'] },
            locks: { number: 2, classes: ['keyless_exit', 'yale_lock', 'night_latch', 'mortice_lock', 'external_lock', 'mortice_cover', 'code_lock', 'emergency_lock', 'padlock', 'bolt_latch'] },
            closer: { number: 3, classes: ['door_closer'] },
            glazing: { number: 4, classes: ['glass', 'safety_glass'] },
            handles: { number: 5, classes: ['door_handle', 'pull_handle', 'door_knob', 'push_pad'] },
            accessories: { number: 6, classes: ['door_number', 'door_bell', 'knocker', 'spyhole', 'letter_box', 'signage'] },
            fireSafety: { number: 7, classes: ['fire_exit', 'keep_clear', 'keep_locked', 'keep_shut'] },
            seals: { number: 8, classes: ['drop_down_seal', 'ventilation'] },
            doorFrame: { number: 9, classes: ['door', 'door_damage', 'frame_damage', 'door_latch'] },

            screwNormal: { number: 10, classes: ['normal'], name: 'Normal Screws' },
            screwMissing: { number: 11, classes: ['missing'], name: 'Missing Screws' },
            screwReflection: { number: 12, classes: ['reflection'], name: 'Reflection' },
            screwLoose: { number: 13, classes: ['loose'], name: 'Loose Screws' },
        };

        const classNames = {
            'hinge': 'Hinge',
            'keyless_exit': 'Keyless Exit', 'yale_lock': 'Yale Lock', 'night_latch': 'Night Latch',
            'mortice_lock': 'Mortice Lock', 'external_lock': 'External Lock', 'mortice_cover': 'Mortice Cover',
            'code_lock': 'Code Lock', 'emergency_lock': 'Emergency Lock', 'padlock': 'Pad Lock',
            'keep_shut': 'Keep Shut', 'keep_locked': 'Keep Locked', 'bolt_latch': 'Bolt Latch',
            'door_closer': 'Door Closer',
            'glass': 'Glass', 'safety_glass': 'Safety Glass',
            'door_handle': 'Door Handle', 'pull_handle': 'Pull Handle', 'door_knob': 'Door Knob', 'push_pad': 'Push Pad',
            'door_number': 'Door Number', 'door_bell': 'Door Bell', 'knocker': 'Knocker',
            'spyhole': 'Spy Hole', 'letter_box': 'Letter Box', 'signage': 'Signage',
            'fire_exit': 'Fire Exit', 'keep_clear': 'Keep Clear',
            'drop_down_seal': 'Drop Down Seal', 'ventilation': 'Ventilation',
            'door': 'Door', 'door_damage': 'Door Damage', 'frame_damage': 'Frame Damage', 'door_latch': 'Door Latch',
            'normal': 'Normal', 'missing': 'Missing', 'reflection': 'Reflection', 'loose': 'Loose',
        };
        const getCategoryForClass = (cls) => {
            for (const cat of Object.values(categoryMap)) {
                if (cat.classes.includes(cls)) return cat;
            }
            return null;
        };

        let regionsToDraw = regions;
        if (highlightClass) {
            const cat = getCategoryForClass(highlightClass);
            if (cat) regionsToDraw = regions.filter(r => cat.classes.includes(r.cls));
            else regionsToDraw = regions.filter(r => r.cls === highlightClass);
        }

        const isHighlight = highlightClass !== null;

        const defaultFontSize = 28;
        const highlightFontSize = 38;
        const defaultBadgeH = 60;
        const highlightBadgeH = 80;
        const fontSize = isHighlight ? highlightFontSize : defaultFontSize;
        const badgeH = isHighlight ? highlightBadgeH : defaultBadgeH;
        const paddingX = isHighlight ? 42 : 32;
        const radius = isHighlight ? 20 : 10;
        const lineWidth = isHighlight ? 10 : 5;
        const shadowBlur = isHighlight ? 20 : 10;

        regionsToDraw.forEach((region) => {
            const cls = region.cls;
            const cat = getCategoryForClass(cls);
            if (!cat) return;
            const color = numberColors[cat.number] || [120, 120, 120];
            const name = classNames[cls] || cls.substring(0, 6);
            const [r, g, b] = color;
            let x1, y1, x2, y2;

            if (region.pointsX && region.pointsY) {
                ctx.beginPath();
                let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
                for (let i = 0; i < region.pointsX.length; i++) {
                    const px = region.pointsX[i] * imgW;
                    const py = region.pointsY[i] * imgH;
                    if (i === 0) ctx.moveTo(px, py);
                    else ctx.lineTo(px, py);
                    if (px < minX) minX = px; if (px > maxX) maxX = px;
                    if (py < minY) minY = py; if (py > maxY) maxY = py;
                }
                ctx.closePath();
                ctx.fillStyle = `rgba(${r},${g},${b},${isHighlight ? 0.5 : 0.25})`;
                ctx.fill();
                ctx.strokeStyle = `rgb(${r},${g},${b})`;
                ctx.lineWidth = lineWidth;
                ctx.shadowColor = isHighlight ? `rgba(${r},${g},${b},0.8)` : 'transparent';
                ctx.shadowBlur = shadowBlur;
                ctx.stroke();
                ctx.shadowColor = 'transparent';
                ctx.shadowBlur = 0;
                x1 = minX; y1 = minY; x2 = maxX; y2 = maxY;
            } else {
                x1 = (region.x || 0) * imgW;
                y1 = (region.y || 0) * imgH;
                x2 = ((region.x || 0) + (region.w || 0)) * imgW;
                y2 = ((region.y || 0) + (region.h || 0)) * imgH;
                ctx.fillStyle = `rgba(${r},${g},${b},${isHighlight ? 0.5 : 0.25})`;
                ctx.fillRect(x1, y1, x2 - x1, y2 - y1);
                ctx.strokeStyle = `rgb(${r},${g},${b})`;
                ctx.lineWidth = lineWidth;
                ctx.shadowColor = isHighlight ? `rgba(${r},${g},${b},0.8)` : 'transparent';
                ctx.shadowBlur = shadowBlur;
                ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);
                ctx.shadowColor = 'transparent';
                ctx.shadowBlur = 0;
            }

            const labelText = name;
            ctx.font = `bold ${fontSize}px Arial`;
            const tw = ctx.measureText(labelText).width;
            const bw = tw + paddingX;
            let bx = (x1 + x2) / 2 - bw / 2;
            let by = y1 - badgeH - (isHighlight ? 10 : 6);
            if (by < 4) by = y2 + 4;
            if (bx < 2) bx = 2;
            if (bx + bw > imgW - 2) bx = imgW - bw - 2;

            ctx.beginPath();
            ctx.moveTo(bx + radius, by);
            ctx.lineTo(bx + bw - radius, by);
            ctx.quadraticCurveTo(bx + bw, by, bx + bw, by + radius);
            ctx.lineTo(bx + bw, by + badgeH - radius);
            ctx.quadraticCurveTo(bx + bw, by + badgeH, bx + bw - radius, by + badgeH);
            ctx.lineTo(bx + radius, by + badgeH);
            ctx.quadraticCurveTo(bx, by + badgeH, bx, by + badgeH - radius);
            ctx.lineTo(bx, by + radius);
            ctx.quadraticCurveTo(bx, by, bx + radius, by);
            ctx.closePath();

            ctx.shadowColor = isHighlight ? 'rgba(0,0,0,0.7)' : 'rgba(0,0,0,0.4)';
            ctx.shadowBlur = isHighlight ? 14 : 6;
            ctx.fillStyle = `rgb(${r},${g},${b})`;
            ctx.fill();
            ctx.shadowColor = 'transparent';
            ctx.shadowBlur = 0;

            ctx.strokeStyle = 'white';
            ctx.lineWidth = isHighlight ? 4 : 2;
            ctx.stroke();

            ctx.fillStyle = 'white';
            ctx.font = `bold ${fontSize}px Arial`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(labelText, bx + bw / 2, by + badgeH / 2);
        });

        return canvas.toDataURL('image/png');
    };

    const generateAllOverlays = useCallback(async () => {
        if (!report?.aiAnnotations?.length || !overlayEnabled) return;
        setIsLoadingOverlay(true);
        const overlays = {};
        const cache = {};

        const imageMap = [
            { key: "doorPullPhotoLink", annotationId: "pullAiAnnotations", side: "pull" },
            { key: "doorPushPhotoLink", annotationId: "pushAiAnnotations", side: "push" },
            { key: "hingePhotoLink", annotationId: "hingeAiAnnotations", side: null, mode: "hinge" },
            { key: "hingePhotoLink2", annotationId: "hinge2AiAnnotations", side: null, mode: "hinge" },
            { key: "hingePhotoLink3", annotationId: "hinge3AiAnnotations", side: null, mode: "hinge" },
        ];

        for (const item of imageMap) {
            if (!report[item.key]) continue;
            const annotation = report.aiAnnotations.find(a => a.id === item.annotationId);
            const regions = annotation?.regions || [];
            if (!regions.length) { overlays[item.key] = report[item.key]; continue; }
            try {
                const img = await new Promise((resolve, reject) => {
                    const image = new Image();
                    image.crossOrigin = "anonymous";
                    image.onload = () => resolve(image);
                    image.onerror = reject;
                    image.src = report[item.key];
                });
                const baseOverlay = applyOverlayOnCanvas(img, regions, item.mode || 'door', report, item.side, null);
                cache[item.key] = { base: baseOverlay, image: img, regions, mode: item.mode || 'door', side: item.side };
                overlays[item.key] = baseOverlay;
            } catch (e) {
                overlays[item.key] = report[item.key];
            }
        }
        overlayCacheRef.current = cache;
        setOverlaidImages(overlays);
        setIsLoadingOverlay(false);
    }, [report, overlayEnabled]);

    const getHighlightedOverlay = useCallback((key, highlightClass) => {
        const cached = overlayCacheRef.current[key];
        if (!cached || !highlightClass) return cached?.base || null;
        return applyOverlayOnCanvas(cached.image, cached.regions, cached.mode, report, cached.side, highlightClass);
    }, [report]);

    useEffect(() => {
        if (!overlayEnabled || Object.keys(overlayCacheRef.current).length === 0) return;
        const updatedOverlays = {};
        Object.keys(overlayCacheRef.current).forEach(key => {
            updatedOverlays[key] = highlightedClass ? getHighlightedOverlay(key, highlightedClass) : overlayCacheRef.current[key].base;
        });
        setOverlaidImages(updatedOverlays);
    }, [highlightedClass, overlayEnabled, getHighlightedOverlay]);

    useEffect(() => {
        if (!report?.hasAccess) return;
        if (report?.aiAnnotations && overlayEnabled) generateAllOverlays();
    }, [report?.aiAnnotations, overlayEnabled, generateAllOverlays]);


    // 

    const getDisplayUrl = (originalUrl, key) => overlayEnabled && overlaidImages[key] ? overlaidImages[key] : originalUrl;

    const getSelectedMediaUrl = () => {
        if (!selectedMedia || !overlayEnabled) return selectedMedia;
        if (selectedMedia === report?.doorPullPhotoLink) return getDisplayUrl(report.doorPullPhotoLink, "doorPullPhotoLink");
        if (selectedMedia === report?.doorPushPhotoLink) return getDisplayUrl(report.doorPushPhotoLink, "doorPushPhotoLink");
        if (selectedMedia === report?.hingePhotoLink) return getDisplayUrl(report.hingePhotoLink, "hingePhotoLink");
        if (selectedMedia === report?.hingePhotoLink2) return getDisplayUrl(report.hingePhotoLink2, "hingePhotoLink2");
        if (selectedMedia === report?.hingePhotoLink3) return getDisplayUrl(report.hingePhotoLink3, "hingePhotoLink3");

        return selectedMedia;
    };

    const getAIItems = useCallback(() => {
        const pullRegions = report?.aiAnnotations?.find(a => a.id === 'pullAiAnnotations')?.regions || [];
        const pushRegions = report?.aiAnnotations?.find(a => a.id === 'pushAiAnnotations')?.regions || [];
        const hinge1Regions = report?.aiAnnotations?.find(a => a.id === 'hingeAiAnnotations')?.regions || [];
        const hinge2Regions = report?.aiAnnotations?.find(a => a.id === 'hinge2AiAnnotations')?.regions || [];
        const hinge3Regions = report?.aiAnnotations?.find(a => a.id === 'hinge3AiAnnotations')?.regions || [];

        const allRegions = [...pullRegions, ...pushRegions, ...hinge1Regions, ...hinge2Regions, ...hinge3Regions];
        const detectedClasses = [...new Set(allRegions.map(r => r.cls))];
        const categorized = {};
        const rgbToHex = (c) => c ? `#${c.map(v => v.toString(16).padStart(2, '0')).join('')}` : '#6c757d';

        detectedClasses.forEach(cls => {
            const category = getClassCategory(cls);
            if (category && category.number > 0) {
                if (!categorized[category.number]) {
                    categorized[category.number] = {
                        ...category,
                        classes: [],
                        totalCount: 0,
                        pullCount: 0,
                        pushCount: 0,
                        hinge1Count: 0,
                        hinge2Count: 0,
                        hinge3Count: 0
                    };
                }
                const count = allRegions.filter(r => r.cls === cls).length;
                const pullC = pullRegions.filter(r => r.cls === cls).length;
                const pushC = pushRegions.filter(r => r.cls === cls).length;
                const h1C = hinge1Regions.filter(r => r.cls === cls).length;
                const h2C = hinge2Regions.filter(r => r.cls === cls).length;
                const h3C = hinge3Regions.filter(r => r.cls === cls).length;

                categorized[category.number].classes.push({
                    cls, count, pullCount: pullC, pushCount: pushC,
                    hinge1Count: h1C, hinge2Count: h2C, hinge3Count: h3C
                });
                categorized[category.number].totalCount += count;
                categorized[category.number].pullCount += pullC;
                categorized[category.number].pushCount += pushC;
                categorized[category.number].hinge1Count += h1C;
                categorized[category.number].hinge2Count += h2C;
                categorized[category.number].hinge3Count += h3C;
            }
        });

        const items = [];

        const mainCategories = [
            { number: 1, name: 'Hinges', color: [255, 80, 80], classes: ['hinge'] },
            { number: 2, name: 'Locks & Security', color: [220, 80, 140], classes: ['keyless_exit', 'yale_lock', 'night_latch', 'mortice_lock', 'external_lock', 'mortice_cover', 'code_lock', 'emergency_lock', 'padlock', 'keep_locked', 'bolt_latch'] },
            { number: 3, name: 'Door Closer', color: [140, 0, 200], classes: ['door_closer'] },
            { number: 4, name: 'Glazing', color: [60, 180, 220], classes: ['glass', 'safety_glass'] },
            { number: 5, name: 'Handles & Push', color: [240, 120, 80], classes: ['door_handle', 'pull_handle', 'door_knob', 'push_pad'] },
            { number: 6, name: 'Door Accessories', color: [80, 120, 220], classes: ['door_number', 'door_bell', 'knocker', 'spyhole', 'letter_box', 'signage'] },
            { number: 7, name: 'Fire & Signage', color: [0, 160, 160], classes: ['fire_exit', 'keep_clear', 'keep_locked', 'keep_shut'] },
            { number: 8, name: 'Seals & Ventilation', color: [240, 180, 40], classes: ['drop_down_seal', 'ventilation'] },
            { number: 9, name: 'Door & Frame', color: [140, 180, 80], classes: ['door', 'door_damage', 'frame_damage', 'door_latch'] },
            // { number: 10, name: 'Hinge Screws', color: [255, 127, 80], classes: ['normal', 'missing', 'reflection', 'screws'] },
        ];

        mainCategories.forEach(cat => {
            const existing = categorized[cat.number];
            const count = existing ? existing.totalCount : 0;

            let sub = '';
            if (existing) {
                sub = `${count} total`;
                if (existing.pullCount > 0 || existing.pushCount > 0) {
                    sub += ` (Pull:${existing.pullCount} Push:${existing.pushCount})`;
                }
                if (existing.hinge1Count > 0 || existing.hinge2Count > 0 || existing.hinge3Count > 0) {
                    sub += ` (H1:${existing.hinge1Count} H2:${existing.hinge2Count} H3:${existing.hinge3Count})`;
                }
            } else {
                sub = 'Not detected';
            }

            items.push({
                num: cat.number,
                bg: rgbToHex(cat.color),
                title: cat.name,
                sub: sub,
                status: existing ? 'PASS' : cat.number <= 4 ? 'CHECK' : 'INFO',
                statusClass: existing ? 'bg-success text-white' : cat.number <= 4 ? 'bg-warning text-dark' : 'bg-secondary text-white',
                categoryClasses: existing?.classes || cat.classes.map(c => ({ cls: c, count: 0, pullCount: 0, pushCount: 0 })),
                pullCount: existing?.pullCount || 0,
                pushCount: existing?.pushCount || 0,
                hinge1Count: existing?.hinge1Count || 0,
                hinge2Count: existing?.hinge2Count || 0,
                hinge3Count: existing?.hinge3Count || 0,
            });
        });

        const damageMultiples = report?.damageMultiples || [];
        let n = items.length;

        const frameDM = damageMultiples.find(d => String(d).toLowerCase().startsWith('frame'));
        n++;
        items.push({
            num: n,
            bg: rgbToHex(frameDM ? (String(frameDM).toLowerCase().includes('fail') ? [220, 50, 50] : [40, 180, 80]) : [40, 180, 80]),
            title: 'Frame Condition',
            sub: frameDM ? String(frameDM).replace(/^frame\s*/i, '') : 'Passed',
            status: frameDM && String(frameDM).toLowerCase().includes('fail') ? 'FAIL' : 'PASS',
            statusClass: frameDM && String(frameDM).toLowerCase().includes('fail') ? 'bg-danger text-white' : 'bg-success text-white',
            categoryClasses: [{ cls: 'frame_damage', count: frameDM ? 1 : 0, pullCount: 0, pushCount: 0 }],
            pullCount: 0,
            pushCount: 0,
            showImage: 'push'
        });

        const doorDM = damageMultiples.find(d => String(d).toLowerCase().startsWith('door') && !String(d).toLowerCase().includes('frame'));
        n++;
        items.push({
            num: n,
            bg: rgbToHex(doorDM ? (String(doorDM).toLowerCase().includes('fail') ? [220, 50, 50] : [40, 180, 80]) : [40, 180, 80]),
            title: 'Door Condition',
            sub: doorDM ? String(doorDM).replace(/^door\s*/i, '') : 'Passed',
            status: doorDM && String(doorDM).toLowerCase().includes('fail') ? 'FAIL' : 'PASS',
            statusClass: doorDM && String(doorDM).toLowerCase().includes('fail') ? 'bg-danger text-white' : 'bg-success text-white',
            categoryClasses: [{ cls: 'door', count: doorDM ? 1 : 0, pullCount: 0, pushCount: 0 }],
            pullCount: 0,
            pushCount: 0,
            showImage: 'push'
        });

        const glassDM = damageMultiples.find(d => String(d).toLowerCase().startsWith('glass'));
        n++;
        items.push({
            num: n,
            bg: rgbToHex(glassDM ? (String(glassDM).toLowerCase().includes('fail') ? [220, 50, 50] : [40, 180, 80]) : [40, 180, 80]),
            title: 'Glass Condition',
            sub: glassDM ? String(glassDM).replace(/^glass\s*/i, '') : 'Passed',
            status: glassDM && String(glassDM).toLowerCase().includes('fail') ? 'FAIL' : 'PASS',
            statusClass: glassDM && String(glassDM).toLowerCase().includes('fail') ? 'bg-danger text-white' : 'bg-success text-white',
            categoryClasses: [{ cls: 'glass', count: glassDM ? 1 : 0, pullCount: 0, pushCount: 0 }],
            pullCount: 0,
            pushCount: 0,
            showImage: 'push'
        });

        const sealDM = damageMultiples.find(d => String(d).toLowerCase().includes('ventilation') || String(d).toLowerCase().includes('seal'));
        n++;
        items.push({
            num: n,
            bg: rgbToHex(sealDM ? (String(sealDM).toLowerCase().includes('fail') ? [220, 50, 50] : [40, 180, 80]) : [160, 160, 160]),
            title: 'Sealing Condition',
            sub: sealDM ? String(sealDM).replace(/^ventilation\s*/i, '').replace(/^seal\s*/i, '') : 'None',
            status: sealDM ? (String(sealDM).toLowerCase().includes('fail') ? 'FAIL' : 'PASS') : 'N/A',
            statusClass: sealDM ? (String(sealDM).toLowerCase().includes('fail') ? 'bg-danger text-white' : 'bg-success text-white') : 'bg-secondary text-white',
            categoryClasses: [{ cls: 'drop_down_seal', count: sealDM ? 1 : 0, pullCount: 0, pushCount: 0 }],
            pullCount: 0,
            pushCount: 0,
            showImage: 'push'
        });

        const getGapStatus = (val, type) => {
            if (val === null || val === undefined) return { text: 'N/A', class: 'bg-secondary text-white' };
            if (type === 'bottom') return (val >= 1 && val <= 8) ? { text: 'PASS', class: 'bg-success text-white' } : { text: 'FAIL', class: 'bg-danger text-white' };
            return (val >= 1 && val <= 4) ? { text: 'PASS', class: 'bg-success text-white' } : { text: 'FAIL', class: 'bg-danger text-white' };
        };

        const gapColors = { top: [240, 120, 80], lock: [80, 120, 220], hinge: [0, 160, 160], bottom: [180, 100, 40] };

        n++;
        items.push({ num: n, bg: rgbToHex(gapColors.top), title: 'Top Side Gap', sub: report?.fD3 != null ? `${report.fD3} mm` : 'N/A', status: getGapStatus(parseFloat(report?.fD3), 'top').text, statusClass: getGapStatus(parseFloat(report?.fD3), 'top').class });
        n++;
        items.push({ num: n, bg: rgbToHex(gapColors.lock), title: 'Lock Side Gap', sub: report?.fD1 != null ? `${report.fD1} mm` : 'N/A', status: getGapStatus(parseFloat(report?.fD1), 'side').text, statusClass: getGapStatus(parseFloat(report?.fD1), 'side').class });
        n++;
        items.push({ num: n, bg: rgbToHex(gapColors.hinge), title: 'Hinge Side Gap', sub: report?.fD2 != null ? `${report.fD2} mm` : 'N/A', status: getGapStatus(parseFloat(report?.fD2), 'side').text, statusClass: getGapStatus(parseFloat(report?.fD2), 'side').class });
        n++;
        items.push({ num: n, bg: rgbToHex(gapColors.bottom), title: 'Bottom Side Gap', sub: report?.fD4 != null ? `${report.fD4} mm` : 'N/A', status: getGapStatus(parseFloat(report?.fD4), 'bottom').text, statusClass: getGapStatus(parseFloat(report?.fD4), 'bottom').class });

        n++;
        items.push({ num: n, bg: rgbToHex([240, 180, 40]), title: 'Intumescent Seals', sub: report?.doorStrips ? 'Present' : 'Missing', status: report?.doorStrips ? 'PASS' : 'FAIL', statusClass: report?.doorStrips ? 'bg-success text-white' : 'bg-danger text-white' });

        return items;
    }, [report]);

    const scrollUp = () => { if (thumbRef.current) { thumbRef.current.scrollBy({ top: -100, behavior: 'smooth' }); setTimeout(checkScrollButtons, 150); } };
    const scrollDown = () => { if (thumbRef.current) { thumbRef.current.scrollBy({ top: 100, behavior: 'smooth' }); setTimeout(checkScrollButtons, 150); } };
    const checkScrollButtons = () => {
        if (thumbRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = thumbRef.current;
            setCanScrollUp(scrollTop > 0);
            setCanScrollDown(scrollTop + clientHeight < scrollHeight - 1);
        }
    };

    useEffect(() => {
        checkScrollButtons();
        const thumbElement = thumbRef.current;
        if (thumbElement) {
            thumbElement.addEventListener('scroll', checkScrollButtons);
            window.addEventListener('resize', checkScrollButtons);
            return () => { thumbElement.removeEventListener('scroll', checkScrollButtons); window.removeEventListener('resize', checkScrollButtons); };
        }
    }, [report]);

    useEffect(() => {
        const checkHorizontalScroll = () => {
            if (thumbRef.current && window.innerWidth < 992) {
                const { scrollWidth, clientWidth, scrollLeft } = thumbRef.current;
                setCanScrollLeft(scrollLeft > 0);
                setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
            }
        };

        checkHorizontalScroll();
        const thumbElement = thumbRef.current;
        if (thumbElement) {
            thumbElement.addEventListener('scroll', checkHorizontalScroll);
            window.addEventListener('resize', checkHorizontalScroll);
            return () => {
                thumbElement.removeEventListener('scroll', checkHorizontalScroll);
                window.removeEventListener('resize', checkHorizontalScroll);
            };
        }
    }, [report]);

    const [activeKey2, setactiveKey2] = useState(null);
    const [activeKey3, setactiveKey3] = useState(null);
    const [activeKey4, setactiveKey4] = useState(null);

    const toastId = useRef(null);

    const [reportViewTab, setReportViewTab] = useState('general');
    const mobileImageGestureRef = useRef({
        mode: null,
        startDistance: 0,
        startZoom: 1,
        startPan: { x: 0, y: 0 },
        startMidpoint: { x: 0, y: 0 },
        startTouch: { x: 0, y: 0 },
    });

    const [message, setMessage] = useState("");
    const [photo, setPhoto] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [showModalDelImage, setShowModalDelImage] = useState(false);
    const [showClearModal, setShowClearModal] = useState(false); const storage = getStorage();
    const [fileName, setFileName] = useState("");
    const [fileNames, setFileNames] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [showPinModal, setShowPinModal] = useState(false);
    const [pin, setPin] = useState("");
    const [showVideo, setShowVideo] = useState(false);
    const [showNoAccessModal, setShowNoAccessModal] = useState(false);
    const [showRequiresReviewModal, setRequiresReviewModal] = useState(false);

    const [foundReportUid, setFoundReportUid] = useState("");

    const [editedPrices, setEditedPrices] = useState({});
    const [editedLaborCost, setEditedLaborCost] = useState("");
    const [editedIncludeVAT, setEditedIncludeVAT] = useState(false);
    const [editedIncludeManagementFee, setEditedIncludeManagementFee] = useState(false);

    const [laborCost, setLaborCost] = useState("");
    const [includeVAT, setIncludeVAT] = useState(false);
    const [includeManagementFee, setIncludeManagementFee] = useState(false);
    const [showWorkEditModal, setShowWorkEditModal] = useState(false);

    const [showDetailsModal, setShowDetailsModal] = useState(false);

    const [showCameraModal, setShowCameraModal] = useState(false);
    const [countdown, setCountdown] = useState(30);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const countdownIntervalRef = useRef(null);
    const [photo1, setPhoto1] = useState(null);
    const [photo2, setPhoto2] = useState(null);
    const [photo3, setPhoto3] = useState(null);
    const [photo4, setPhoto4] = useState(null);
    const [lastVideoUrl, setLastVideoUrl] = useState(null);
    const recordingCancelledRef = useRef(false);

    const [reportDocId, setReportDocId] = useState("");
    const [storagePath, setStoragePath] = useState("");
    const formRef = useRef(null);

    const [doorHistory, setDoorHistory] = useState([]);

    const [showEstimateModal, setShowEstimateModal] = useState(false);
    const [selectedDoor, setSelectedDoor] = useState(null);

    const [selectedImage, setSelectedImage] = useState(null);
    const fileInputRef = useRef(null);
    const [inspectionChanged, setInspectionChanged] = useState(null);

    function formatDate(raw) {
        if (!raw) return "Unknown date";

        if (/[a-zA-Z]/.test(raw)) return raw;

        const m = raw.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})$/);
        if (m) {
            const [_, d, mo, y] = m;
            const year = y.length === 2 ? "20" + y : y;
            const iso = `${year}-${mo.padStart(2, "0")}-${d.padStart(2, "0")}`;
            const dt = new Date(iso);
            return !isNaN(dt) ? dt.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : raw;
        }

        const dt = new Date(raw);
        if (!isNaN(dt)) {
            return dt.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
        }

        return typeof raw === "string" ? raw : "Unknown date";
    }

    const [fade, setFade] = React.useState(false);

    const [selectedIndexPhoto, setSelectedIndexPhoto] = React.useState(
        doorHistory.length > 0 ? doorHistory.length - 1 : 0
    );

    const handleSwitch = (i) => {
        setFade(true);
        setTimeout(() => {
            setSelectedIndex(i);
            setFade(false);
        }, 250);
    };



    const [showTenantModal, setShowTenantModal] = useState(false);
    const [tenant, setTenant] = useState({
        name: "",
        phone: "",
        email: "",
        address: "",
        moveInDate: "",
        notes: ""
    });

    const handleShow = () => setShowTenantModal(true);
    const handleClose = () => setShowTenantModal(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTenant({ ...tenant, [name]: value });
    };

    useEffect(() => {
        const loadTenantData = async () => {
            if (!doorId) return;

            const reportUid =
                foundReportUid && foundReportUid.trim() !== "" ? foundReportUid : uid;

            if (!reportUid) {
                console.error("Missing reportUid");
                return;
            }

            setLoading(true);
            try {
                const tenantRef = doc(
                    db,
                    `Reports/${reportUid}/ResidentialReports/${doorId}/tenant/${doorId}`
                );

                const snapshot = await getDoc(tenantRef);
                if (snapshot.exists()) {
                    setTenant(snapshot.data());
                } else {
                    // console.log("No tenant data found for this door yet.");
                    setTenant({
                        name: "",
                        phone: "",
                        email: "",
                        moveInDate: "",
                        address: "",
                        notes: "",
                    });
                }
            } catch (error) {
                console.error("Error loading tenant details:", error);
            }
            finally {
                setLoading(false);
            }
        };

        if (showTenantModal) {
            loadTenantData();
        }
    }, [showTenantModal, doorId, foundReportUid, uid]);

    const handleSave = async () => {
        const reportUid =
            foundReportUid && foundReportUid.trim() !== "" ? foundReportUid : uid;

        setLoading(true);
        try {
            if (!reportUid || !doorId) {
                console.error("Missing reportUid or doorId");
                return;
            }

            const tenantRef = doc(
                db,
                `Reports/${reportUid}/ResidentialReports/${doorId}/tenant/${doorId}`
            );

            await setDoc(tenantRef, tenant, { merge: true });

            handleClose();
        } catch (error) {
            console.error("Error saving tenant details:", error);
        } finally {
            setLoading(false);
        }
    };


    const handleOpenModal = () => {
        setShowPinModal(true);
    };

    const predefinedOptions = {
        // doorCertification: ["Replace non-Certified Door", "Internal Door Inspection"],
        // doorCloseAsIntented: ["Repair door closer", "Adjust door closer", "Install new door closer", "Replace door closer"],
        // doorStrips: ["Install intumescent strips", "Replace damaged intumescent strip", "Replace missing intumescent strip", "Intumescent strip installed incorrectly"],
        // hingesWorking: ["Screws missing from hinge", "Tighten hinge", "Replace broken hinge"],
        // hingesFireRating: ["Replace non-compliant hinge"],
        // door: ["Replace damaged door", "Repair damaged door", "Replace non-compliant door"],
        // frame: ["Repair damaged door frame"],
        // glass: ["Replace cracked glass", "Replace non-compliant glass", "Refix loose glazing beads", "Replace glazing beads"],
        // ventilation: ["Clear blocked ventilation gaps", "Install additional gaps if needed"],
        // gaps: ["Adjust Gap - Lock", "Adjust Gap - Hinge", "Adjust Gap - Top", "Adjust Gap - Bottom"],
    };
    const [prices, setPrices] = useState({});

    const riskPriority = {
        "Fire Safety Risk": 1,
        "Gaps": 2,
        "Maintenance Issue": 3
    };

    const workItemDisplayLabels = {
        "adjust gap - lock": "Adjust Gap - Lock Side",
        "adjust gap - hinge": "Adjust Gap - Hinge Side",
        "adjust gap - top": "Adjust Gap - Top Side",
        "adjust gap - bottom": "Adjust Gap - Bottom Side",
    };

    const prioritizedOptions = {
        "replace non-certified door": { risk: "Fire Safety Risk" },
        "internal door inspection": { risk: "Fire Safety Risk" },
        "repair door closer": { risk: "Maintenance Issue" },
        "adjust door closer": { risk: "Maintenance Issue" },
        "install new door closer": { risk: "Maintenance Issue" },
        "replace door closer": { risk: "Maintenance Issue" },
        "install intumescent strips": { risk: "Fire Safety Risk" },
        "replace damaged intumescent strip": { risk: "Fire Safety Risk" },
        "replace missing intumescent strip": { risk: "Fire Safety Risk" },
        "intumescent strip installed incorrectly": { risk: "Fire Safety Risk" },
        "screws missing from hinge": { risk: "Gaps" },
        "tighten hinge": { risk: "Maintenance Issue" },
        "replace broken hinge": { risk: "Maintenance Issue" },
        "replace non-compliant hinge": { risk: "Fire Safety Risk" },
        "replace damaged door": { risk: "Maintenance Issue" },
        "repair damaged door": { risk: "Maintenance Issue" },
        "replace non-compliant door": { risk: "Fire Safety Risk" },
        "repair damaged door frame": { risk: "Maintenance Issue" },
        "replace damaged door frame": { risk: "Maintenance Issue" },
        "replace cracked glass": { risk: "Fire Safety Risk" },
        "replace non-compliant glass": { risk: "Fire Safety Risk" },
        "refix loose glazing beads": { risk: "Maintenance Issue" },
        "replace glazing beads": { risk: "Maintenance Issue" },
        "clear blocked ventilation gaps": { risk: "Fire Safety Risk" },
        "install additional gaps if needed": { risk: "Fire Safety Risk" },
        "adjust gap - lock": { risk: "Gaps" },
        "adjust gap - hinge": { risk: "Gaps" },
        "adjust gap - top": { risk: "Gaps" },
        "adjust gap - bottom": { risk: "Gaps" },
    };

    const handleOpenEditModal = () => {
        setEditedPrices(prices || {});
        setEditedLaborCost(laborCost || "");
        setEditedIncludeVAT(includeVAT);
        setEditedIncludeManagementFee(includeManagementFee);
        setShowWorkEditModal(true);
    };


    const handleSaveWorkPrices = async () => {
        if (!uid || !doorId) return;

        const reportUid = foundReportUid && foundReportUid.trim() !== "" ? foundReportUid : uid;

        const docRef = doc(
            db,
            `Reports/${reportUid}/ResidentialReports/${doorId}/prices/${doorId}`
        );

        // const saveData = {
        //     ...prices,
        // laborCost,
        // includeVAT,
        // includeManagementFee,
        // };

        try {
            await setDoc(docRef, editedPrices, { merge: true });
            setPrices(editedPrices);

            setShowWorkEditModal(false);
        } catch (error) {
            console.error("Error saving prices:", error);
        }
    };

    const handleVerifyPin = () => {
        if (pin === "2203") {
            setShowPinModal(false);
            setShowModal(true);
            setPin("");
        } else {
            alert("Incorrect PIN! Please try again.");
            setPin("");
        }
    };

    const handleFileSelection = (event) => {
        const files = Array.from(event.target.files);
        if (files.length > 0) {
            setSelectedFiles((prev) => [...prev, ...files]);
            setFileNames((prev) => [...prev, ...files.map(file => file.name)]);
        }
    };

    const removeSelectedFile = (index) => {
        setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        setFileNames((prevNames) => prevNames.filter((_, i) => i !== index));
    };

    const handleDeleteClick = (photo, index) => {
        setSelectedPhoto(photo);
        setSelectedIndex(index);
        setShowModalDelImage(true);
    };

    const handleConfirmDelete = async () => {
        if (!selectedPhoto) return;

        setLoading(true);
        try {
            const doorReportRef = doc(db, `Reports/${reportUidToUse}/ResidentialReports/${doorId}`);

            const storageRef = ref(storage, selectedPhoto);
            await deleteObject(storageRef);

            const updatedPhotos = report.workDonePhoto.filter((_, i) => i !== selectedIndex);
            await updateDoc(doorReportRef, { workDonePhoto: updatedPhotos });

            setReport((prevReport) => ({
                ...prevReport,
                workDonePhoto: updatedPhotos,
            }));

            toast.success("Photo deleted successfully!");
        } catch (error) {
            console.error("Error deleting photo:", error);
            toast.error("Failed to delete photo. Please try again.");
        } finally {
            setShowModalDelImage(false);
            setLoading(false);
        }
    };

    const handleSubmitDetails = async () => {
        if (!formRef.current) return console.error("Form reference not found");
        if (!user?.uid || !doorId) return console.error("Missing user UID or Door ID");

        const formData = new FormData(formRef.current);
        const doorNumber = formData.get("doorNumber")?.toString().trim() || "";
        const doorLevel = formData.get("floor")?.toString().trim() || "";

        if (!doorNumber || !doorLevel) {
            alert("Please fill in both Door Number and Door Level.");
            return;
        }

        setLoading(true);

        try {
            const now = new Date();
            const formattedDate = format(now, "yyyy-MM-dd HH:mm:ss");

            const doorDocRef = doc(db, "Reports", uid, "ResidentialReports", doorId);
            const storagePath = `Reports/${uid}/ResidentialReports/${doorId}`;

            const dataUrlToBlob = async (dataUrl) => {
                const res = await fetch(dataUrl);
                return await res.blob();
            };

            const uploadMedia = async (file, filename) => {
                if (!file) return null;
                try {
                    const storageRef = ref(storage, `${storagePath}/${filename}`);
                    const blob = file instanceof Blob ? file : await dataUrlToBlob(file);
                    await uploadBytes(storageRef, blob);
                    return await getDownloadURL(storageRef);
                } catch (error) {
                    console.error(`Error uploading ${filename}:`, error);
                    return null;
                }
            };

            const [
                doorPullPhotoLink,
                hingePhotoLink,
                doorCertPhotoLink,
                doorPushPhotoLink,
                closerVideoLink
            ] = await Promise.all([
                photo1 ? uploadMedia(await dataUrlToBlob(photo1), "doorPull.jpg") : null,
                photo2 ? uploadMedia(await dataUrlToBlob(photo2), "hinge.jpg") : null,
                photo3 ? uploadMedia(await dataUrlToBlob(photo3), "doorCert.jpg") : null,
                photo4 ? uploadMedia(await dataUrlToBlob(photo4), "doorPush.jpg") : null,
                lastVideoUrl ? uploadMedia(await dataUrlToBlob(lastVideoUrl), "closer.webm") : null
            ]);

            const data = {
                doorNumber,
                doorLevel,
                date: formattedDate,
                uid: doorId,
                doorId: doorId,
                hasAccess: true,
                requiresAttention: false,
                requiresReview: true,
                type: "residential",
                addedBy: user.uid,
                doorPushPhotoLink,
                doorPullPhotoLink,
                doorCertPhotoLink,
                hingePhotoLink,
                closerVideoLink,
                doorLocation: formData.get("doorLocation") || "",
                doorPhotoLink: "",
                doorCertif: formData.get("doorCertif") || "",
                doorUsage: formData.get("doorUsage") || "",
                damageMultiples: [],
                damageText: formData.get("damageText") || "",
                doorDamageLink: "",
                doorCloseAsIntented: null,
                doorStrips: null,
                glassFireStampLink: "",
                fD1: formData.get("fD1") || "",
                fD2: formData.get("fD2") || "",
                fD3: formData.get("fD3") || "",
                fD4: formData.get("fD4") || "",
                doorDimHeight: formData.get("doorDimHeight") || "",
                doorDimWidth: formData.get("doorDimWidth") || "",
                doorDimDepth: formData.get("doorDimDepth") || "",
                hingesWorking: null,
                hingesFireRating: null,
                workNeeded: "",
            };

            await setDoc(doorDocRef, data, { merge: true });
            // console.log("Residential report saved at:", doorDocRef.path);
        } catch (error) {
            console.error("Error saving report:", error);
        } finally {
            window.location.reload();

            setShowDetailsModal(false);
            setLoading(false);
            setPhoto1(null);
            setPhoto2(null);
            setPhoto3(null);
            setPhoto4(null);
            setLastVideoUrl(null);
        }
    };


    const handleOpenCamera = async () => {

        setPhoto1(null);
        setPhoto2(null);
        setPhoto3(null);
        setPhoto4(null);
        setLastVideoUrl(null);
        setCountdown(60);
        recordingCancelledRef.current = false;

        if (videoRef.current?.srcObject) {
            videoRef.current.srcObject.getTracks().forEach(track => track.stop());
            videoRef.current.srcObject = null;
        }

        if (videoRef.current) {
            videoRef.current.removeAttribute('src');
            videoRef.current.load();
        }

        if (lastVideoUrl) {
            URL.revokeObjectURL(lastVideoUrl);
        }

        if (mediaRecorderRef.current) {
            try {
                if (mediaRecorderRef.current.state !== 'inactive') {
                    mediaRecorderRef.current.stop();
                }
            } catch (e) {
                console.warn('Error stopping previous recorder:', e);
            }
            mediaRecorderRef.current = null;
        }

        if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
        }

        setShowCameraModal(true);

        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: { exact: "environment" },
                    width: { ideal: 1920 },
                    height: { ideal: 1080 },
                    advanced: [
                        { focusMode: "continuous" },
                    ]
                },
                audio: false,
            });


            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            }

            const recorder = new MediaRecorder(stream);
            const chunks = [];

            recorder.ondataavailable = (e) => chunks.push(e.data);
            recorder.onstop = () => {
                if (recordingCancelledRef.current) return;
                const blob = new Blob(chunks, { type: 'video/webm' });
                const url = URL.createObjectURL(blob);
                setLastVideoUrl(url);
            };


            recorder.start();
            mediaRecorderRef.current = recorder;

            countdownIntervalRef.current = setInterval(() => {
                setCountdown(prev => {
                    if (prev <= 1) {
                        clearInterval(countdownIntervalRef.current);
                        recorder.stop();
                        stream.getTracks().forEach((t) => t.stop());
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        } catch (error) {
            console.error("Camera access failed:", error);
            setShowCameraModal(false);
        }
    };


    const handleStopRecording = () => {
        clearInterval(countdownIntervalRef.current);
        setCountdown(0);

        if (mediaRecorderRef.current && mediaRecorderRef.current.state === "recording") {
            mediaRecorderRef.current.stop();
        }

        const stream = videoRef.current?.srcObject;
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }

        setShowCameraModal(false);
    };

    const handleTakePhoto = (slot) => {
        const video = videoRef.current;
        const canvas = canvasRef.current;

        if (!video || !canvas) return;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageData = canvas.toDataURL('image/png');
        switch (slot) {
            case 1: setPhoto1(imageData); break;
            case 2: setPhoto2(imageData); break;
            case 3: setPhoto3(imageData); break;
            case 4: setPhoto4(imageData); break;
            default: break;
        }
    };

    const handleCloseCameraModal = () => {
        recordingCancelledRef.current = true;
        setShowCameraModal(false);

        if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
        }

        if (mediaRecorderRef.current) {
            try {
                if (mediaRecorderRef.current.state !== 'inactive') {
                    mediaRecorderRef.current.stop();
                }
            } catch (e) {
                console.warn("Error stopping MediaRecorder:", e);
            }
            mediaRecorderRef.current = null;
        }

        const stream = videoRef.current?.srcObject;
        if (stream) {
            stream.getTracks().forEach((track) => track.stop());
        }

        if (videoRef.current) {
            videoRef.current.srcObject = null;
            videoRef.current.removeAttribute('src');
            videoRef.current.load();
        }

        if (lastVideoUrl) {
            URL.revokeObjectURL(lastVideoUrl);
        }

        setPhoto1(null);
        setPhoto2(null);
        setPhoto3(null);
        setPhoto4(null);
        setLastVideoUrl(null);
        setCountdown(0);
    };


    const handleCloseDetailsModal = () => {
        setReportDocId('');
        resetCameraState();
        setShowDetailsModal(false);
    };

    const resetCameraState = () => {
        setPhoto1(null);
        setPhoto2(null);
        setPhoto3(null);
        setPhoto4(null);

        if (lastVideoUrl) {
            URL.revokeObjectURL(lastVideoUrl);
        }
        setLastVideoUrl(null);

        if (mediaRecorderRef.current) {
            try {
                if (mediaRecorderRef.current.state !== 'inactive') {
                    mediaRecorderRef.current.stop();
                }
            } catch (e) {
                console.warn("Error stopping MediaRecorder:", e);
            }
            mediaRecorderRef.current = null;
        }

        if (videoRef.current?.srcObject) {
            videoRef.current.srcObject.getTracks().forEach(track => track.stop());
            videoRef.current.srcObject = null;
        }

        if (videoRef.current) {
            videoRef.current.removeAttribute('src');
            videoRef.current.load();
        }

        if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
        }

        setCountdown(0);
        recordingCancelledRef.current = false;
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            try {
                const reportsCollectionRef = collection(db, 'Reports');
                const buildingQuery = query(reportsCollectionRef, where('uid', '==', uid));
                const buildingSnapshot = await getDocs(buildingQuery);

                const building = buildingSnapshot.docs.map(doc => {
                    const data = doc.data();
                    return {
                        buildingLink: data.buildingLink,
                        buildingName: data.buildingName,
                        buildingType: data.buildingType,
                        city: data.city,
                        clientAddress: data.clientAddress,
                        clientName: data.clientName,
                        completedBy: data.completedBy,
                        date: data.date,
                        nextDate: data.nextDateResidential,
                        floors: data.floors,
                        personInCharge: data.personInCharge,
                        postcode: data.postcode,
                        reportId: data.reportId,
                        surveryCompleted: data.surveryCompleted,
                        excelLink: data.excelLink,
                        pdfLink: data.pdfLink,
                        uid: data.uid,
                        signOff: data.signOff || false,
                        logo: data.logo,
                        email: data.email,
                        estimateNo: data.estimateNo || "",
                    };
                });

                if (building.length === 0) {
                    console.error('No building data found.');
                    return;
                }

                const currentBuilding = building[0];
                setBuildingData(currentBuilding);

                const doorReportsRef = collection(db, `Reports/${uid}/ResidentialReports`);
                const doorQuery = query(doorReportsRef, orderBy('date', 'asc'));
                const doorSnapshot = await getDocs(doorQuery);

                const doorReports = doorSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                setDoorReports(doorReports);

                if (!originalIndex) {
                    const index = doorReports.findIndex(door => door.id === doorId);
                    if (index !== -1) {
                        setOriginalIndex(index);
                    }
                }

                let localReportUid = uid;
                setReportUidToUse(uid);

                let reportRef = doc(db, `Reports/${uid}/ResidentialReports/${doorId}`);
                let reportSnap = await getDoc(reportRef);

                let reportData;

                if (!reportSnap.exists() || (reportSnap.data()?.addedBy ?? "") === "") {
                    const allReportsQuery = query(
                        collection(db, 'Reports'),
                        where('buildingName', '==', currentBuilding.buildingName)
                    );
                    const allReportsSnapshot = await getDocs(allReportsQuery);

                    const allReportsSorted = allReportsSnapshot.docs
                        .map(docSnap => ({
                            id: docSnap.id,
                            data: docSnap.data(),
                        }))
                        .sort((a, b) => {
                            const dateA = new Date(a.data.date);
                            const dateB = new Date(b.data.date);
                            return dateB - dateA;
                        });

                    for (const report of allReportsSorted) {
                        const reportUid = report.id;
                        const reportDate = report.data.date || "No date";

                        if (reportUid === uid) {
                            continue;
                        }

                        const doorRef = doc(db, `Reports/${reportUid}/ResidentialReports/${doorId}`);
                        const doorSnap = await getDoc(doorRef);

                        if (doorSnap.exists()) {
                            reportData = doorSnap.data();

                            if (!reportData.addedBy?.trim()) continue;

                            localReportUid = reportUid;
                            setReportUidToUse(reportUid);
                            setFoundReportUid(reportUid);
                            break;
                        }
                    }

                    if (!reportData) {
                        console.warn('No older door report found in any matching building.');
                    }
                } else {
                    reportData = reportSnap.data();
                }

                const pathname = location.pathname.replace(/\/+$/, '');
                const isSetPasscodePage = /\/(?:passcode|setpasscode)$/.test(pathname);
                const doorPasscode = String(reportData?.passcode ?? '').trim();
                const isBuildingOwner = Boolean(
                    currentBuilding.email && user?.email &&
                    currentBuilding.email === user.email
                );

                setStoredPasscode(doorPasscode);
                setProtectedDoorNumber(reportData?.doorNumber || doorId);

                if (canBypassPasscode || isBuildingOwner) {
                    setPasscodeModalType(null);
                } else if (doorPasscode) {
                    setPasscodeModalType(passcodeVerified ? null : 'enter');
                } else if (isSetPasscodePage) {
                    setPasscodeModalType('set');
                } else {
                    setPasscodeModalType(null);
                }

                let finalReportData = reportData ? { ...reportData } : null;

                if (!finalReportData || finalReportData.hasAccess === false) {
                    if (finalReportData) {
                        Object.keys(finalReportData).forEach((key) => {
                            if (key === 'hasAccess' || key === 'doorNumber') return;
                            if (Array.isArray(finalReportData[key])) finalReportData[key] = [];
                            else if (typeof finalReportData[key] === 'object' && finalReportData[key] !== null) finalReportData[key] = {};
                        });
                    }
                }

                if (!finalReportData || finalReportData.requiresReview === true) {
                    if (finalReportData) {
                        Object.keys(finalReportData).forEach((key) => {
                            if (key === 'requiresReview' || key === 'doorNumber') return;
                            if (Array.isArray(finalReportData[key])) finalReportData[key] = [];
                            else if (typeof finalReportData[key] === 'object' && finalReportData[key] !== null) finalReportData[key] = {};
                        });
                    }
                }

                let aiAnnotations = null;

                try {

                    const aiAnnotationsRef = collection(db, `Reports/${localReportUid}/ResidentialReports/${doorId}/ai-annotations`);
                    const aiAnnotationsSnap = await getDocs(aiAnnotationsRef);

                    // console.log('AI Annotations - reportUidToUse:', reportUidToUse);
                    // console.log('AI Annotations - doorId:', doorId);
                    // console.log('AI Annotations snapshot empty?:', aiAnnotationsSnap.empty);
                    // console.log('AI Annotations docs count:', aiAnnotationsSnap.docs.length);

                    if (!aiAnnotationsSnap.empty) {
                        aiAnnotations = aiAnnotationsSnap.docs.map(doc => ({
                            id: doc.id,
                            ...doc.data()
                        }));
                        // console.log('Mapped aiAnnotations:', aiAnnotations);
                    } else {
                        // console.log('No AI annotations found');
                    }
                } catch (error) {
                    console.error('Error fetching AI annotations:', error);
                }

                if (finalReportData && aiAnnotations && aiAnnotations.length > 0) {
                    finalReportData = { ...finalReportData, aiAnnotations };
                }

                setReport(finalReportData);

                await fetchPrices(localReportUid);

            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                // setTimeout(() => {
                //     setLoading(false);
                // }, 4500);
                setLoading(false);
                window.scrollTo(0, 0);
            }
        };

        fetchData();
    }, [uid, doorId, originalIndex, passcodeVerified, location.pathname]);

    const handleVerifyPasscode = () => {
        if (!storedPasscode || passcodeInput.trim() !== storedPasscode) {
            setPasscodeError('Incorrect passcode.');
            return;
        }

        setPasscodeError('');
        setPasscodeInput('');
        setPasscodeModalType(null);
        setPasscodeVerified(true);
    };

    const handleSetPasscode = async () => {
        if (isSavingPasscodeRef.current) return;

        if (storedPasscode) {
            setNewPasscode('');
            setPasscodeError('A passcode is already set. Enter your existing passcode.');
            setPasscodeVerified(false);
            setPasscodeModalType('enter');
            return;
        }

        const value = newPasscode;
        if (!/^[0-9]{4}$/.test(value)) {
            setPasscodeError('Passcode must be exactly 4 digits.');
            return;
        }

        isSavingPasscodeRef.current = true;
        setIsSavingPasscode(true);
        setPasscodeError('');

        try {
            const residentialReportRef = doc(
                db,
                `Reports/${reportUidToUse || uid}/ResidentialReports/${doorId}`
            );

            const result = await runTransaction(db, async (transaction) => {
                const snapshot = await transaction.get(residentialReportRef);
                if (!snapshot.exists()) {
                    throw new Error('Residential door report not found.');
                }

                const existingPasscode = String(snapshot.data().passcode ?? '').trim();
                if (existingPasscode) {
                    return { created: false, passcode: existingPasscode };
                }

                transaction.update(residentialReportRef, { passcode: value });
                return { created: true, passcode: value };
            });

            setStoredPasscode(result.passcode);
            setNewPasscode('');
            setPasscodeInput('');
            setPasscodeVerified(false);

            if (!result.created) {
                setPasscodeError('A passcode is already set. Enter your existing passcode.');
                setPasscodeModalType('enter');
                return;
            }

            setPasscodeError('');
            setPasscodeModalType(null);
            navigate(`/doors/${uid}/resi_details/${doorId}`, { replace: true });
        } catch (error) {
            console.error('Error setting residential door passcode:', error);
            setPasscodeError('Unable to save passcode. Please try again.');
        } finally {
            isSavingPasscodeRef.current = false;
            setIsSavingPasscode(false);
        }
    };

    useEffect(() => {
        setPasscodeVerified(false);
        setStoredPasscode('');
        setPasscodeInput('');
        setNewPasscode('');
        setPasscodeError('');
        setProtectedDoorNumber('');
        setPasscodeModalType(null);
    }, [uid, doorId]);

    const fetchPrices = async (reportUid) => {
        if (!reportUid) return;

        try {
            const pricesRef = doc(db, `Reports/${reportUid}/ResidentialReports/${doorId}/prices/${doorId}`);
            const pricesSnap = await getDoc(pricesRef);

            if (pricesSnap.exists()) {
                setPrices(pricesSnap.data());
            } else {
                // setPrices(null);
                setPrices({});
            }
        } catch (error) {
            console.error("Error fetching prices:", error);
        }
    };



    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            setPhoto(e.target.files[0]);
        }
    };

    function formatToAlternate(isoString) {
        const date = new Date(isoString.replace(" ", "T"));
        const pad = n => String(n).padStart(2, "0");

        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        return `${day}/${month}/${year} ${pad(hours)}:${minutes}:${seconds} ${ampm}`;
    }

    const compressImage = (file, options = {}) => {
        const {
            maxWidth = 1920,
            maxHeight = 1920,
            quality = 0.70,
        } = options;

        return new Promise((resolve, reject) => {
            if (!file.type.startsWith("image/")) {
                resolve(file);
                return;
            }

            const reader = new FileReader();
            const img = new Image();

            reader.onload = (e) => (img.src = e.target.result);
            reader.onerror = reject;

            img.onload = () => {
                let { width, height } = img;

                if (width > maxWidth || height > maxHeight) {
                    const scale = Math.min(maxWidth / width, maxHeight / height);
                    width = Math.round(width * scale);
                    height = Math.round(height * scale);
                }

                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext("2d");
                ctx.imageSmoothingQuality = "high";
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    (blob) => {
                        if (!blob) {
                            reject(new Error("Compression failed"));
                            return;
                        }

                        const compressedFile = new File([blob], file.name, {
                            type: file.type,
                            lastModified: Date.now(),
                        });

                        resolve(compressedFile);
                    },
                    file.type,
                    file.type === "image/png" ? undefined : quality
                );
            };

            reader.readAsDataURL(file);
        });
    };


    const updateWorkDone = async () => {
        if (!message && selectedFiles.length === 0) {
            toast.warning("Please enter a message or upload files.");
            return;
        }

        setLoading(true);

        try {

            const uploadedURLs = [];

            for (let file of selectedFiles) {
                const isVideo = file.type.startsWith('video/');

                let fileToUpload = file;
                let fileExtension = file.name.split('.').pop() || 'jpg';

                if (!isVideo && file.type.startsWith('image/')) {
                    fileToUpload = await compressImage(file, {
                        maxWidth: 1920,
                        maxHeight: 1920,
                        quality: 0.7,
                    });
                    fileExtension = "jpg";
                }

                const imagePath = `Reports/${reportUidToUse}/ResidentialReports/${doorId}/workDone_${Date.now()}.${fileExtension}`;
                const storageRef = ref(storage, imagePath);

                await uploadBytes(storageRef, fileToUpload);
                const url = await getDownloadURL(storageRef);
                uploadedURLs.push(url);
            }

            const doorReportRef = doc(
                db,
                `Reports/${reportUidToUse}/ResidentialReports/${doorId}`
            );

            const updatedWorkDonePhoto = Array.isArray(report?.workDonePhoto)
                ? [...report.workDonePhoto, ...uploadedURLs]
                : uploadedURLs;

            const now = new Date();
            const formattedTimestamp = now
                .toISOString()
                .slice(0, 19)
                .replace("T", " ");

            await setDoc(
                doorReportRef,
                {
                    workDone: message?.trim() || report?.workDone || "",
                    workDonePhoto: updatedWorkDonePhoto,
                    requiresAttention: true,
                    workDoneUpdatedAt: formattedTimestamp,
                },
                { merge: true }
            );

            try {
                await deleteDoc(doc(db, "book-remedials", "available-jobs", reportUidToUse, doorId));
            } catch (pointerErr) {
                console.log("No book-remedials pointer to remove:", pointerErr);
            }

            setMessage("");
            setSelectedFiles([]);
            setFileNames([]);
            setShowModal(false);

            toast.success("Work done updated successfully!", {
                icon: (
                    <FontAwesomeIcon
                        icon={faCircleCheck}
                        bounce
                        size="sm"
                        style={{ color: "green" }}
                    />
                ),
            });
        } catch (error) {
            console.error("Failed to update work done:", error);
            toast.error("Failed to update work done. Please try again.");
        } finally {
            window.location.reload();
        }
    };


    const clearAll = async () => {
        if (!report?.workDone && (!report?.workDonePhoto || report.workDonePhoto.length === 0)) {
            toast.info("Nothing to clear.");
            return;
        }

        setLoading(true);
        try {
            const doorReportRef = doc(db, `Reports/${reportUidToUse}/ResidentialReports/${doorId}`);

            if (report?.workDonePhoto?.length > 0) {
                const deletePromises = report.workDonePhoto.map(async (photo) => {
                    if (photo) {
                        const storageRef = ref(storage, photo);
                        await deleteObject(storageRef).catch(() => console.warn("Photo not found:", photo));
                    }
                });

                await Promise.all(deletePromises);
            }

            await updateDoc(doorReportRef, {
                workDone: "",
                workDonePhoto: [],
                requiresAttention: false,
                workDoneUpdatedAt: "",
            });

            setMessage("");
            setPhoto(null);
            toast.success("Cleared successfully!");
        } catch (error) {
            console.error("Failed to clear:", error);
            toast.error("Failed to clear. Please try again.");
        } finally {
            // setLoading(false);
            window.location.reload();
        }
    };


    useEffect(() => {
        return () => {
            if (selectedImage) {
                URL.revokeObjectURL(selectedImage);
            }
        };
    }, [selectedImage]);

    const closeModal = () => {
        setShowModal1(false);
        setSelectedImage(null);
        setInspectionChanged(null);
    };

    const handleRequireAttention = async () => {
        if (!report?.requiresAttention && !selectedImage) {
            toast.error("Please upload a photo before confirming.");
            return;
        }

        setLoading(true);

        try {
            const doorReportRef = doc(db, `Reports/${reportUidToUse}/ResidentialReports/${doorId}`);

            if (report?.requiresAttention) {
                await updateDoc(doorReportRef, { requiresAttention: false, inspectionChanged: false });
                setReport(prev => ({ ...prev, requiresAttention: false, inspectionChanged: false }));

                setShowModal1(false);
                toast.info('Door no longer requires attention.', {
                    toastId: 'survey_success',
                    className: 'green-toast',
                    progressClassName: 'green-progress-bar',
                });

                setSelectedIndexPhoto(0);
                return;
            }

            const ext = selectedImage.name.split('.').pop() || 'jpg';
            const storage = getStorage();
            const imageRef = ref(
                storage,
                `Reports/${reportUidToUse}/ResidentialReports/${doorId}/door_Photo.${ext}`
            );

            await uploadBytes(imageRef, selectedImage, { contentType: selectedImage.type });
            const downloadURL = await getDownloadURL(imageRef);

            await updateDoc(doorReportRef, {
                requiresAttention: true,
                doorPhotoLink: downloadURL,
                inspectionChanged: inspectionChanged,
            });

            setReport(prev => ({
                ...prev,
                requiresAttention: true,
                doorPhotoLink: downloadURL,
                inspectionChanged: inspectionChanged,
            }));

            setShowModal1(false);
            setSelectedImage(null);
            setInspectionChanged(null);

            toast.info('Door updated with photo successfully!', {
                toastId: 'survey_success',
                className: 'green-toast',
                progressClassName: 'green-progress-bar',
            });

        } catch (error) {
            console.error('Failed to update report:', error);
            toast.error('Failed to update door. Please try again.', {
                toastId: 'survey_error',
                className: 'red-toast',
                progressClassName: 'red-progress-bar',
            });
        } finally {
            setLoading(false);
            // window.location.reload();
        }
    };


    const applySelectedPdfPhotos = (
        door,
        selectedPhotoFields
    ) => {
        if (!door || !selectedPhotoFields) {
            return door;
        }

        return {
            ...door,

            doorPullPhotoLink:
                selectedPhotoFields.doorPullPhotoLink ?? door.doorPullPhotoLink,

            doorPushPhotoLink:
                selectedPhotoFields.doorPushPhotoLink ?? door.doorPushPhotoLink,

            doorCertPhotoLink:
                selectedPhotoFields.doorCertPhotoLink ?? door.doorCertPhotoLink,

            hingePhotoLink:
                selectedPhotoFields.hingePhotoLink ?? door.hingePhotoLink,

            hingePhotoLink2:
                selectedPhotoFields.hingePhotoLink2 ?? door.hingePhotoLink2,

            hingePhotoLink3:
                selectedPhotoFields.hingePhotoLink3 ?? door.hingePhotoLink3,

            lockPhotoLink:
                selectedPhotoFields.lockPhotoLink ?? door.lockPhotoLink,

            letterBoxPhotoLink:
                selectedPhotoFields.letterBoxPhotoLink ?? door.letterBoxPhotoLink,

            doorDamageLink:
                selectedPhotoFields.doorDamageLink ?? door.doorDamageLink,
        };
    };

    const exportToPDF = async (
        buildingData,
        report,
        selectedPhotoFields = null
    ) => {
        setDisplayedText("");
        setMessageIndex(0);
        setCharIndex(0);

        setMessages([
            "Locating your file...",
            "Downloading PDF...",
            "Saving to your device...",
            "Almost done...",
        ]);

        setLoading(true);

        try {
            const doorReportsCollection = "ResidentialReports";

            const actualSelectedPhotoFields =
                selectedPhotoFields?.selectedFields ||
                selectedPhotoFields ||
                null;

            const selectedAiAnnotations =
                Array.isArray(
                    selectedPhotoFields?.aiAnnotations
                )
                    ? selectedPhotoFields.aiAnnotations
                    : null;

            let hasAiAnnotations = false;

            let reportWithAnnotations =
                Array.isArray(report)
                    ? [...report]
                    : { ...report };

            const reportsArray =
                Array.isArray(report)
                    ? report
                    : [report];

            if (
                selectedAiAnnotations &&
                selectedAiAnnotations.length > 0
            ) {
                hasAiAnnotations =
                    selectedAiAnnotations.some(
                        (annotation) =>
                            annotation?.annotationExists === true ||
                            (
                                Array.isArray(
                                    annotation?.regions
                                ) &&
                                annotation.regions.length > 0
                            )
                    );

                if (hasAiAnnotations) {
                    if (Array.isArray(report)) {
                        reportWithAnnotations =
                            report.map((door) => ({
                                ...door,
                                aiAnnotations:
                                    selectedAiAnnotations,
                            }));
                    } else {
                        reportWithAnnotations = {
                            ...report,
                            aiAnnotations:
                                selectedAiAnnotations,
                        };
                    }
                }
            }

            if (reportsArray.length > 0) {
                const annotationsPath =
                    `Reports/${reportUidToUse}/${doorReportsCollection}/${doorId}/ai-annotations`;

                const annotationsRef =
                    collection(
                        db,
                        annotationsPath
                    );

                const annotationsSnapshot =
                    await getDocs(
                        annotationsRef
                    );

                hasAiAnnotations =
                    !annotationsSnapshot.empty ||
                    selectedAiAnnotations?.length > 0;

                if (hasAiAnnotations) {
                    const aiAnnotations = [
                        ...annotationsSnapshot.docs.map((annotationDoc) => ({
                            ...annotationDoc.data(),
                            id: annotationDoc.id,
                        })),
                        ...(selectedAiAnnotations || []),
                    ].filter(
                        (annotation, index, array) =>
                            index === array.findIndex(
                                (a) => a.id === annotation.id
                            )
                    );

                    if (Array.isArray(report)) {
                        reportWithAnnotations =
                            report.map((door) => ({
                                ...door,
                                aiAnnotations,
                            }));
                    } else {
                        reportWithAnnotations = {
                            ...report,
                            aiAnnotations,
                        };
                    }
                }
            }

            if (actualSelectedPhotoFields) {
                if (
                    Array.isArray(
                        reportWithAnnotations
                    )
                ) {
                    const currentReportDoor =
                        Array.isArray(report)
                            ? report[0]
                            : report;

                    reportWithAnnotations =
                        reportWithAnnotations.map(
                            (door) => {
                                const sameDoor =
                                    reportWithAnnotations.length === 1 ||
                                    String(
                                        door?.id ||
                                        door?.doorId ||
                                        ""
                                    ) ===
                                    String(
                                        doorId ||
                                        ""
                                    ) ||
                                    (
                                        door?.doorNumber != null &&
                                        currentReportDoor?.doorNumber != null &&
                                        String(
                                            door.doorNumber
                                        ) ===
                                        String(
                                            currentReportDoor.doorNumber
                                        )
                                    );

                                if (!sameDoor) {
                                    return door;
                                }

                                return applySelectedPdfPhotos(
                                    door,
                                    actualSelectedPhotoFields
                                );
                            }
                        );
                } else {
                    reportWithAnnotations =
                        applySelectedPdfPhotos(
                            reportWithAnnotations,
                            actualSelectedPhotoFields
                        );
                }
            }

            const payload = {
                doorReports:
                    Array.isArray(
                        reportWithAnnotations
                    )
                        ? reportWithAnnotations
                        : [reportWithAnnotations],

                report:
                    buildingData,

                returnPdfBytes:
                    true,
            };

            const endpoint =
                hasAiAnnotations
                    ? "https://firechecked-gcp-813451531907.europe-west1.run.app/export-new-main-report-pdf"
                    : "https://firechecked-gcp-813451531907.europe-west1.run.app/export-to-pdf";

            const response =
                await fetch(
                    endpoint,
                    {
                        method: "POST",

                        headers: {
                            "Content-Type":
                                "application/json",
                        },

                        body:
                            JSON.stringify(
                                payload
                            ),
                    }
                );

            if (!response.ok) {
                throw new Error(
                    `Failed to generate PDF: ${response.statusText}`
                );
            }

            const blob =
                await response.blob();

            const pdfUrl =
                URL.createObjectURL(
                    blob
                );

            const link =
                document.createElement(
                    "a"
                );

            link.href =
                pdfUrl;

            link.download =
                `Report_${new Date().toISOString()}.pdf`;

            document.body.appendChild(
                link
            );

            link.click();

            document.body.removeChild(
                link
            );

            setTimeout(() => {
                URL.revokeObjectURL(
                    pdfUrl
                );
            }, 1000);

            return pdfUrl;

        } catch (error) {
            console.error(
                "Error exporting PDF:",
                error
            );

            return null;

        } finally {
            setLoading(false);
        }
    };

    function toTitleCase(str) {
        if (!str) return "";
        return str
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }

    const isDoorFailed = (door) => {
        let trueCount = 0;
        let falseCount = 0;

        const d1 = parseFloat(door.fD1) || 0;
        const d2 = parseFloat(door.fD2) || 0;
        const d3 = parseFloat(door.fD3) || 0;
        const d4 = parseFloat(door.fD4) || 0;

        const condition1 = d1 <= 4 && d2 <= 4 && d3 <= 4;
        const condition2 = d4 <= 8;

        if (door.doorCloseAsIntented === false || door.doorCloseAsIntented === "No") falseCount++; else trueCount++;
        if (door.doorStrips) trueCount++; else falseCount++;
        if (door.hingesWorking) trueCount++; else falseCount++;
        if (door.hingesFireRating) trueCount++; else falseCount++;
        if (door.relevantSignage !== false) trueCount++; else falseCount++;
        if (door.keylessExit !== false) trueCount++; else falseCount++;
        if (door.lockFireRated !== false) trueCount++; else falseCount++;

        const damageMultiplesArr = (door.damageMultiples || []).map(item => item.toString());
        if (damageMultiplesArr.includes("None") && damageMultiplesArr.length === 1) {
            trueCount++;
        } else {
            const isValidCondition =
                (damageMultiplesArr.includes("Door Pass") || !damageMultiplesArr.includes("Door")) &&
                (damageMultiplesArr.includes("Frame Pass") || !damageMultiplesArr.includes("Frame")) &&
                (damageMultiplesArr.includes("Glass None") ||
                    damageMultiplesArr.includes("Glass Pass") ||
                    !damageMultiplesArr.includes("Glass")) &&
                (damageMultiplesArr.includes("Ventilation Gaps None") ||
                    damageMultiplesArr.includes("Ventilation Gaps Pass") ||
                    !damageMultiplesArr.includes("Ventilation Gaps"));

            if (isValidCondition) trueCount++;
            else falseCount++;
        }

        if (door.doorCertif && !door.doorCertif.includes("No")) trueCount++; else falseCount++;
        if (condition1 && condition2) trueCount++; else falseCount++;

        return falseCount > 0;
    };


    useEffect(() => {
        const getUserNameByUid = async (uid) => {
            try {
                if (!uid) return "Unknown";
                const userDoc = await getDoc(doc(db, "users", uid));
                return userDoc.exists() ? userDoc.data().name || "Unknown" : "Unknown";
            } catch (e) {
                console.error("Error fetching user name:", e);
                return "Unknown";
            }
        }

        const generateDoorHistory = async () => {
            try {
                if (!buildingData || !report || !report.doorNumber) {
                    setDoorHistory([]);
                    return;
                }

                setLoading(true);

                const previousReports = await fetchPreviousReport(
                    buildingData.uid,
                    report.doorNumber,
                    buildingData.buildingName
                );

                const reportsArray = [report, ...(previousReports || [])];
                const uniqueReports = reportsArray
                    .filter(report => report.addedBy && report.addedBy.trim() !== "")
                    .filter((item, index, self) =>
                        index === self.findIndex(t => t.date === item.date)
                    );


                const sortedReports = uniqueReports.sort((a, b) => {
                    const dateA = new Date(a.date || 0);
                    const dateB = new Date(b.date || 0);
                    return dateA - dateB;
                });

                const history = [];

                for (const r of sortedReports) {
                    const failed = isDoorFailed(r);
                    let addedByName = await getUserNameByUid(r.addedBy);
                    if (addedByName.toLowerCase() === "hello") {
                        addedByName = "FireChecked";
                    }

                    const date = new Date(r.date);
                    const formattedDate = !isNaN(date)
                        ? date.toLocaleDateString("en-GB")
                        : "Unknown date";

                    const baseMedia = [
                        { link: r.closerVideoLink, title: "Closer Video", isVideo: true },
                        { link: r.doorPullPhotoLink, title: "Pull", isVideo: false },
                        { link: r.doorPushPhotoLink, title: "Push", isVideo: false },
                        { link: r.doorCertPhotoLink, title: "Certification", isVideo: false },
                        { link: r.hingePhotoLink, title: "Hinge 1", isVideo: false },
                        { link: r.hingePhotoLink2, title: "Hinge 2", isVideo: false },
                        { link: r.hingePhotoLink3, title: "Hinge 3", isVideo: false },
                        { link: r.glassFireStampLink, title: "Fire Stamp", isVideo: false },
                        { link: r.cupboard_contense_photo, title: "Cupboard Contents", isVideo: false },
                        { link: r.lockPhotoLink, title: "Lock Photo 1", isVideo: false },
                        { link: r.lockPhotoLink2, title: "Lock Photo 2", isVideo: false },
                        { link: r.lockPhotoLink3, title: "Lock Photo 3", isVideo: false },
                        { link: r.letterBoxPhotoLink, title: "Letter Box", isVideo: false },
                        { link: r.doorDamageLink, title: "Damage 1", isVideo: false },
                        { link: r.doorDamageLink2, title: "Damage 2", isVideo: false },
                        { link: r.doorDamageLink3, title: "Damage 3", isVideo: false },
                        { link: r.doorDamageLink4, title: "Damage 4", isVideo: false },
                        { link: r.doorDamageLink5, title: "Damage 5", isVideo: false },
                    ].filter(item => !!item.link);

                    const isVideoFromUrl = (url) => {
                        if (!url) return false;
                        const lowerUrl = url.toLowerCase();
                        const videoExtensions = ['.mp4', '.mov', '.avi', '.webm', '.mkv', '.m4v', '.3gp'];
                        return videoExtensions.some(ext => lowerUrl.includes(ext));
                    };

                    const workDoneMedia = (r.workDonePhoto || [])
                        .map((url, i) => ({
                            link: url,
                            title: `Work Done ${i + 1}`,
                            isVideo: isVideoFromUrl(url),
                        }))
                        .filter(item => !!item.link);

                    const preloadImages = (items) => {
                        items
                            .filter(m => !m.isVideo && !!m.link)
                            .forEach(m => {
                                const img = new Image();
                                img.src = m.link;
                            });
                    };
                    preloadImages(baseMedia);
                    preloadImages(workDoneMedia);

                    let failureReasons = [];

                    if (r.workNeeded && typeof r.workNeeded === "string") {
                        failureReasons = r.workNeeded
                            .split(/\n|\s*\|\s*/)
                            .map(s => s.trim())
                            .filter(Boolean)
                            .map(reason =>
                                workItemDisplayLabels[reason.toLowerCase()] || reason
                            );
                    }

                    const reasonText = failureReasons.length
                        ? failureReasons.join(", ")
                        : "not specified";

                    history.push({
                        type: r.hasAccess === false ? "no-access" : failed ? "failed" : "passed",
                        text: r.hasAccess === false
                            ? `Door surveyed on ${formattedDate} by ${addedByName}, No Access`
                            : r.requiresReview
                                ? `Door surveyed on ${formattedDate} by ${addedByName}, ${failed
                                    ? `Failed for reason: ${reasonText} (Under Review)`
                                    : "Passed inspection."
                                }`
                                : failed
                                    ? `Door surveyed on ${formattedDate} by ${addedByName}, failed for reason: ${reasonText}`
                                    : `Door surveyed on ${formattedDate} by ${addedByName}, passed inspection.`,
                        date: formattedDate,
                        label: "Before Work Done",
                        whome: addedByName,
                        media: baseMedia,
                    });

                    if ((r.workDoneUpdatedAt || r.workDonePhoto?.length > 0 || r.workDone != null)) {
                        const reDate = r.workDoneUpdatedAt
                            ? (() => {
                                const dt = new Date(r.workDoneUpdatedAt);
                                return !isNaN(dt.getTime())
                                    ? dt.toLocaleDateString("en-GB")
                                    : "Unknown Date";
                            })()
                            : "Unknown Date";

                        const workText = r.workDone
                            ? `Work done: ${r.workDone}`
                            : "Work details not provided.";

                        const combinedMedia = [...baseMedia, ...workDoneMedia];
                        preloadImages(combinedMedia);

                        history.push({
                            type: "reinspect",
                            text: `Work Done on ${reDate} by ${addedByName}. ${workText}`,
                            date: reDate,
                            label: "After Work Done",
                            whome: addedByName,
                            media: combinedMedia,
                        });
                    }
                }

                // console.log("Compiled door history:", history);
                setDoorHistory(history);
            }
            catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                // setTimeout(() => {
                //     setLoading(false);
                // }, 2000);
                // setLoading(false);
                window.scrollTo(0, 0);
            }
        }

        generateDoorHistory();
    }, [buildingData, report]);


    const exportHistoryToPDF = async (buildingData, report) => {
        setLoading(true);
        try {
            const reportsArray = Array.isArray(report) ? report : [report];

            const uniqueReports = reportsArray.filter((item, index, self) =>
                index === self.findIndex(t =>
                    t.uid === item.uid &&
                    t.date && item.date &&
                    t.date === item.date
                )
            );

            const payload = {
                doorReports: uniqueReports,
                report: buildingData,
            };

            // console.log("Sending payload for PDF export:", payload);

            const response = await fetch(
                // "http://localhost:8080/export-history-to-pdf",
                "https://firechecked-gcp-813451531907.europe-west1.run.app/export-history-to-pdf",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                throw new Error(`Failed to generate PDF: ${response.statusText}`);
            }

            const blob = await response.blob();
            const pdfUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = pdfUrl;
            link.download = `Report_${new Date().toISOString()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            //"PDF downloaded successfully");

            return pdfUrl;
        } catch (error) {
            console.error("Error exporting PDF:", error);
            return null;
        } finally {
            setLoading(false);
        }
    };


    const handleGetPreviousReport = async () => {
        setDisplayedText('');
        setMessageIndex(0);
        setCharIndex(0);
        setMessages([
            "Preparing your report...",
            "Fetching latest data...",
            "Compiling content...",
            "Generating PDF file...",
            "Optimizing layout...",
            "Finalizing formatting...",
            "Downloading PDF...",
            "Wrapping things up...",
            "Almost done...",
            "Just a moment more..."
        ]);

        setLoading(true);

        const previousReports = await fetchPreviousReport(buildingData.uid, report.doorNumber, buildingData.buildingName);
        const reportsArray = [report, ...(previousReports || [])];

        setLoading(false);

        // console.log(reportsArray);
        exportHistoryToPDF(buildingData, reportsArray);

    };

    const fetchPreviousReport1 = async (currentUid, targetDoorNumber, buildingName) => {
        try {

            const reportsRef = collection(db, "Reports");
            const q = query(reportsRef, where("buildingName", "==", buildingName));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                return null;
            }

            const reports = Array.from(querySnapshot.docs)
                .map(doc => ({
                    id: doc.id,
                    date: doc.data().date?.toDate?.() || new Date(doc.data().date || 0),
                    data: doc.data()
                }))
                .sort((a, b) => b.date - a.date);

            for (const report of reports) {
                if (report.id === currentUid) {
                    continue;
                }

                const doorReportsRef = collection(db, `Reports/${report.id}/ResidentialReports`);
                const doorSnap = await getDocs(doorReportsRef);

                const doors = [];
                doorSnap.forEach(doc => {
                    const doorData = doc.data();

                    const rawDate = doorData.date || report.date;
                    const timestamp = rawDate?.toDate?.() || new Date(rawDate);

                    doors.push({
                        ...doorData,
                        docId: doc.id,
                        timestamp,
                        originalNumber: doorData.doorNumber?.toString()
                    });
                });

                const exactMatch = doors.find(d => d.originalNumber === targetDoorNumber.toString());
                if (exactMatch) {
                    return formatResult(exactMatch, report, false);
                }

                if (doors.length > 0 && !doors[0].doorNumber) {
                    const sortedDoors = doors.sort((a, b) => {
                        const timeDiff = a.timestamp - b.timestamp;
                        return timeDiff !== 0 ? timeDiff : a.docId.localeCompare(b.docId);
                    });

                    const positionMap = sortedDoors.map((door, index) => ({
                        ...door,
                        positionNumber: index + 1
                    }));

                    // console.log('Chronological door order:',
                    //     positionMap.map(d => ({
                    //         position: d.positionNumber,
                    //         timestamp: d.timestamp.toISOString(),
                    //         original: d.originalNumber
                    //     }))
                    // );

                    const positionMatch = positionMap.find(d =>
                        d.positionNumber.toString() === targetDoorNumber.toString()
                    );

                    if (positionMatch) {
                        return formatResult(positionMatch, report, true, targetDoorNumber);
                    }
                }
            }

            // console.log("No matching doors found in any reports");
            return null;

        } catch (error) {
            console.error("Error:", error);
            return null;
        }
    };

    const fetchPreviousReport = async (currentUid, targetDoorNumber, buildingName) => {
        try {
            const reportsRef = collection(db, "Reports");
            const q = query(reportsRef, where("buildingName", "==", buildingName));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                return [];
            }

            const reports = Array.from(querySnapshot.docs)
                .map(doc => ({
                    id: doc.id,
                    date: doc.data().date?.toDate?.() || new Date(doc.data().date || 0),
                    data: doc.data()
                }))
                .sort((a, b) => b.date - a.date);

            const results = [];

            for (const report of reports) {
                if (report.id === currentUid) {
                    continue;
                }

                const doorReportsRef = collection(db, `Reports/${report.id}/ResidentialReports`);
                const doorSnap = await getDocs(doorReportsRef);

                const doors = [];
                doorSnap.forEach(doc => {
                    const doorData = doc.data();
                    const rawDate = doorData.date || report.date;
                    const timestamp = rawDate?.toDate?.() || new Date(rawDate);

                    doors.push({
                        ...doorData,
                        docId: doc.id,
                        timestamp,
                        originalNumber: doorData.doorNumber?.toString()
                    });
                });

                const exactMatch = doors.find(d => d.originalNumber === targetDoorNumber.toString());
                if (exactMatch) {
                    results.push(formatResult(exactMatch, report, false));
                    continue;
                }

                if (doors.length > 0) {
                    const sortedDoors = doors.sort((a, b) => {
                        const timeDiff = a.timestamp - b.timestamp;
                        return timeDiff !== 0 ? timeDiff : a.docId.localeCompare(b.docId);
                    });

                    const positionMap = sortedDoors.map((door, index) => ({
                        ...door,
                        positionNumber: index + 1
                    }));

                    const positionMatch = positionMap.find(d =>
                        d.positionNumber.toString() === targetDoorNumber.toString()
                    );

                    if (positionMatch) {
                        results.push(formatResult(positionMatch, report, true, targetDoorNumber));
                    }
                }
            }

            // console.log("Results:", results);
            return results;

        } catch (error) {
            console.error("Error:", error);
            return [];
        }
    };


    const formatResult = (doorData, report, isFallback, targetNumber) => {
        const result = {
            ...doorData,
            type: "residential",
            doorNumber: isFallback ? targetNumber.toString() : doorData.originalNumber,
            reportDate: report.date,
            reportId: report.id,
            isFallback,
            originalDoorNumber: doorData.originalNumber,
            positionNumber: doorData.positionNumber
        };

        return result;
    };

    const [messages, setMessages] = useState([
        "Fetching respective doors...",
        "Compiling results...",
        "Almost there..."
    ]);

    const [messageIndex, setMessageIndex] = useState(0);
    const [charIndex, setCharIndex] = useState(0);
    const [displayedText, setDisplayedText] = useState('');

    useEffect(() => {
        const currentMessage = messages[messageIndex];

        if (charIndex < currentMessage.length) {
            const timeout = setTimeout(() => {
                setDisplayedText(currentMessage.slice(0, charIndex + 1));
                setCharIndex((prev) => prev + 1);
            }, 30);
            return () => clearTimeout(timeout);
        } else if (messageIndex < messages.length - 1) {
            const delay = setTimeout(() => {
                setMessageIndex((prev) => prev + 1);
                setCharIndex(0);
                setDisplayedText('');
            }, 1500);
            return () => clearTimeout(delay);
        }
    }, [charIndex, messageIndex, messages]);

    const [isFirstDoor, setIsFirstDoor] = useState(false);
    const [isLastDoor, setIsLastDoor] = useState(false);

    const parseDoorNumber = (doorNumber) => {
        const str = String(doorNumber || "").replace(/\s+/g, "");
        const match = str.match(/^([A-Za-z]*)(\d+)?([A-Za-z]*)$/);
        if (!match) return { num: Infinity, category: 3, key: str };

        const [, prefix, digits, suffix] = match;
        const num = digits ? parseInt(digits, 10) : Infinity;

        let category;
        if (!prefix && !suffix) category = 0;
        else if (!prefix && suffix) category = 1;
        else category = 2;

        return { num, category, key: prefix + suffix };
    };

    const fetchAllDoors = async (uid, foundReportUid) => {
        const [primarySnap, fallbackSnap] = await Promise.all([
            getDocs(collection(db, "Reports", uid, "ResidentialReports")),
            foundReportUid
                ? getDocs(collection(db, "Reports", foundReportUid, "ResidentialReports"))
                : Promise.resolve(null),
        ]);

        const merged = [];
        const seen = new Set();

        primarySnap.docs.forEach((d) => {
            const data = d.data();
            const doorNumber = data.doorNumber?.trim() || d.id;
            if (!data.addedBy || data.addedBy.trim() === "") return;
            seen.add(doorNumber);
            merged.push({ id: d.id, reportUid: uid, ...data, doorNumber });
        });

        if (fallbackSnap) {
            fallbackSnap.docs.forEach((d) => {
                const data = d.data();
                const doorNumber = data.doorNumber?.trim() || d.id;
                if (seen.has(doorNumber)) return;
                if (!data.addedBy || data.addedBy.trim() === "") return;
                seen.add(doorNumber);
                merged.push({ id: d.id, reportUid: foundReportUid, ...data, doorNumber });
            });
        }

        return merged;
    };

    useEffect(() => {
        const checkDoorPosition = async () => {
            const doorsArray = await fetchAllDoors(uid, foundReportUid);

            const sortedDoorsArray = [...doorsArray].sort((a, b) => {
                const A = parseDoorNumber(a.doorNumber);
                const B = parseDoorNumber(b.doorNumber);
                if (A.num !== B.num) return A.num - B.num;
                if (A.category !== B.category) return A.category - B.category;
                return A.key.localeCompare(B.key);
            });

            const currentIndex = sortedDoorsArray.findIndex((door) => door.id === doorId);

            setIsFirstDoor(currentIndex <= 0);
            setIsLastDoor(currentIndex === -1 || currentIndex === sortedDoorsArray.length - 1);
        };

        if (doorId) {
            checkDoorPosition();
        }
    }, [doorId, uid, foundReportUid]);
    const panelHeight = window.innerWidth < 992 ? '500px' : 'min(750px, calc(100vh - 200px))';;

    if (loading) return (
        <div className="loading-container">
            <ClipLoader color="#b11111" size={60} />
            <div className="loading-text">
                {displayedText}
                <span className="cursor">|</span>
            </div>
        </div>
    );

    if (passcodeModalType && !canBypassPasscode) {
        const isSetMode = passcodeModalType === "set";

        return createPortal(
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: "100vw",
                    height: "100dvh",
                    margin: 0,
                    padding: "16px",
                    boxSizing: "border-box",
                    background: "rgba(15, 23, 42, 0.78)",
                    backdropFilter: "blur(7px)",
                    WebkitBackdropFilter: "blur(7px)",
                    zIndex: 2147483647,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflowY: "auto",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        maxWidth: "470px",
                        margin: "auto",
                        background: "#ffffff",
                        borderRadius: "18px",
                        overflow: "hidden",
                        boxSizing: "border-box",
                        boxShadow:
                            "0 25px 80px rgba(0, 0, 0, 0.35)",
                    }}
                >

                    <div
                        style={{
                            padding: "25px 26px 22px",
                            background:
                                "linear-gradient(135deg, #8f1010 0%, #b11111 100%)",
                            color: "#ffffff",
                        }}
                    >
                        <div
                            style={{
                                fontSize: "11px",
                                fontWeight: "700",
                                textTransform: "uppercase",
                                letterSpacing: "1.2px",
                                opacity: 0.82,
                                marginBottom: "7px",
                            }}
                        >
                            FireChecked Secure Access
                        </div>

                        <h3
                            style={{
                                margin: 0,
                                fontSize: "24px",
                                lineHeight: "1.25",
                                fontWeight: "700",
                            }}
                        >
                            {isSetMode
                                ? "Set Door Passcode"
                                : "Protected Door Report"}
                        </h3>

                        <p
                            style={{
                                margin: "8px 0 0",
                                fontSize: "14px",
                                lineHeight: "1.5",
                                opacity: 0.9,
                            }}
                        >
                            {isSetMode
                                ? "Create a passcode to protect access to this residential door report."
                                : "This residential door report is protected. Enter the passcode to continue."}
                        </p>
                    </div>


                    <div
                        style={{
                            margin: "22px 26px 0",
                            background: "#f8fafc",
                            border: "1px solid #e2e8f0",
                            borderRadius: "12px",
                            overflow: "hidden",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "20px",
                                padding: "14px 16px",
                            }}
                        >
                            <span
                                style={{
                                    fontSize: "13px",
                                    color: "#64748b",
                                }}
                            >
                                Building
                            </span>

                            <strong
                                style={{
                                    fontSize: "14px",
                                    color: "#0f172a",
                                    textAlign: "right",
                                }}
                            >
                                {buildingData?.buildingName || "—"}
                            </strong>
                        </div>

                        <div
                            style={{
                                height: "1px",
                                background: "#e2e8f0",
                            }}
                        />

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "20px",
                                padding: "14px 16px",
                            }}
                        >
                            <span
                                style={{
                                    fontSize: "13px",
                                    color: "#64748b",
                                }}
                            >
                                Door
                            </span>

                            <strong
                                style={{
                                    fontSize: "14px",
                                    color: "#0f172a",
                                    textAlign: "right",
                                }}
                            >
                                R{protectedDoorNumber || "—"}
                            </strong>
                        </div>
                    </div>


                    <div
                        style={{
                            padding: "22px 26px 26px",
                        }}
                    >
                        <label
                            style={{
                                display: "block",
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "#334155",
                                marginBottom: "8px",
                            }}
                        >
                            {isSetMode
                                ? "New Passcode"
                                : "Enter Passcode"}
                        </label>

                        <input
                            type="password"
                            inputMode={isSetMode || /^[0-9]{4}$/.test(storedPasscode) ? "numeric" : "text"}
                            maxLength={isSetMode ? 4 : undefined}
                            pattern={isSetMode ? "[0-9]{4}" : undefined}
                            disabled={isSavingPasscode}
                            value={
                                isSetMode
                                    ? newPasscode
                                    : passcodeInput
                            }
                            onChange={(e) => {
                                setPasscodeError("");

                                if (isSetMode) {
                                    setNewPasscode(
                                        e.target.value.replace(/[^0-9]/g, '').slice(0, 4)
                                    );
                                } else {
                                    setPasscodeInput(e.target.value);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key !== "Enter") {
                                    return;
                                }

                                if (isSetMode) {
                                    handleSetPasscode();
                                } else {
                                    handleVerifyPasscode();
                                }
                            }}
                            placeholder={
                                isSetMode
                                    ? "Create a 4-digit passcode"
                                    : "Enter your passcode"
                            }
                            autoFocus
                            autoComplete="off"
                            style={{
                                width: "100%",
                                height: "48px",
                                border: passcodeError
                                    ? "1px solid #dc2626"
                                    : "1px solid #cbd5e1",
                                borderRadius: "10px",
                                padding: "0 14px",
                                boxSizing: "border-box",
                                fontSize: "15px",
                                outline: "none",
                                background: "#ffffff",
                                color: "#0f172a",
                            }}
                        />

                        {passcodeError && (
                            <div
                                style={{
                                    marginTop: "8px",
                                    fontSize: "13px",
                                    color: "#dc2626",
                                }}
                            >
                                {passcodeError}
                            </div>
                        )}


                        <button
                            type="button"
                            disabled={isSavingPasscode}
                            onClick={
                                isSetMode
                                    ? handleSetPasscode
                                    : handleVerifyPasscode
                            }
                            style={{
                                width: "100%",
                                height: "48px",
                                marginTop: "20px",
                                border: "none",
                                borderRadius: "10px",
                                background: "#b11111",
                                color: "#ffffff",
                                fontSize: "14px",
                                fontWeight: "700",
                                cursor: "pointer",
                            }}
                        >
                            {isSetMode
                                ? (isSavingPasscode ? "Saving..." : "Save Passcode")
                                : "Access Door Report"}
                        </button>


                        {isSetMode && (
                            <div
                                style={{
                                    marginTop: "8px",
                                    fontSize: "12px",
                                    color: "#64748b",
                                    lineHeight: "1.5",
                                }}
                            >
                                Enter exactly 4 digits (0–9).
                            </div>
                        )}
                    </div>
                </div>
            </div>,

            document.body
        );
    }

    if (!report) return (
        <div className="loading-container">
            <ClipLoader color="#b11111" size={60} />
            <div className="loading-text">
                {displayedText}
                <span className="cursor">|</span>
            </div>
        </div>
    );

    const viewerHeight = "700px";

    const handleThumbnailClick = (link, isVideo) => {
        setSelectedMedia(link);
        setMediaType(isVideo ? "video" : "image");

        setTimeout(() => {
            if (thumbRef.current) {
                const selectedThumb = thumbRef.current.querySelector(`[data-media="${link}"]`);
                if (selectedThumb) {
                    selectedThumb.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });
                    setTimeout(checkScrollButtons, 200);
                }
            }
        }, 100);
    };

    const handleMouseMove = (e) => {
        const img = e.currentTarget;
        const rect = img.getBoundingClientRect();

        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = "scale(3)";
    };

    const handleMouseLeave = (e) => {
        const img = e.currentTarget;
        img.style.transform = "scale(1)";
        img.style.transformOrigin = "center";
    };

    const handleSelectVideo = (link) => {
        setSelectedMedia(link);
        setMediaType("video");
    };

    const getMediaItems = () => {
        return [
            { link: report.doorPullPhotoLink, type: "image" },
            { link: report.doorPushPhotoLink, type: "image" },
            { link: report.doorCertPhotoLink, type: "image" },
            { link: report.hingePhotoLink, type: "image" },
            { link: report.hingePhotoLink2, type: "image" },
            { link: report.hingePhotoLink3, type: "image" },
            { link: report.glassFireStampLink, type: "image" },
            { link: report.cupboard_contense_photo, type: "image" },
            { link: report.lockPhotoLink, type: "image" },
            { link: report.lockPhotoLink2, type: "image" },
            { link: report.lockPhotoLink3, type: "image" },
            { link: report.letterBoxPhotoLink, type: "image" },
            { link: report.doorDamageLink, type: "image" },
            { link: report.doorDamageLink2, type: "image" },
            { link: report.doorDamageLink3, type: "image" },
            { link: report.doorDamageLink4, type: "image" },
            { link: report.doorDamageLink5, type: "image" },
            { link: report.closerVideoLink, type: "video" },
        ].filter(item => item.link);
    };

    const mediaItems = getMediaItems();
    const currentMediaIndex = mediaItems.findIndex(item => item.link === selectedMedia);
    const totalMediaCount = mediaItems.length;

    const navigateMedia = (direction) => {
        if (mediaItems.length === 0) return;

        let newIndex = currentMediaIndex + direction;
        if (newIndex < 0) newIndex = mediaItems.length - 1;
        if (newIndex >= mediaItems.length) newIndex = 0;

        const newMedia = mediaItems[newIndex];
        setSelectedMedia(newMedia.link);
        setMediaType(newMedia.type);

        if (thumbRef.current) {
            const thumbElement = thumbRef.current.children[newIndex];
            if (thumbElement) {
                thumbElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });
            }
        }
    };

    const processedItems = new Set();
    const processedPrices = new Set();

    const normalizedOptions = {};
    for (const category in predefinedOptions) {
        predefinedOptions[category].forEach(option => {
            const text = typeof option === "string" ? option : option.text;
            const normalized = text.toLowerCase().replace(/[^a-z0-9\s]/g, "");
            normalizedOptions[normalized] = text;
        });
    };

    const riskInitials = {
        "Fire Safety Risk": "FSR",
        "Gaps": "G",
        "Maintenance Issue": "MI"
    };

    const riskStyles = {
        "Fire Safety Risk": { color: "#dc3545", bg: "#fee", badge: "danger" },
        "Gaps": { color: "#fd7e14", bg: "#fee", badge: "warning" },
        "Maintenance Issue": { color: "#6c757d", bg: "#fee", badge: "secondary" }
        // "Fire Safety Risk": { color: "#dc3545", bg: "#fee", badge: "danger" },
        // "Gaps": { color: "#fd7e14", bg: "#fff8e1", badge: "warning" },
        // "Maintenance Issue": { color: "#6c757d", bg: "#f5f5f5", badge: "secondary" }
    };

    const workItemsRaw = report.workNeeded
        .split(/\n|\|/)
        .map(l => l.trim())
        .filter(Boolean)
        .flatMap(line => {
            const items = [];
            const lineLower = line.toLowerCase();

            if (lineLower.includes("gap")) {
                const gapKeywords = ["lock", "hinge", "top", "bottom"];
                const detected = gapKeywords.filter(g => lineLower.includes(g));

                detected.forEach(gap => {
                    const text = `Adjust Gap - ${gap.charAt(0).toUpperCase() + gap.slice(1)}`;
                    const price = prices[text] ?? 0;

                    if (!processedItems.has(text)) {
                        processedItems.add(text);
                        items.push({
                            text,
                            price,
                            risk: "Gaps"
                        });
                    }

                    if (price > 0) processedPrices.add(text);
                });
            }

            const normalizedLine = lineLower.replace(/[^a-z0-9\s]/g, "");

            for (const key in normalizedOptions) {
                if (
                    normalizedLine.includes(key) ||
                    key.includes(normalizedLine)
                ) {
                    const matchedText = normalizedOptions[key];
                    const risk =
                        prioritizedOptions[key]?.risk || "Maintenance Issue";
                    const price = prices[matchedText] ?? 0;

                    if (!processedItems.has(matchedText)) {
                        processedItems.add(matchedText);
                        items.push({ text: matchedText, price, risk });
                    }

                    if (price > 0) processedPrices.add(matchedText);
                    break;
                }
            }

            if (items.length === 0 && !processedItems.has(line)) {
                const risk =
                    prioritizedOptions[
                        lineLower.replace(/[^a-z0-9\s]/g, "")
                    ]?.risk || "Maintenance Issue";

                const price = prices[line] ?? 0;

                processedItems.add(line);
                items.push({
                    text: line,
                    price,
                    risk
                });

                if (price > 0) processedPrices.add(line);
            }

            return items;
        });

    const workItemsSorted = workItemsRaw.sort(
        (a, b) => riskPriority[a.risk] - riskPriority[b.risk]
    );

    const goToAdjacentDoor = async (direction) => {
        setLoading(true);
        setSelectedMedia(null);
        setMediaType('image');
        resetZoom();

        try {
            const doorsArray = await fetchAllDoors(uid, foundReportUid);

            const sortedDoorsArray = [...doorsArray].sort((a, b) => {
                const A = parseDoorNumber(a.doorNumber);
                const B = parseDoorNumber(b.doorNumber);
                if (A.num !== B.num) return A.num - B.num;
                if (A.category !== B.category) return A.category - B.category;
                return A.key.localeCompare(B.key);
            });

            const currentIndex = sortedDoorsArray.findIndex((door) => door.id === doorId);

            if (currentIndex === -1) return;

            const targetIndex = direction === "next" ? currentIndex + 1 : currentIndex - 1;

            if (targetIndex < 0 || targetIndex >= sortedDoorsArray.length) return;

            const target = sortedDoorsArray[targetIndex];

            navigate(`/doors/${target.reportUid}/resi_details/${target.id}`);
        } finally {
            setLoading(false);
        }
    };

    const getMobileTouchDistance = (touches) => {
        if (!touches || touches.length < 2) return 0;
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.hypot(dx, dy);
    };

    const getMobileTouchMidpoint = (touches) => ({
        x: (touches[0].clientX + touches[1].clientX) / 2,
        y: (touches[0].clientY + touches[1].clientY) / 2,
    });

    const handleMobileImageTouchStart = (e) => {
        if (e.touches.length === 2) {
            e.preventDefault();
            mobileImageGestureRef.current = {
                mode: 'pinch',
                startDistance: getMobileTouchDistance(e.touches),
                startZoom: zoom,
                startPan: { ...pan },
                startMidpoint: getMobileTouchMidpoint(e.touches),
                startTouch: { x: 0, y: 0 },
            };
            return;
        }

        if (e.touches.length === 1 && zoom > 1) {
            e.preventDefault();
            mobileImageGestureRef.current = {
                ...mobileImageGestureRef.current,
                mode: 'pan',
                startPan: { ...pan },
                startTouch: {
                    x: e.touches[0].clientX,
                    y: e.touches[0].clientY,
                },
            };
        }
    };

    const handleMobileImageTouchMove = (e) => {
        const gesture = mobileImageGestureRef.current;

        if (e.touches.length === 2 && gesture.mode === 'pinch') {
            e.preventDefault();
            const distance = getMobileTouchDistance(e.touches);
            if (!gesture.startDistance) return;

            const midpoint = getMobileTouchMidpoint(e.touches);
            const nextZoom = Math.min(
                5,
                Math.max(1, gesture.startZoom * (distance / gesture.startDistance))
            );

            setZoom(nextZoom);
            setPan({
                x: gesture.startPan.x + (midpoint.x - gesture.startMidpoint.x),
                y: gesture.startPan.y + (midpoint.y - gesture.startMidpoint.y),
            });
            return;
        }

        if (e.touches.length === 1 && gesture.mode === 'pan' && zoom > 1) {
            e.preventDefault();
            setPan({
                x: gesture.startPan.x + (e.touches[0].clientX - gesture.startTouch.x),
                y: gesture.startPan.y + (e.touches[0].clientY - gesture.startTouch.y),
            });
        }
    };

    const handleMobileImageTouchEnd = (e) => {
        if (e.touches.length === 1 && zoom > 1) {
            mobileImageGestureRef.current = {
                ...mobileImageGestureRef.current,
                mode: 'pan',
                startPan: { ...pan },
                startTouch: {
                    x: e.touches[0].clientX,
                    y: e.touches[0].clientY,
                },
            };
            return;
        }

        if (e.touches.length === 0) {
            mobileImageGestureRef.current.mode = null;
            if (zoom <= 1.01) {
                setZoom(1);
                setPan({ x: 0, y: 0 });
            }
        }
    };

    return (
        <div className="container-fluid service__section">
            <div className='services__great__wrapper' id='services'>
                <div className="container-fluid" style={{ maxWidth: '1600px', padding: '0 15px' }}>

                    <div
                        className={`py-3 door-report-header ${user ? 'has-door-nav' : 'no-door-nav'}`}
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr auto 1fr',
                            alignItems: 'center',
                            gap: '12px',
                            width: '100%',
                        }}
                    >
                        <div className="door-report-back" style={{ justifySelf: 'start' }}>
                            <button
                                className="btn btn-link text-danger text-decoration-none p-0 d-flex align-items-center"
                                onClick={() => navigate(`/doors/${uid}/`)}
                                style={{
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    className="me-2"
                                >
                                    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
                                </svg>

                                <span className="d-none d-sm-inline">Back to Doors</span>
                                <span className="d-inline d-sm-none">Back</span>
                            </button>
                        </div>

                        <div
                            className="text-center door-report-title-wrap"
                            style={{
                                justifySelf: 'center',
                                minWidth: 0,
                            }}
                        >
                            <h1
                                className="fw-bold mb-1 door-report-title"
                                style={{
                                    fontSize: 'clamp(18px, 3vw, 28px)',
                                    color: '#000',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {buildingData?.buildingName || 'Building'} R
                                {report?.doorNumber ?? originalIndex + 1}
                            </h1>

                            <p
                                className="text-muted mb-0 door-report-subtitle"
                                style={{
                                    fontSize: 'clamp(11px, 1.5vw, 14px)',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {report.doorLevel || 'Ground Floor'} •{' '}
                                {report.doorLocation || 'Main Entrance'}
                            </p>
                        </div>

                        <div
                            className="d-flex align-items-center gap-1 door-report-actions-wrap"
                            style={{
                                justifySelf: 'end',
                                flexWrap: 'nowrap',
                            }}
                        >
                            <div className="d-flex gap-2 justify-content-lg-end justify-content-center flex-wrap door-report-actions">
                                {user && (
                                    <span style={{ cursor: isFirstDoor ? 'not-allowed' : 'pointer' }}>
                                        <button
                                            className="btn btn-secondary btn-sm d-flex align-items-center gap-2 rounded-pill door-action door-action-prev"
                                            style={{
                                                fontSize: '11px',
                                                padding: '6px 14px',
                                                whiteSpace: 'nowrap',
                                                opacity: isFirstDoor ? 0.5 : 1,
                                                pointerEvents: isFirstDoor ? 'none' : 'auto',
                                            }}
                                            onClick={() => goToAdjacentDoor("prev")}
                                            disabled={isFirstDoor}
                                        >
                                            <FontAwesomeIcon icon={faArrowLeft} />
                                            <span className="door-nav-full-label">Previous Door</span>
                                            <span className="door-nav-short-label">Prev</span>
                                        </button>
                                    </span>
                                )}

                                {user && (
                                    <span style={{ cursor: isLastDoor ? 'not-allowed' : 'pointer' }}>
                                        <button
                                            className="btn btn-success btn-sm d-flex align-items-center gap-2 rounded-pill door-action door-action-next"
                                            style={{
                                                fontSize: '11px',
                                                padding: '6px 14px',
                                                whiteSpace: 'nowrap',
                                                opacity: isLastDoor ? 0.5 : 1,
                                                pointerEvents: isLastDoor ? 'none' : 'auto',
                                            }}
                                            onClick={() => goToAdjacentDoor("next")}
                                            disabled={isLastDoor}
                                        >
                                            <span className="door-nav-full-label">Next Door</span>
                                            <span className="door-nav-short-label">Next</span>
                                            <FontAwesomeIcon icon={faArrowRight} />
                                        </button>
                                    </span>
                                )}


                                {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'remedial') && (
                                    <button
                                        className="btn btn-primary btn-sm d-flex align-items-center gap-2 rounded-pill door-action door-action-estimate door-header-secondary-action"
                                        style={{
                                            fontSize: '11px',
                                            padding: '6px 14px',
                                            whiteSpace: 'nowrap',
                                        }}
                                        onClick={() => {
                                            setSelectedDoor(report);
                                            setShowEstimateModal(true);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faDownload} />
                                        Estimate
                                    </button>
                                )}

                                {user && (
                                    <button
                                        className="btn btn-danger btn-sm d-flex align-items-center gap-2 rounded-pill door-action door-action-pdf door-header-secondary-action"
                                        style={{
                                            fontSize: "11px",
                                            padding: "6px 14px",
                                            whiteSpace: "nowrap",
                                        }}
                                        onClick={() => {
                                            const canSelectPdfPhotos =
                                                userData?.role === "admin" ||
                                                userData?.role === "manager" ||
                                                userData?.role === "inspection" ||
                                                userData?.role === "reviewer" ||
                                                userData?.role === "remedial";

                                            if (canSelectPdfPhotos) {
                                                setShowPdfPhotoPicker(true);
                                            } else {
                                                exportToPDF(
                                                    buildingData,
                                                    report
                                                );
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faDownload} />
                                        PDF Report
                                    </button>
                                )}

                                {user && (
                                    <button
                                        className="btn btn-warning btn-sm d-flex align-items-center gap-2 rounded-pill text-dark door-action door-action-thread door-header-secondary-action"
                                        style={{
                                            fontSize: '11px',
                                            padding: '6px 14px',
                                            whiteSpace: 'nowrap',
                                        }}
                                        onClick={handleGetPreviousReport}
                                    >
                                        <FontAwesomeIcon icon={faDownload} />
                                        Golden Thread
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="door-mobile-tabs" role="tablist" aria-label="Door report sections">
                        <button
                            type="button"
                            role="tab"
                            aria-selected={reportViewTab === 'general'}
                            className={`door-mobile-tab ${reportViewTab === 'general' ? 'active' : ''}`}
                            onClick={() => setReportViewTab('general')}
                        >
                            General
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={reportViewTab === 'analysis'}
                            className={`door-mobile-tab ${reportViewTab === 'analysis' ? 'active' : ''}`}
                            onClick={() => setReportViewTab('analysis')}
                        >
                            Door Analysis
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={reportViewTab === 'history'}
                            className={`door-mobile-tab ${reportViewTab === 'history' ? 'active' : ''}`}
                            onClick={() => setReportViewTab('history')}
                        >
                            History
                        </button>
                    </div>

                    <div className="door-mobile-content-flow">

                        <div className={`row g-2 mb-3 door-summary-grid door-tab-panel door-tab-general ${reportViewTab === 'general' ? 'is-active' : ''}`}>
                            {[
                                {
                                    icon: (
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                                    ),
                                    label: 'Status',
                                    value: !report.hasAccess
                                        ? 'No access'
                                        : report.requiresReview
                                            ? 'In REVIEW'
                                            : isDoorFailed(report)
                                                ? 'FAIL'
                                                : 'PASS',
                                    color: !report.hasAccess
                                        ? '#6c757d'
                                        : report.requiresReview
                                            ? '#ffc107'
                                            : isDoorFailed(report)
                                                ? '#dc3545'
                                                : '#198754',
                                },

                                {
                                    icon: (
                                        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
                                    ),
                                    label: 'Certification',
                                    value: report?.hasAccess === false
                                        ? 'No access'
                                        : ['Assumed', 'Nominal'].includes(report?.doorCertif)
                                            ? 'Nominal'
                                            : report?.doorCertif || 'No',

                                    color: report?.hasAccess === false
                                        ? '#6c757d'
                                        : !report?.doorCertif || report?.doorCertif === 'No'
                                            ? '#dc3545'
                                            : '#28a745',
                                    showInfoButton: report?.hasAccess !== false
                                },

                                {
                                    icon: (
                                        <FontAwesomeIcon
                                            icon={faRuler}
                                            style={{ color: '#7d848b' }}
                                        />
                                    ),
                                    label: 'Dimensions (mm)',
                                    value: report?.hasAccess === false
                                        ? 'No access'
                                        : [
                                            report?.doorDimHeight,
                                            report?.doorDimWidth,
                                            report?.doorDimDepth
                                        ].every(
                                            v => v !== undefined && v !== null
                                        )
                                            ? `${report.doorDimHeight}×${report.doorDimWidth}×${report.doorDimDepth}`
                                            : 'N/A',
                                    color: '#6c757d',
                                },

                                {
                                    icon: (
                                        <path d="M3 17h6v4H3v-4zm6-7h6v11H9V10zm6-7h6v18h-6V3z" />
                                    ),
                                    label: 'Level',
                                    value: report.doorLevel || 'N/A',
                                    color: '#6c757d'
                                },

                                {
                                    icon: (
                                        <path d="M7 7h11l-2-2 1.4-1.4L21.8 7l-4.4 4.4L16 10l2-2H7V7zm10 10H6l2 2-1.4 1.4L2.2 17l4.4-4.4L8 14l-2 2h11v1z" />
                                    ),
                                    label: 'Usage',
                                    value: report.doorUsage || 'N/A',
                                    color: '#6c757d'
                                },

                                {
                                    icon: (
                                        <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10z" />
                                    ),
                                    label: 'Date Surveyed',
                                    value: report.date
                                        ? new Date(report.date).toLocaleDateString('en-GB')
                                        : 'N/A',
                                    color: '#6c757d'
                                },

                                {
                                    icon: (
                                        <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-1.99.9-1.99 2L2 11c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
                                    ),
                                    label: 'Tag ID',
                                    value: report.doorId?.substring(0, 12) + '...' || 'N/A',
                                    color: '#6c757d',
                                    truncate: true
                                },

                            ].map((item, idx) => (
                                <div
                                    key={idx}
                                    className="col-6 col-sm-4 col-md-3 col-lg door-summary-item"
                                >
                                    <div
                                        className="bg-white p-2 p-md-3 rounded-3 shadow-sm border h-100 door-summary-card"
                                        onClick={
                                            item.clickable
                                                ? item.onClick
                                                : undefined
                                        }
                                        onKeyDown={
                                            item.clickable
                                                ? (e) => {
                                                    if (
                                                        e.key === 'Enter' ||
                                                        e.key === ' '
                                                    ) {
                                                        e.preventDefault();
                                                        item.onClick();
                                                    }
                                                }
                                                : undefined
                                        }
                                        role={
                                            item.clickable
                                                ? 'button'
                                                : undefined
                                        }
                                        tabIndex={
                                            item.clickable
                                                ? 0
                                                : undefined
                                        }
                                        style={{
                                            cursor: item.clickable
                                                ? 'pointer'
                                                : 'default'
                                        }}
                                    >
                                        <div className="d-flex align-items-center gap-2 h-100">

                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill={item.color}
                                                className="flex-shrink-0 d-none d-md-block"
                                            >
                                                {item.icon}
                                            </svg>

                                            <div className="flex-grow-1 min-w-0">

                                                <div
                                                    className="text-muted mb-1 fw-bold d-flex align-items-center gap-2"
                                                    style={{ fontSize: 'clamp(10px, 1.5vw, 12px)' }}
                                                >
                                                    <span>{item.label}</span>

                                                    {item.showInfoButton && (
                                                        <button
                                                            className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                            onClick={(e) => {
                                                                e.stopPropagation();

                                                                openCertificationInfo(
                                                                    report?.doorCertif || 'Nominal'
                                                                );
                                                            }}
                                                            style={{
                                                                width: '24px',
                                                                height: '24px',
                                                                padding: 0,
                                                                border: '1px solid #6c757d',
                                                                background: 'white',
                                                                color: '#212529',
                                                                fontSize: '12px',
                                                                fontWeight: 'bold',
                                                                cursor: 'pointer',
                                                                flexShrink: 0
                                                            }}
                                                            title="More information"
                                                        >
                                                            ?
                                                        </button>
                                                    )}
                                                </div>

                                                <div
                                                    className={`fw-semibold ${item.truncate
                                                        ? 'text-truncate'
                                                        : ''
                                                        }`}
                                                    style={{
                                                        fontSize: 'clamp(12px, 2.2vw, 14px)',
                                                        color: item.color
                                                    }}
                                                    title={
                                                        item.clickable
                                                            ? 'Click for certification explanation'
                                                            : item.truncate
                                                                ? item.value
                                                                : undefined
                                                    }
                                                >
                                                    {item.value}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className={`door-mobile-report-actions door-tab-panel door-tab-general ${reportViewTab === 'general' ? 'is-active' : ''}`} aria-label="Report actions">
                            <div className="door-mobile-report-actions-head">
                                <span>Report actions</span>
                            </div>

                            <div className="door-mobile-report-actions-grid">
                                {(userData.role === 'admin' || userData.role === 'manager' || userData.role === 'inspection' || userData.role === 'remedial') && (
                                    <button
                                        type="button"
                                        className="door-mobile-report-action door-mobile-report-action-estimate"
                                        onClick={() => {
                                            setSelectedDoor(report);
                                            setShowEstimateModal(true);
                                        }}
                                    >
                                        <span className="door-mobile-report-action-icon" aria-hidden="true">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M6 2h9l3 3v17H6z" />
                                                <path d="M14 2v5h5" />
                                                <path d="M9 12h6M9 16h4" />
                                            </svg>
                                        </span>
                                        <span className="door-mobile-report-action-text">
                                            <strong>Estimate</strong>
                                            <small>View costs</small>
                                        </span>
                                    </button>
                                )}

                                {user && (
                                    <button
                                        type="button"
                                        className="door-mobile-report-action door-mobile-report-action-pdf"
                                        onClick={() => exportToPDF(buildingData, report)}
                                    >
                                        <span className="door-mobile-report-action-icon" aria-hidden="true">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M6 2h9l3 3v17H6z" />
                                                <path d="M14 2v5h5" />
                                                <path d="M9 13h6M9 17h6" />
                                            </svg>
                                        </span>
                                        <span className="door-mobile-report-action-text">
                                            <strong>PDF Report</strong>
                                            <small>Download</small>
                                        </span>
                                    </button>
                                )}

                                {user && (
                                    <button
                                        type="button"
                                        className="door-mobile-report-action door-mobile-report-action-thread"
                                        onClick={handleGetPreviousReport}
                                    >
                                        <span className="door-mobile-report-action-icon" aria-hidden="true">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M3 12a9 9 0 1 0 3-6.7" />
                                                <path d="M3 4v6h6" />
                                                <path d="M12 7v5l3 2" />
                                            </svg>
                                        </span>
                                        <span className="door-mobile-report-action-text">
                                            <strong>Golden Thread</strong>
                                            <small>Previous report</small>
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="row g-3 door-main-grid">

                            <div className={`col-12 col-lg-6 door-media-column door-tab-panel door-tab-general ${reportViewTab === 'general' ? 'is-active' : ''}`}>
                                <div className="d-flex flex-column door-media-panel" style={{ height: panelHeight }}>
                                    <div className="d-flex align-items-center gap-2 mb-2 w-100 flex-wrap door-media-heading">
                                        <FontAwesomeIcon icon={faStar} />
                                        <h6 className="mb-0 fw-bold text-truncate flex-grow-1" style={{ fontSize: 'clamp(13px, 2.5vw, 15px)' }}>Inspection Media</h6>

                                        {/* {report?.aiAnnotations && (
                                            <button
                                                className={`btn rounded-pill flex-shrink-0 ${overlayEnabled ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                onClick={() => setOverlayEnabled(!overlayEnabled)}
                                                disabled={isLoadingOverlay}
                                                style={{
                                                    fontSize: 'clamp(9px, 1.6vw, 12px)',
                                                    padding: '4px 12px',
                                                    lineHeight: 1.2,
                                                    whiteSpace: 'nowrap',
                                                    width: 'fit-content',
                                                    minWidth: 'unset',
                                                }}
                                            >
                                                {isLoadingOverlay && (
                                                    <span className="spinner-border spinner-border-sm me-1" style={{ width: '9px', height: '9px' }} />
                                                )}
                                                AI {overlayEnabled ? 'On' : 'Off'}
                                            </button>
                                        )} */}

                                        {/* {activeTab === 'breakdown' && hardwareItemsRef.current.length > 0 && (
                                            <button
                                                className={`btn rounded-pill flex-shrink-0 ${isAutoPlaying ? 'btn-warning' : 'btn-outline-primary'}`}
                                                onClick={() => {
                                                    if (isAutoPlaying) {
                                                        stopAutoPlay();
                                                    } else {
                                                        const currentItems = [];
                                                        const items = filteredItemsForAutoPlay.current;
                                                        if (items && items.length > 0) {
                                                            startAutoPlay(items);
                                                        } else {
                                                            setTimeout(() => {
                                                                if (filteredItemsForAutoPlay.current.length > 0) {
                                                                    startAutoPlay(filteredItemsForAutoPlay.current);
                                                                } else {
                                                                    console.log('Still no items, forcing filter refresh');
                                                                    setBreakdownFilter(prev => prev);
                                                                }
                                                            }, 100);
                                                        }
                                                    }
                                                }}
                                                disabled={isLoadingOverlay}
                                                style={{
                                                    fontSize: 'clamp(9px, 1.6vw, 12px)',
                                                    padding: '4px 12px',
                                                    lineHeight: 1.2,
                                                    whiteSpace: 'nowrap',
                                                    width: 'fit-content',
                                                    minWidth: 'unset',
                                                }}
                                            >
                                                {isAutoPlaying ? 'Stop' : 'Play'}
                                            </button>
                                        )} */}
                                    </div>

                                    <div className="d-flex flex-column flex-lg-row gap-2 door-media-layout" style={{ height: `calc(${panelHeight} - 50px)`, flex: 1 }}>
                                        <div className="flex-grow-1 rounded-3 overflow-hidden position-relative door-media-stage" style={{ background: '#1a1a1a', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                                            <div className="position-relative w-100 h-100">
                                                {isLoadingOverlay && (
                                                    <div className="position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center"
                                                        style={{ background: 'rgba(0,0,0,0.7)', zIndex: 10 }}>
                                                        <div className="text-center">
                                                            <div className="spinner-border text-light mb-2" role="status">
                                                                <span className="visually-hidden">Loading AI overlays...</span>
                                                            </div>
                                                            <div style={{ color: 'white', fontSize: '12px' }}>Loading AI analysis...</div>
                                                        </div>
                                                    </div>
                                                )}

                                                {(!mediaType || mediaType === 'image') && (
                                                    <div
                                                        className="image-viewer-container door-touch-image-viewer"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            overflow: 'hidden',
                                                            position: 'relative',
                                                            cursor: zoom > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default',
                                                            touchAction: zoom > 1 ? 'none' : 'pan-y'
                                                        }}
                                                        onTouchStart={handleMobileImageTouchStart}
                                                        onTouchMove={handleMobileImageTouchMove}
                                                        onTouchEnd={handleMobileImageTouchEnd}
                                                        onTouchCancel={handleMobileImageTouchEnd}
                                                    >
                                                        <img
                                                            ref={imageRef}
                                                            src={getSelectedMediaUrl() || getDisplayUrl(report.doorPullPhotoLink, 'doorPullPhotoLink') || getDisplayUrl(report.doorPushPhotoLink, 'doorPushPhotoLink')}
                                                            alt="Door"
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'contain',
                                                                opacity: isLoadingOverlay ? 0.5 : 1,
                                                                transform: `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`,
                                                                transition: isDragging ? 'none' : 'transform 0.1s ease-out',
                                                                transformOrigin: 'center center',
                                                                pointerEvents: zoom > 1 ? 'auto' : 'none'
                                                            }}
                                                            onMouseDown={handleMouseDown}
                                                            onMouseMove={handleMouseMoveDrag}
                                                            onMouseUp={handleMouseUp}
                                                            onMouseLeave={handleMouseLeaveImage}
                                                            draggable={false}
                                                        />
                                                    </div>
                                                )}
                                                {mediaType === 'video' && (
                                                    <video src={selectedMedia || report.closerVideoLink} controls muted style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                                )}

                                                {mediaType !== 'video' && (
                                                    <div className="position-absolute bottom-0 end-0 d-flex gap-2 m-3" style={{ zIndex: 5 }}>
                                                        <button
                                                            className="btn btn-sm rounded-circle"
                                                            onClick={() => setZoom(prev => Math.max(0.5, prev - 0.25))}
                                                            style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.2)', width: '36px', height: '36px', padding: 0, color: 'white' }}
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                <path d="M20 12H4" />
                                                            </svg>
                                                        </button>
                                                        <span className="px-3 rounded-pill d-flex align-items-center" style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.2)', color: 'white', fontSize: '13px', fontWeight: '500' }}>
                                                            {Math.round(zoom * 100)}%
                                                        </span>
                                                        <button
                                                            className="btn btn-sm rounded-circle"
                                                            onClick={() => setZoom(prev => Math.min(5, prev + 0.25))}
                                                            style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.2)', width: '36px', height: '36px', padding: 0, color: 'white' }}
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                <path d="M12 4v16M20 12H4" />
                                                            </svg>
                                                        </button>
                                                        <button
                                                            className="btn btn-sm rounded-circle"
                                                            onClick={resetZoom}
                                                            style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.2)', width: '36px', height: '36px', padding: 0, color: 'white' }}
                                                            title="Reset zoom"
                                                        >
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                                <circle cx="12" cy="12" r="3" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                )}

                                                {/* {mediaType !== 'video' && ( */}
                                                <>
                                                    <button
                                                        className="btn position-absolute top-50 start-0 translate-middle-y ms-2"
                                                        onClick={() => navigateMedia(-1)}
                                                        style={{ background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '50%', width: '40px', height: '40px', padding: 0, color: 'white', zIndex: 4 }}
                                                    >
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <path d="M15 18l-6-6 6-6" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        className="btn position-absolute top-50 end-0 translate-middle-y me-2"
                                                        onClick={() => navigateMedia(1)}
                                                        style={{ background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '50%', width: '40px', height: '40px', padding: 0, color: 'white', zIndex: 4 }}
                                                    >
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                            <path d="M9 18l6-6-6-6" />
                                                        </svg>
                                                    </button>
                                                </>
                                                {/* )} */}

                                                <div className="position-absolute top-0 start-0 end-0 d-flex justify-content-between align-items-center px-3 py-2"
                                                    style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.6), transparent)' }}>
                                                    <span style={{ color: 'white', fontSize: '11px', fontWeight: 600 }}>
                                                        {currentMediaIndex + 1} / {totalMediaCount}
                                                    </span>
                                                    <span className="px-2 py-0 rounded-pill" style={{ background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(8px)', color: 'white', fontSize: '9px', textTransform: 'uppercase' }}>
                                                        {mediaType === 'video' ? 'Video' : 'Photo'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="d-flex flex-row flex-lg-column rounded-3 overflow-auto p-2 gap-2 door-media-strip"
                                            style={{
                                                width: window.innerWidth < 992 ? '100%' : '90px',
                                                height: window.innerWidth < 992 ? '120px' : 'auto',
                                                background: '#f8f9fa',
                                                border: '1px solid #e9ecef',
                                                scrollbarWidth: 'thin',
                                                overflowX: 'auto',
                                                overflowY: window.innerWidth < 992 ? 'hidden' : 'auto',
                                                flexDirection: window.innerWidth < 992 ? 'row' : 'column',
                                                alignItems: window.innerWidth < 992 ? 'center' : 'stretch'
                                            }}
                                            ref={thumbRef}
                                        >
                                            {[
                                                { link: report.doorPullPhotoLink, label: 'Pull', type: 'image' },
                                                { link: report.doorPushPhotoLink, label: 'Push', type: 'image' },
                                                { link: report.doorCertPhotoLink, label: 'Cert', type: 'image' },
                                                { link: report.hingePhotoLink, label: 'Hinge1', type: 'image' },
                                                { link: report.hingePhotoLink2, label: 'Hinge2', type: 'image' },
                                                { link: report.hingePhotoLink3, label: 'Hinge3', type: 'image' },
                                                { link: report.glassFireStampLink, label: 'Stamp', type: 'image' },
                                                { link: report.cupboard_contense_photo, label: 'Cupbd', type: 'image' },
                                                { link: report.lockPhotoLink, label: 'Lock1', type: 'image' },
                                                { link: report.lockPhotoLink2, label: 'Lock2', type: 'image' },
                                                { link: report.lockPhotoLink3, label: 'Lock3', type: 'image' },
                                                { link: report.letterBoxPhotoLink, label: 'Box', type: 'image' },
                                                { link: report.doorDamageLink, label: 'Dmg1', type: 'image' },
                                                { link: report.doorDamageLink2, label: 'Dmg2', type: 'image' },
                                                { link: report.doorDamageLink3, label: 'Dmg3', type: 'image' },
                                                { link: report.doorDamageLink4, label: 'Dmg4', type: 'image' },
                                                { link: report.doorDamageLink5, label: 'Dmg5', type: 'image' },
                                                { link: report.closerVideoLink, label: 'Video', type: 'video' },
                                            ].filter(item => item.link).map((item, idx) => {
                                                const isSelected = selectedMedia === item.link;
                                                return (
                                                    <div
                                                        key={idx}
                                                        onClick={() => {
                                                            setSelectedMedia(item.link);
                                                            setMediaType(item.type);
                                                            resetZoom();
                                                        }}
                                                        className="position-relative rounded-2 overflow-hidden flex-shrink-0 door-media-thumb"
                                                        style={{
                                                            width: window.innerWidth < 992 ? '70px' : '100%',
                                                            minWidth: window.innerWidth < 992 ? '70px' : 'auto',
                                                            height: window.innerWidth < 992 ? '60px' : '55px',
                                                            cursor: 'pointer',
                                                            border: isSelected ? '2px solid #fd0d21' : '1px solid #dee2e6',
                                                            transition: 'all 0.15s ease',
                                                            opacity: isSelected ? 1 : 0.75
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                                                        onMouseLeave={(e) => e.currentTarget.style.opacity = isSelected ? '1' : '0.75'}
                                                    >
                                                        {item.type === 'video' ? (
                                                            <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-dark">
                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
                                                                    <path d="M8 5v14l11-7z" />
                                                                </svg>
                                                            </div>
                                                        ) : (
                                                            <img src={item.link} alt={item.label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} loading="lazy" />
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        {window.innerWidth < 992 && (
                                            <div className="d-flex justify-content-center gap-2 mt-2 door-thumb-controls">
                                                <button
                                                    className="btn btn-sm btn-outline-secondary rounded-circle"
                                                    onClick={() => {
                                                        if (thumbRef.current) {
                                                            thumbRef.current.scrollBy({ left: -100, behavior: 'smooth' });
                                                        }
                                                    }}
                                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M15 18l-6-6 6-6" />
                                                    </svg>
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-outline-secondary rounded-circle"
                                                    onClick={() => {
                                                        if (thumbRef.current) {
                                                            thumbRef.current.scrollBy({ left: 100, behavior: 'smooth' });
                                                        }
                                                    }}
                                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M9 18l6-6-6-6" />
                                                    </svg>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={`col-12 col-lg-6 door-analysis-column door-tab-panel door-tab-analysis ${reportViewTab === 'analysis' ? 'is-active' : ''}`}>
                                <div className="bg-white rounded-3 shadow-sm d-flex flex-column door-analysis-panel" style={{ height: panelHeight, overflow: 'hidden' }}>

                                    <div className="px-3 py-2 border-bottom d-flex align-items-center gap-2 flex-shrink-0 door-analysis-header" style={{ flexWrap: window.innerWidth < 768 ? 'wrap' : 'nowrap' }}>
                                        <div className="d-flex align-items-center gap-2">
                                            <FontAwesomeIcon icon={faStar} className="text-primary" style={{ fontSize: '14px' }} />
                                            <h6 className="mb-0 fw-bold" style={{ fontSize: 'clamp(13px, 2.5vw, 15px)' }}>Door Analysis</h6>
                                        </div>

                                        <div className="d-flex ms-auto door-analysis-tabs" style={{ background: '#f8f9fa', borderRadius: '8px', padding: '2px' }}>
                                            <button
                                                className="btn btn-sm rounded-3 fw-semibold"
                                                onClick={() => setActiveTab('breakdown')}
                                                style={{
                                                    fontSize: window.innerWidth < 768 ? '10px' : '12px',
                                                    padding: window.innerWidth < 768 ? '4px 10px' : '6px 14px',
                                                    background: activeTab === 'breakdown' ? '#0d6efd' : 'transparent',
                                                    color: activeTab === 'breakdown' ? 'white' : '#6c757d',
                                                    border: 'none',
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                Breakdown
                                            </button>
                                            <button
                                                className="btn btn-sm rounded-3 fw-semibold"
                                                onClick={() => setActiveTab('required')}
                                                style={{
                                                    fontSize: window.innerWidth < 768 ? '10px' : '12px',
                                                    padding: window.innerWidth < 768 ? '4px 10px' : '6px 14px',
                                                    background: activeTab === 'required' ? '#0d6efd' : 'transparent',
                                                    color: activeTab === 'required' ? 'white' : '#6c757d',
                                                    border: 'none',
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                Work Required
                                            </button>
                                            <button
                                                className="btn btn-sm rounded-3 fw-semibold"
                                                onClick={() => setActiveTab('completed')}
                                                style={{
                                                    fontSize: window.innerWidth < 768 ? '10px' : '12px',
                                                    padding: window.innerWidth < 768 ? '4px 10px' : '6px 14px',
                                                    background: activeTab === 'completed' ? '#0d6efd' : 'transparent',
                                                    color: activeTab === 'completed' ? 'white' : '#6c757d',
                                                    border: 'none',
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                Work Completed
                                            </button>
                                        </div>

                                        {/* {report?.requiresAttention && ( */}
                                        <div className="d-flex justify-content-center door-external-check">
                                            <button
                                                className="btn btn-sm btn-warning rounded-3"
                                                disabled={report?.hasAccess === false}
                                                onClick={() => {
                                                    if (report?.hasAccess === false) return;
                                                    setShowModal1(true);
                                                }}
                                                style={{
                                                    cursor: report?.hasAccess === false ? "not-allowed" : "pointer",
                                                }}
                                            >
                                                {report?.requiresAttention
                                                    ? "Cancel Re-Inspection Request"
                                                    : "External Check"}
                                                {/* : "Request a Re-Inspection"} */}
                                            </button>
                                        </div>
                                        {/* )} */}
                                    </div>

                                    <div className="overflow-auto flex-grow-1 p-3 door-analysis-body">

                                        {activeTab === 'breakdown' && (
                                            <div>

                                                <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom" style={{ flexWrap: window.innerWidth < 768 ? 'wrap' : 'nowrap', gap: window.innerWidth < 768 ? '12px' : '0' }}>

                                                    <div className="d-flex align-items-center gap-2">
                                                        <div style={{ color: '#3b82f6' }}>
                                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                                                <line x1="12" y1="20" x2="12" y2="10"></line>
                                                                <line x1="18" y1="20" x2="18" y2="4"></line>
                                                                <line x1="6" y1="20" x2="6" y2="16"></line>
                                                            </svg>
                                                        </div>
                                                        <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '15px' }}>Breakdown</h6>
                                                    </div>

                                                    {(() => {
                                                        if (report?.hasAccess === false) {
                                                            return (
                                                                <div className="d-flex rounded-3 overflow-hidden" style={{ border: '1px solid #e9ecef' }}>
                                                                    <div className="text-center px-3 px-md-4 py-2" style={{ backgroundColor: '#f8f9fa', minWidth: '180px' }}>
                                                                        <div className="fw-bold text-muted" style={{ fontSize: window.innerWidth < 768 ? '20px' : '24px', lineHeight: '1.2' }}>
                                                                            No access
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }

                                                        const allItems = allItemsRef.current;
                                                        const totalChecks = allItems.length;
                                                        const failedChecks = allItems.filter(item => item.status === 'FAIL').length;
                                                        const passedChecks = totalChecks - failedChecks;

                                                        return (
                                                            <div className="d-flex rounded-3 overflow-hidden" style={{ border: '1px solid #e9ecef' }}>
                                                                <div className="d-flex rounded-3 overflow-hidden" style={{ border: '1px solid #e9ecef' }}>
                                                                    <div
                                                                        className="text-center px-3 px-md-4 py-2"
                                                                        style={{ backgroundColor: '#f0f4ff', minWidth: '60px' }}
                                                                    >
                                                                        <div
                                                                            className="fw-bold"
                                                                            style={{
                                                                                fontSize: window.innerWidth < 768 ? '20px' : '24px',
                                                                                lineHeight: '1.2',
                                                                                color: '#0d6efd'
                                                                            }}
                                                                        >
                                                                            {totalChecks}
                                                                        </div>
                                                                        <div style={{ fontSize: '10px', color: '#0d6efd' }}>
                                                                            Checks
                                                                        </div>
                                                                    </div>

                                                                    <div
                                                                        className="text-center px-3 px-md-4 py-2"
                                                                        style={{ backgroundColor: '#fff0f0', minWidth: '60px' }}
                                                                    >
                                                                        <div
                                                                            className="fw-bold"
                                                                            style={{
                                                                                fontSize: window.innerWidth < 768 ? '20px' : '24px',
                                                                                lineHeight: '1.2',
                                                                                color: '#dc3545'
                                                                            }}
                                                                        >
                                                                            {failedChecks}
                                                                        </div>
                                                                        <div style={{ fontSize: '10px', color: '#dc3545' }}>
                                                                            Issues
                                                                        </div>
                                                                    </div>

                                                                    <div
                                                                        className="text-center px-3 px-md-4 py-2"
                                                                        style={{ backgroundColor: '#f0fff4', minWidth: '60px' }}
                                                                    >
                                                                        <div
                                                                            className="fw-bold"
                                                                            style={{
                                                                                fontSize: window.innerWidth < 768 ? '20px' : '24px',
                                                                                lineHeight: '1.2',
                                                                                color: '#198754'
                                                                            }}
                                                                        >
                                                                            {passedChecks}
                                                                        </div>
                                                                        <div style={{ fontSize: '10px', color: '#198754' }}>
                                                                            Passed
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })()}
                                                </div>

                                                <div className="d-flex gap-1 mb-3 door-breakdown-filters" style={{ flexWrap: 'wrap' }}>
                                                    {['all', 'pass', 'fail'].map(f => (
                                                        <button key={f} className={`btn btn-sm ${breakdownFilter === f ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                            onClick={() => setBreakdownFilter(f)} style={{ fontSize: '11px', textTransform: 'capitalize', padding: '5px 12px' }}>
                                                            {f === 'all' ? 'All' : f === 'pass' ? 'Passed' : 'Failed'}
                                                        </button>
                                                    ))}
                                                </div>

                                                {isLoadingOverlay && (
                                                    <div className="text-center py-4">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="visually-hidden">Loading AI overlays...</span>
                                                        </div>
                                                        <p className="text-muted mt-2 small">Loading AI annotations...</p>
                                                    </div>
                                                )}

                                                {report?.hasAccess === false && (
                                                    <div className="text-center px-3 px-md-4 py-2" style={{ backgroundColor: '#f8f9fa', minWidth: '180px' }}>
                                                        <div className="fw-bold text-muted" style={{ fontSize: window.innerWidth < 768 ? '20px' : '24px', lineHeight: '1.2' }}>
                                                            No access
                                                        </div>
                                                        {report?.noAccessReason && (
                                                            <div className="fw-bold fst-italic text-muted mt-1">
                                                                {report.noAccessReason}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {report?.hasAccess !== false && !isLoadingOverlay && (
                                                    <div className="row g-2">
                                                        {(() => {
                                                            const rgbToHex = (c) => c ? `#${c.map(v => v.toString(16).padStart(2, '0')).join('')}` : '#6c757d';
                                                            const pullR = report?.aiAnnotations?.find(a => a.id === 'pullAiAnnotations')?.regions || [];
                                                            const pushR = report?.aiAnnotations?.find(a => a.id === 'pushAiAnnotations')?.regions || [];
                                                            const h1R = report?.aiAnnotations?.find(a => a.id === 'hingeAiAnnotations')?.regions || [];
                                                            const h2R = report?.aiAnnotations?.find(a => a.id === 'hinge2AiAnnotations')?.regions || [];
                                                            const h3R = report?.aiAnnotations?.find(a => a.id === 'hinge3AiAnnotations')?.regions || [];
                                                            const allR = [...pullR, ...pushR, ...h1R, ...h2R, ...h3R];
                                                            const dc = new Set(allR.map(r => r.cls));

                                                            const cats = [
                                                                { color: [255, 80, 80], name: 'Hinges', classes: ['hinge'], from: 'both', type: 'hardware' },
                                                                { color: [220, 80, 140], name: 'Locks & Security', classes: ['keyless_exit', 'yale_lock', 'night_latch', 'mortice_lock', 'external_lock', 'mortice_cover', 'code_lock', 'emergency_lock', 'padlock', 'keep_locked', 'bolt_latch'], from: 'push', type: 'hardware' },
                                                                { color: [140, 0, 200], name: 'Door Closer', classes: ['door_closer'], from: 'both', type: 'hardware' },
                                                                { color: [60, 180, 220], name: 'Glazing', classes: ['glass', 'safety_glass'], from: 'both', type: 'hardware' },
                                                                { color: [240, 120, 80], name: 'Handles & Push Pad', classes: ['door_handle', 'pull_handle', 'door_knob', 'push_pad'], from: 'both', type: 'hardware' },
                                                                { color: [80, 120, 220], name: 'Accessories', classes: ['door_number', 'door_bell', 'knocker', 'spyhole', 'letter_box', 'signage'], from: 'both', type: 'hardware' },
                                                                { color: [0, 160, 160], name: 'Fire & Signage', classes: ['fire_exit', 'keep_clear', 'keep_locked', 'keep_shut'], from: 'both', type: 'hardware' },
                                                                { color: [240, 180, 40], name: 'Seals & Vent', classes: ['drop_down_seal', 'ventilation'], from: 'both', type: 'hardware' },
                                                                { color: [140, 180, 80], name: 'Door & Frame', classes: ['door', 'door_damage', 'frame_damage', 'door_latch'], from: 'pull', type: 'hardware' },
                                                                { color: [0, 200, 100], name: 'Normal Screws', classes: ['normal'], from: 'hinge', type: 'hardware' },
                                                                { color: [255, 50, 50], name: 'Missing Screws', classes: ['missing'], from: 'hinge', type: 'hardware' },
                                                                { color: [255, 100, 0], name: 'Loose Screws', classes: ['loose'], from: 'hinge', type: 'hardware' },
                                                            ];

                                                            const gs = (v, t) => {
                                                                if (v == null) return { t: 'N/A', c: 'bg-secondary text-white' };
                                                                if (t === 'bottom') return (v >= 1 && v <= 8) ? { t: 'PASS', c: 'bg-success text-white' } : { t: 'FAIL', c: 'bg-danger text-white' };
                                                                return (v >= 1 && v <= 4) ? { t: 'PASS', c: 'bg-success text-white' } : { t: 'FAIL', c: 'bg-danger text-white' };
                                                            };

                                                            const items = [];

                                                            cats.forEach(cat => {
                                                                if (!cat.classes.some(c => dc.has(c))) return;
                                                                let count = 0, pc = 0, puc = 0, h1c = 0, h2c = 0, h3c = 0;
                                                                if (cat.from === 'pull') { count = pullR.filter(r => cat.classes.includes(r.cls)).length; pc = count; }
                                                                else if (cat.from === 'push') { count = pushR.filter(r => cat.classes.includes(r.cls)).length; puc = count; }
                                                                else if (cat.from === 'hinge') { h1c = h1R.filter(r => cat.classes.includes(r.cls)).length; h2c = h2R.filter(r => cat.classes.includes(r.cls)).length; h3c = h3R.filter(r => cat.classes.includes(r.cls)).length; count = h1c + h2c + h3c; }
                                                                else { pc = pullR.filter(r => cat.classes.includes(r.cls)).length; puc = pushR.filter(r => cat.classes.includes(r.cls)).length; count = pc + puc; }

                                                                if (count === 0) return;

                                                                let sl = '';
                                                                if (cat.from === 'hinge') sl = [h1c && `H1:${h1c}`, h2c && `H2:${h2c}`, h3c && `H3:${h3c}`].filter(Boolean).join(' ');
                                                                else if (cat.from === 'both') sl = pc && puc ? 'Both' : pc ? 'Pull' : 'Push';
                                                                else sl = cat.from === 'pull' ? 'Pull' : 'Push';

                                                                items.push({
                                                                    bg: rgbToHex(cat.color),
                                                                    title: cat.name,
                                                                    sub: `${count} detected${sl ? ` (${sl})` : ''}`,
                                                                    status: 'PASS',
                                                                    statusClass: 'bg-success text-white',
                                                                    categoryClasses: cat.classes.filter(c => dc.has(c)).map(c => ({ cls: c })),
                                                                    pullCount: pc, pushCount: puc, hinge1Count: h1c, hinge2Count: h2c, hinge3Count: h3c,
                                                                    type: cat.type,
                                                                    originalSub: `${count} detected${sl ? ` (${sl})` : ''}`
                                                                });
                                                            });

                                                            items.push({
                                                                bg: rgbToHex([240, 180, 40]),
                                                                title: 'Intumescent Seals',
                                                                sub: report?.doorStrips ? 'Present' : 'Missing',
                                                                status: report?.doorStrips ? 'PASS' : 'FAIL',
                                                                statusClass: report?.doorStrips ? 'bg-success text-white' : 'bg-danger text-white',
                                                                type: 'other',
                                                                originalSub: report?.doorStrips ? 'Present' : 'Missing'
                                                            });

                                                            const gc = { top: [240, 120, 80], lock: [80, 120, 220], hinge: [0, 160, 160], bottom: [180, 100, 40] };
                                                            const topGapResult = gs(parseFloat(report?.fD3), 'top');
                                                            const lockGapResult = gs(parseFloat(report?.fD1), 'side');
                                                            const hingeGapResult = gs(parseFloat(report?.fD2), 'side');
                                                            const bottomGapResult = gs(parseFloat(report?.fD4), 'bottom');

                                                            items.push({ bg: rgbToHex(gc.top), title: 'Top Side Gap', sub: report?.fD3 != null ? `${report.fD3} mm` : 'N/A', status: topGapResult.t, statusClass: topGapResult.c, type: 'measurement', originalSub: report?.fD3 != null ? `${report.fD3} mm` : 'N/A' });
                                                            items.push({ bg: rgbToHex(gc.lock), title: 'Lock Side Gap', sub: report?.fD1 != null ? `${report.fD1} mm` : 'N/A', status: lockGapResult.t, statusClass: lockGapResult.c, type: 'measurement', originalSub: report?.fD1 != null ? `${report.fD1} mm` : 'N/A' });
                                                            items.push({ bg: rgbToHex(gc.hinge), title: 'Hinge Side Gap', sub: report?.fD2 != null ? `${report.fD2} mm` : 'N/A', status: hingeGapResult.t, statusClass: hingeGapResult.c, type: 'measurement', originalSub: report?.fD2 != null ? `${report.fD2} mm` : 'N/A' });
                                                            items.push({ bg: rgbToHex(gc.bottom), title: 'Bottom Side Gap', sub: report?.fD4 != null ? `${report.fD4} mm` : 'N/A', status: bottomGapResult.t, statusClass: bottomGapResult.c, type: 'measurement', originalSub: report?.fD4 != null ? `${report.fD4} mm` : 'N/A' });

                                                            const workToFeatureMapping = {
                                                                'doorCloseAsIntented': ['Repair Door Closer', 'Adjust Door Closer', 'Install New Door Closer', 'Replace Door Closer'],
                                                                'doorStrips': ['Install Intumescent Strips', 'Replace Damaged Intumescent Strip', 'Replace Missing Intumescent Strip', 'Intumescent Strip Installed Incorrectly'],
                                                                'hingesWorking': ['Screws Missing From Hinge', 'Tighten Hinge', 'Install Third Fire Rated Hinge', 'Replace Broken Hinge'],
                                                                'hingesFireRating': ['Replace Non-Compliant Hinge'],
                                                                'lockFireRated': ['Replace Non-Compliant Locks'],
                                                                'keylessExit': ['Install Keyless Exit'],
                                                                'letterBoxFireRated': ['Upgrade Non-Compliant LetterBox'],
                                                                'door': ['Replace Damaged Door', 'Repair Damaged Door', 'Replace Non-Compliant Door', 'Other (Door)'],
                                                                'frame': ['Repair Damaged Door Frame', 'Replace damaged door frame', 'Other (Frame)'],
                                                                'glass': ['Replace Cracked Glass', 'Replace Non-Compliant Glass', 'Refix Loose Glazing Beads', 'Replace Glazing Beads', 'Other (Glass)'],
                                                                'ventilation': ['Clear Blocked Ventilation Gaps', 'Install Additional Gaps If Needed', 'Other (Ventilation)'],
                                                            };

                                                            const failedFeatures = new Set();

                                                            const doorCloserItem = items.find(item => item.title === 'Door Closer');
                                                            if (doorCloserItem && doorCloserItem.status === 'FAIL') failedFeatures.add('doorCloseAsIntented');

                                                            const sealsItem = items.find(item => item.title === 'Intumescent Seals');
                                                            if (sealsItem && sealsItem.status === 'FAIL') failedFeatures.add('doorStrips');

                                                            const hingesItem = items.find(item => item.title === 'Hinges');
                                                            if (hingesItem && hingesItem.status === 'FAIL') {
                                                                failedFeatures.add('hingesWorking');
                                                                failedFeatures.add('hingesFireRating');
                                                            }

                                                            const locksItem = items.find(item => item.title === 'Locks & Security');
                                                            if (locksItem && locksItem.status === 'FAIL') {
                                                                failedFeatures.add('lockFireRated');
                                                                failedFeatures.add('keylessExit');
                                                            }

                                                            const accessoriesItem = items.find(item => item.title === 'Accessories');
                                                            if (accessoriesItem && accessoriesItem.status === 'FAIL') {
                                                                failedFeatures.add('letterBoxFireRated');
                                                            }

                                                            const doorFrameItem = items.find(item => item.title === 'Door & Frame');
                                                            if (doorFrameItem && doorFrameItem.status === 'FAIL') {
                                                                failedFeatures.add('door');
                                                                failedFeatures.add('frame');
                                                            }

                                                            const glazingItem = items.find(item => item.title === 'Glazing');
                                                            if (glazingItem && glazingItem.status === 'FAIL') failedFeatures.add('glass');

                                                            const sealsVentItem = items.find(item => item.title === 'Seals & Vent');
                                                            if (sealsVentItem && sealsVentItem.status === 'FAIL') failedFeatures.add('ventilation');

                                                            const failingGaps = [];
                                                            if (topGapResult.t === 'FAIL') failingGaps.push('top');
                                                            if (lockGapResult.t === 'FAIL') failingGaps.push('lock');
                                                            if (hingeGapResult.t === 'FAIL') failingGaps.push('hinge');
                                                            if (bottomGapResult.t === 'FAIL') failingGaps.push('bottom');

                                                            const workNeededItems = [];
                                                            const processedWorkItems = new Set();

                                                            const getSimplifiedTitle = (text) => {
                                                                const textLower = text.toLowerCase();
                                                                if (textLower.includes('door closer') || textLower.includes('closer')) return 'Closer';
                                                                if (textLower.includes('hinge')) return 'Hinges';
                                                                if (textLower.includes('lock')) return 'Locks & Security';
                                                                if (textLower.includes('intumescent') || textLower.includes('strip')) return 'Intumescent Seals';
                                                                if (textLower.includes('glass')) return 'Glazing';
                                                                if (textLower.includes('door') && (textLower.includes('replace') || textLower.includes('repair'))) return 'Door & Frame';
                                                                if (textLower.includes('frame')) return 'Door & Frame';
                                                                if (textLower.includes('letterbox') || textLower.includes('letter box')) return 'Accessories';
                                                                if (textLower.includes('ventilation') || textLower.includes('gap')) return 'Seals & Vent';
                                                                if (textLower.includes('handle') || textLower.includes('push pad')) return 'Handles & Push Pad';
                                                                return text.split(' ').slice(0, 2).join(' ');
                                                            };

                                                            (report.workNeeded || "")
                                                                .split(/\n|\|/)
                                                                .map((line) => line.trim())
                                                                .filter((line) => line)
                                                                .forEach((line) => {
                                                                    const lineLower = line.toLowerCase();
                                                                    let shouldSkip = false;

                                                                    if (lineLower.includes('gap')) {
                                                                        for (const gap of failingGaps) {
                                                                            if (lineLower.includes(gap)) {
                                                                                shouldSkip = true;
                                                                                break;
                                                                            }
                                                                        }
                                                                    }

                                                                    if (!shouldSkip) {
                                                                        for (const [feature, workItems] of Object.entries(workToFeatureMapping)) {
                                                                            if (failedFeatures.has(feature)) {
                                                                                const isMatch = workItems.some(wi =>
                                                                                    lineLower.includes(wi.toLowerCase()) || wi.toLowerCase().includes(lineLower)
                                                                                );
                                                                                if (isMatch) {
                                                                                    shouldSkip = true;
                                                                                    break;
                                                                                }
                                                                            }
                                                                        }
                                                                    }

                                                                    if (!shouldSkip && !processedWorkItems.has(line)) {
                                                                        processedWorkItems.add(line);
                                                                        const simplifiedTitle = getSimplifiedTitle(line);
                                                                        workNeededItems.push({
                                                                            bg: rgbToHex([255, 100, 100]),
                                                                            title: simplifiedTitle,
                                                                            sub: line,
                                                                            status: 'FAIL',
                                                                            statusClass: 'bg-danger text-white',
                                                                            type: 'work-needed',
                                                                            isWorkNeeded: true,
                                                                            categoryClasses: []
                                                                        });
                                                                    }
                                                                });

                                                            workNeededItems.forEach(workItem => {
                                                                const matchingItem = items.find(item => item.title === workItem.title);
                                                                if (matchingItem && !matchingItem.hasMultipleWork) {

                                                                    matchingItem.sub = workItem.sub;
                                                                    matchingItem.status = 'FAIL';
                                                                    matchingItem.statusClass = 'bg-danger text-white';
                                                                    matchingItem.mergedWork = true;
                                                                    matchingItem.hasMultipleWork = true;
                                                                    matchingItem.originalTitle = matchingItem.title;
                                                                } else if (matchingItem && matchingItem.hasMultipleWork) {
                                                                    items.push({
                                                                        ...workItem,
                                                                        title: matchingItem.originalTitle,
                                                                        originalTitle: matchingItem.originalTitle
                                                                    });
                                                                    matchingItem.workCount = (matchingItem.workCount || 1) + 1;
                                                                } else {
                                                                    items.push(workItem);
                                                                }
                                                            });

                                                            // items.forEach(item => {
                                                            //     if (item.originalTitle && item.workCount) {
                                                            //         item.title = `${item.originalTitle} (${item.workCount})`;
                                                            //     }
                                                            // });

                                                            const hardwareOnly = items.filter(item => item.type === 'hardware');
                                                            hardwareItemsRef.current = hardwareOnly;

                                                            allItemsRef.current = [...items];

                                                            let displayItems = [];

                                                            if (breakdownFilter === 'all') {
                                                                displayItems = [...items];
                                                            } else if (breakdownFilter === 'fail') {
                                                                displayItems = items.filter(item => item.status === 'FAIL');
                                                            } else if (breakdownFilter === 'pass') {
                                                                displayItems = items.filter(item => item.status === 'PASS');
                                                            }

                                                            const seenKeys = new Set();
                                                            displayItems = displayItems.filter(item => {
                                                                const uniqueKey = `${item.title}_${item.sub}_${item.status}`;
                                                                if (seenKeys.has(uniqueKey)) {
                                                                    return false;
                                                                }
                                                                seenKeys.add(uniqueKey);
                                                                return true;
                                                            });

                                                            displayItems.sort((a, b) => a.title.localeCompare(b.title));

                                                            filteredItemsForAutoPlay.current = displayItems;

                                                            if (displayItems.length === 0) {
                                                                return <div className="col-12 text-center py-4 text-muted"><small>No items found</small></div>;
                                                            }

                                                            return displayItems.map((item, idx) => (
                                                                <div key={idx} className="col-12 col-sm-6" data-ai-item={idx + 1}>
                                                                    <div className="d-flex align-items-center justify-content-between p-2 border rounded-3 h-100 door-check-card"
                                                                        style={{
                                                                            cursor: item.categoryClasses?.length > 0 ? 'pointer' : 'default',
                                                                            background: highlightedNumber === (idx + 1) ? '#f0f4ff' : '#fafbfc',
                                                                            borderLeft: `4px solid ${item.bg}`,
                                                                            transition: 'all 0.15s ease',
                                                                            minHeight: '62px',
                                                                            transform: highlightedNumber === (idx + 1) ? 'translateY(-2px)' : 'none',
                                                                            boxShadow: highlightedNumber === (idx + 1) ? '0 4px 12px rgba(0,0,0,0.15)' : 'none'
                                                                        }}
                                                                        onMouseEnter={() => handleAIItemHover({ ...item, num: idx + 1 })}
                                                                        onMouseLeave={() => handleAIItemLeave()}>

                                                                        <div className="d-flex align-items-center gap-2 flex-grow-1">
                                                                            <div className="rounded-2 d-flex align-items-center justify-content-center fw-bold flex-shrink-0"
                                                                                style={{
                                                                                    width: '28px',
                                                                                    height: '28px',
                                                                                    backgroundColor: '#e9ecef',
                                                                                    color: item.bg,
                                                                                    fontSize: '12px'
                                                                                }}>
                                                                                {idx + 1}
                                                                            </div>
                                                                            <div className="flex-grow-1">
                                                                                <div className="fw-bold" style={{ fontSize: '12px', lineHeight: '1.3' }}>{item.title}</div>
                                                                                <div className="text-muted" style={{ fontSize: '10px', lineHeight: '1.3' }}>{item.sub}</div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="d-flex align-items-center gap-1 flex-shrink-0">
                                                                            {breakdownFilter === 'fail' && item.status === 'FAIL' && (
                                                                                <button
                                                                                    className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        const searchText = item.type === 'work-needed' ? item.sub : item.title;
                                                                                        showInfo(searchText, item.title, item.sub);
                                                                                    }}
                                                                                    style={{
                                                                                        width: '24px',
                                                                                        height: '24px',
                                                                                        padding: 0,
                                                                                        border: '1px solid #6c757d',
                                                                                        background: 'white',
                                                                                        color: '#212529',
                                                                                        fontSize: '12px',
                                                                                        fontWeight: 'bold',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                    title="More information"
                                                                                >
                                                                                    ?
                                                                                </button>
                                                                            )}
                                                                            <span className={`badge rounded-pill ${item.statusClass}`} style={{ fontSize: '10px', fontWeight: 700, padding: '5px 10px', letterSpacing: '0.5px' }}>
                                                                                {item.status}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ));
                                                        })()}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {report?.hasAccess === false && activeTab === 'required' && (
                                            <div className="text-center px-3 px-md-4 py-2" style={{ backgroundColor: '#f8f9fa', minWidth: '180px' }}>
                                                <div className="fw-bold text-muted" style={{ fontSize: window.innerWidth < 768 ? '20px' : '24px', lineHeight: '1.2' }}>
                                                    No access
                                                </div>
                                                {report?.noAccessReason && (
                                                    <div className="fw-bold fst-italic text-muted mt-1">
                                                        {report.noAccessReason}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {report?.hasAccess !== false && activeTab === 'required' && (
                                            <>
                                                {report?.workNeeded && workItemsSorted?.length > 0 ? (
                                                    <div className="row g-3">
                                                        {workItemsSorted.map((item, index) => (
                                                            <div key={index} className="col-12 col-sm-6">
                                                                <div className="d-flex align-items-start p-3 rounded-3 h-100"
                                                                    style={{ background: riskStyles[item.risk]?.bg || '#f8f9fa', border: `1px solid ${riskStyles[item.risk]?.color || '#dee2e6'}20` }}>
                                                                    <div className="d-flex flex-column gap-2 flex-grow-1">
                                                                        <div className="d-flex align-items-center justify-content-between">
                                                                            <span className="fw-bold text-muted" style={{ fontSize: '13px' }}>{String(index + 1).padStart(2, '0')}</span>
                                                                            <button
                                                                                className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                                                onClick={() => navigateToAIBreakdown(item.text || item, index)}
                                                                                style={{
                                                                                    width: '28px',
                                                                                    height: '28px',
                                                                                    padding: 0,
                                                                                    border: '1px solid #6c757d',
                                                                                    background: 'white',
                                                                                    color: '#212529',
                                                                                    fontSize: '12px',
                                                                                    fontWeight: 'bold'
                                                                                }}
                                                                                title="View in Breakdown"
                                                                            >
                                                                                i
                                                                            </button>
                                                                        </div>
                                                                        <span style={{ fontSize: '13px', lineHeight: '1.5' }}>
                                                                            {workItemDisplayLabels[(item.text || item).toLowerCase()] ||
                                                                                toTitleCase(item.text || item)}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <div className="text-center py-5">
                                                        <div className="rounded-circle bg-success-subtle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '56px', height: '56px' }}>
                                                            <svg width="28" height="28" viewBox="0 0 24 24" fill="#198754"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" /></svg>
                                                        </div>
                                                        <p className="text-muted mb-1 fw-semibold" style={{ fontSize: '15px' }}>No Work Required</p>
                                                        <small className="text-muted" style={{ fontSize: '13px' }}>All inspection points passed</small>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {report?.hasAccess === false && activeTab === 'completed' && (
                                            <div className="text-center px-3 px-md-4 py-2" style={{ backgroundColor: '#f8f9fa', minWidth: '180px' }}>
                                                <div className="fw-bold text-muted" style={{ fontSize: window.innerWidth < 768 ? '20px' : '24px', lineHeight: '1.2' }}>
                                                    No access
                                                </div>
                                                {report?.noAccessReason && (
                                                    <div className="fw-bold fst-italic text-muted mt-1">
                                                        {report.noAccessReason}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {report?.hasAccess !== false && activeTab === 'completed' && (
                                            <div className="d-flex align-items-center justify-content-center h-100" style={{ minHeight: '200px' }}>
                                                {report?.workDone ? (
                                                    <div className="text-center py-4">
                                                        <div className="rounded-circle bg-success-subtle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '48px', height: '48px' }}>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="#198754"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" /></svg>
                                                        </div>
                                                        {report.workDoneUpdatedAt && (
                                                            <small className="text-muted d-block mb-2" style={{ fontSize: '12px' }}>Modified: {formatToAlternate(report.workDoneUpdatedAt)}</small>
                                                        )}
                                                        <div className="bg-light rounded-3 p-3 mb-3 mx-auto" style={{ maxWidth: '350px' }}>
                                                            <p className="mb-0 fw-medium" style={{ fontSize: '14px' }}>{toTitleCase(report.workDone)}</p>
                                                        </div>
                                                        <button className="btn btn-outline-success btn-sm rounded-pill px-4" onClick={handleOpenModal} style={{ fontSize: '13px' }}>Modify</button>
                                                    </div>
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <div className="rounded-circle bg-light d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '48px', height: '48px' }}>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="#adb5bd"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" /></svg>
                                                        </div>
                                                        <p className="text-muted mb-2 fw-semibold" style={{ fontSize: '14px' }}>No Work Completed</p>
                                                        <small className="text-muted d-block mb-3" style={{ fontSize: '12px' }}>Submit when ready</small>
                                                        <button className="btn btn-success btn-sm rounded-pill px-4" onClick={handleOpenModal} style={{ fontSize: '13px' }}>Submit Work</button>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    {report.requiresReview === true ||
                        (report.date !== "" && report.doorNumber !== "") ? (
                        <div className={`row mt-4 mx-0 door-history-section door-tab-panel door-tab-history ${reportViewTab === 'history' ? 'is-active' : ''}`}>
                            <div className="col-12">
                                <div className="bg-white rounded-3 shadow-sm overflow-hidden">

                                    <div className="door-history-mobile-title">
                                        <div>
                                            <div className="door-history-mobile-title-main">Inspection history</div>
                                            <div className="door-history-mobile-title-sub">Previous inspection events and media</div>
                                        </div>
                                    </div>

                                    {report.requiresReview === true ||
                                        (report.date !== "" &&
                                            // report.doorLevel !== "" &&
                                            report.doorNumber !== "") ? (
                                        <Accordion
                                            activeKey={activeKey4}
                                            onSelect={(eventKey) => setactiveKey4(eventKey)}
                                            className="card border border-danger d-block door-history-accordion"
                                            style={{ borderRadius: "15px", marginBottom: "20px" }}
                                        >
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>
                                                    <div
                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "32px",
                                                            height: "32px",
                                                        }}
                                                    >
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="currentColor"
                                                        >
                                                            <path d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
                                                        </svg>
                                                    </div>

                                                    <div>
                                                        <h6 className="mb-0 fw-bold" style={{ fontSize: "15px" }}>
                                                            Inspection History
                                                        </h6>
                                                    </div>
                                                </Accordion.Header>

                                                <Accordion.Body>
                                                    {doorHistory.length > 0 ? (
                                                        <div className="space-y-2">
                                                            {[...doorHistory]
                                                                .filter(entry => !(report?.hasAccess === false && entry.type === "workneeded"))
                                                                .reverse()
                                                                .map((entry, i) => {
                                                                    let bgClass = "";
                                                                    let textClass = "";
                                                                    let borderClass = "";
                                                                    let icon = "✅";

                                                                    if (entry.type === "no-access") {
                                                                        bgClass = "bg-secondary-subtle";
                                                                        textClass = "text-muted fw-semibold";
                                                                        borderClass = "border-start border-4 border-secondary";
                                                                        icon = "🚫";
                                                                    } else if (entry.type === "failed") {
                                                                        bgClass = "bg-danger-subtle";
                                                                        textClass = "text-danger fw-semibold";
                                                                        borderClass = "border-start border-4 border-danger";
                                                                        icon = "❌";
                                                                    } else if (entry.type === "reinspect") {
                                                                        bgClass = "bg-warning-subtle";
                                                                        textClass = "text-warning fw-semibold";
                                                                        borderClass = "border-start border-4 border-warning";
                                                                        icon = "🔧";
                                                                    } else {
                                                                        bgClass = "bg-success-subtle";
                                                                        textClass = "text-success fw-semibold";
                                                                        borderClass = "border-start border-4 border-success";
                                                                        icon = "✅";
                                                                    }

                                                                    return (
                                                                        <div
                                                                            key={i}
                                                                            className={`d-flex justify-content-between align-items-center p-2 rounded shadow-sm mb-2 ${bgClass} ${borderClass}`}
                                                                        >
                                                                            <div className={`d-flex align-items-center gap-2 ${textClass}`}>
                                                                                <span className="fs-5">{icon}</span>
                                                                                <span>
                                                                                    {entry.text.split(/(\(.*?\))/g).map((part, idx) =>
                                                                                        part.startsWith("(") && part.endsWith(")") ? (
                                                                                            <span key={idx} className="text-dark fw-semibold">
                                                                                                {part}
                                                                                            </span>
                                                                                        ) : (
                                                                                            <span key={idx}>{part}</span>
                                                                                        )
                                                                                    )}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>
                                                    ) : (
                                                        <p className="text-sm text-gray-600 italic">
                                                            No previous history found for this door.
                                                        </p>
                                                    )}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    ) : null
                                    }

                                    {doorHistory.length > 0 ? (
                                        <div>
                                            <div
                                                className="d-flex flex-nowrap overflow-x-auto overflow-y-hidden justify-content-start gap-2 px-3 py-2 border-bottom door-history-tabs"
                                                style={{
                                                    scrollbarWidth: "thin",
                                                    WebkitOverflowScrolling: "touch",
                                                }}
                                            >
                                                {report?.requiresAttention && report?.inspectionChanged && (
                                                    <div className="flex-shrink-0">
                                                        <button
                                                            type="button"
                                                            className={`btn btn-sm rounded-pill fw-semibold ${selectedIndexPhoto === "external" ? "btn-warning" : "btn-outline-warning"}`}
                                                            onClick={() => {
                                                                setFade(true);
                                                                setTimeout(() => {
                                                                    setSelectedIndexPhoto("external");
                                                                    setFade(false);
                                                                }, 250);
                                                            }}
                                                            style={{
                                                                fontSize: "12px",
                                                                padding: "6px 14px",
                                                                whiteSpace: "nowrap",
                                                                transition: "0.3s",
                                                            }}
                                                        >
                                                            <i className="fas fa-exclamation-triangle me-1"></i>
                                                            External Check
                                                        </button>
                                                    </div>
                                                )}

                                                {[...doorHistory].reverse().map((entry, i) => {
                                                    const rawLabel =
                                                        entry.date ||
                                                        entry.inspectionDate ||
                                                        entry.workDoneUpdatedAt ||
                                                        entry.createdAt ||
                                                        "";
                                                    const label = formatDate(rawLabel);

                                                    let btnClass = "btn-outline-secondary";
                                                    if (entry.type === "failed") {
                                                        btnClass = "btn-outline-danger";
                                                    } else if (entry.type === "reinspect") {
                                                        btnClass = "btn-outline-warning";
                                                    } else if (
                                                        entry.type === "passed" ||
                                                        entry.type === "fixed" ||
                                                        entry.type === "completed"
                                                    ) {
                                                        btnClass = "btn-outline-success";
                                                    }

                                                    if (i === selectedIndexPhoto) {
                                                        btnClass = btnClass.replace("outline-", "");
                                                    }

                                                    return (
                                                        <div key={i} className="flex-shrink-0">
                                                            <button
                                                                type="button"
                                                                className={`btn btn-sm rounded-pill fw-semibold ${btnClass}`}
                                                                onClick={() => {
                                                                    if (i !== selectedIndexPhoto) {
                                                                        setFade(true);
                                                                        setTimeout(() => {
                                                                            setSelectedIndexPhoto(i);
                                                                            setFade(false);
                                                                        }, 250);
                                                                    }
                                                                }}
                                                                style={{
                                                                    fontSize: "12px",
                                                                    padding: "6px 14px",
                                                                    whiteSpace: "nowrap",
                                                                    transition: "0.3s",
                                                                }}
                                                            >
                                                                {label}
                                                            </button>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            <div className={`p-3 transition-slide ${!fade ? "show" : ""}`}>
                                                {selectedIndexPhoto === "external" ? (
                                                    report?.doorPhotoLink ? (
                                                        <div className="d-flex gap-3 overflow-auto pb-2 door-history-media" style={{ scrollbarWidth: "thin" }}>
                                                            <div
                                                                className="flex-shrink-0 rounded-3 overflow-hidden position-relative door-history-media-card"
                                                                style={{ width: "200px", height: "150px", cursor: "pointer", transition: "transform 0.2s ease" }}
                                                                onClick={() => {
                                                                    setSelectedMedia(report.doorPhotoLink);
                                                                    setMediaType("image");
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                                                                onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                                                            >
                                                                <img
                                                                    src={report.doorPhotoLink}
                                                                    alt="External Check"
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit: "cover",
                                                                    }}
                                                                />
                                                                <div
                                                                    className="position-absolute bottom-0 start-0 end-0 p-2"
                                                                    style={{
                                                                        background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                                                                    }}
                                                                >
                                                                    <small style={{ color: "white", fontSize: "10px", fontWeight: 600 }}>
                                                                        External Check
                                                                    </small>
                                                                    {report?.inspectionChanged !== null && (
                                                                        <span
                                                                            className={`badge ms-1 ${report.inspectionChanged ? "bg-danger" : "bg-success"}`}
                                                                            style={{ fontSize: "8px" }}
                                                                        >
                                                                            {report.inspectionChanged ? "Changed" : "Same"}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center text-muted py-4">
                                                            No photo available for this external check.
                                                        </div>
                                                    )
                                                ) : (
                                                    (() => {
                                                        const reversed = [...doorHistory].reverse();
                                                        const entry = reversed[selectedIndexPhoto] || {};

                                                        const rawDate =
                                                            entry.date || entry.inspectionDate || entry.workDoneUpdatedAt || entry.createdAt || "";
                                                        const sameDateEntries = reversed.filter((e) => {
                                                            const eDate =
                                                                e.date || e.inspectionDate || e.workDoneUpdatedAt || e.createdAt || "";
                                                            return formatDate(eDate) === formatDate(rawDate);
                                                        });

                                                        const getMediaItems = (e, includeWorkDone = true) => {
                                                            const mediaFromArray = Array.isArray(e.media) && e.media.length ? e.media : null;

                                                            const baseItems = (
                                                                mediaFromArray
                                                                    ? mediaFromArray
                                                                    : [
                                                                        { link: e.closerVideoLink, title: "Closer Video", isVideo: true },
                                                                        { link: e.doorPullPhotoLink, title: "Pull Side", isVideo: false },
                                                                        { link: e.doorPushPhotoLink, title: "Push Side", isVideo: false },
                                                                        { link: e.doorCertPhotoLink, title: "Certification", isVideo: false },
                                                                        { link: e.hingePhotoLink, title: "Hinge 1", isVideo: false },
                                                                        { link: e.hingePhotoLink2, title: "Hinge 2", isVideo: false },
                                                                        { link: e.hingePhotoLink3, title: "Hinge 3", isVideo: false },
                                                                        { link: e.glassFireStampLink, title: "Fire Stamp", isVideo: false },
                                                                        { link: e.cupboard_contense_photo, title: "Cupboard", isVideo: false },
                                                                        { link: e.lockPhotoLink, title: "Lock 1", isVideo: false },
                                                                        { link: e.lockPhotoLink2, title: "Lock 2", isVideo: false },
                                                                        { link: e.lockPhotoLink3, title: "Lock 3", isVideo: false },
                                                                        { link: e.letterBoxPhotoLink, title: "Letter Box", isVideo: false },
                                                                        { link: e.doorDamageLink, title: "Damage 1", isVideo: false },
                                                                        { link: e.doorDamageLink2, title: "Damage 2", isVideo: false },
                                                                        { link: e.doorDamageLink3, title: "Damage 3", isVideo: false },
                                                                        { link: e.doorDamageLink4, title: "Damage 4", isVideo: false },
                                                                        { link: e.doorDamageLink5, title: "Damage 5", isVideo: false },
                                                                    ]
                                                            ).filter((item) => !!(item && item.link));

                                                            const isVideoFromUrl = (url) => {
                                                                if (!url) return false;
                                                                const lowerUrl = url.toLowerCase();
                                                                const videoExtensions = ['.mp4', '.mov', '.avi', '.webm', '.mkv', '.m4v', '.3gp'];
                                                                return videoExtensions.some(ext => lowerUrl.includes(ext));
                                                            };

                                                            if (includeWorkDone && e.workDonePhoto?.length) {
                                                                baseItems.push(
                                                                    ...e.workDonePhoto.map((url, j) => ({
                                                                        link: url,
                                                                        title: `Work Done ${j + 1}`,
                                                                        isVideo: isVideoFromUrl(url),
                                                                    }))
                                                                );
                                                            }
                                                            return baseItems;
                                                        };

                                                        const combinedMedia = [];
                                                        if (sameDateEntries.length > 1) {
                                                            combinedMedia.push(...getMediaItems(entry, false));
                                                            combinedMedia.push(...getMediaItems(entry, true));
                                                        } else {
                                                            combinedMedia.push(...getMediaItems(entry, true));
                                                        }

                                                        if (!combinedMedia.length) {
                                                            return (
                                                                <div className="text-center text-muted py-4">
                                                                    No media available for this entry.
                                                                </div>
                                                            );
                                                        }

                                                        return (
                                                            <div
                                                                className="d-flex gap-3 overflow-auto pb-2"
                                                                style={{
                                                                    scrollbarWidth: "thin",
                                                                    scrollbarColor: "#dee2e6 transparent"
                                                                }}
                                                            >
                                                                {combinedMedia.map((item, idx) => (
                                                                    <div
                                                                        key={idx}
                                                                        className="flex-shrink-0 rounded-3 overflow-hidden position-relative shadow-sm door-history-media-card"
                                                                        style={{
                                                                            width: "200px",
                                                                            height: "150px",
                                                                            cursor: "pointer",
                                                                            transition: "all 0.3s ease-in-out",
                                                                            opacity: fade ? 0 : 1,
                                                                            transform: fade ? "scale(0.95)" : "scale(1)",
                                                                        }}
                                                                        onClick={() => {
                                                                            setSelectedMedia(item.link);
                                                                            setMediaType(item.isVideo ? "video" : "image");
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.currentTarget.style.transform = "scale(1.05)";
                                                                            e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.currentTarget.style.transform = fade ? "scale(0.95)" : "scale(1)";
                                                                            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
                                                                        }}
                                                                    >
                                                                        {item.isVideo ? (
                                                                            <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-dark gap-2">
                                                                                <div
                                                                                    className="rounded-circle bg-white bg-opacity-25 d-flex align-items-center justify-content-center"
                                                                                    style={{ width: "48px", height: "48px" }}
                                                                                >
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                                                                                        <path d="M8 5v14l11-7z" />
                                                                                    </svg>
                                                                                </div>
                                                                                <small style={{ color: "white", fontSize: "10px", fontWeight: 500 }}>
                                                                                    Play Video
                                                                                </small>
                                                                            </div>
                                                                        ) : (
                                                                            <img
                                                                                src={item.link}
                                                                                alt={item.title}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    objectFit: "cover",
                                                                                }}
                                                                                loading="lazy"
                                                                            />
                                                                        )}

                                                                        <div
                                                                            className="position-absolute bottom-0 start-0 end-0 p-2"
                                                                            style={{
                                                                                background: "linear-gradient(to top, rgba(0,0,0,0.8), transparent)",
                                                                            }}
                                                                        >
                                                                            <small style={{ color: "white", fontSize: "10px", fontWeight: 600 }}>
                                                                                {item.title}
                                                                            </small>
                                                                        </div>

                                                                    </div>
                                                                ))}
                                                            </div>
                                                        );
                                                    })()
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="text-center text-muted py-5">
                                            <div
                                                className="rounded-circle bg-light d-inline-flex align-items-center justify-content-center mb-3"
                                                style={{ width: "56px", height: "56px" }}
                                            >
                                                <svg width="28" height="28" viewBox="0 0 24 24" fill="#adb5bd">
                                                    <path d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
                                                </svg>
                                            </div>
                                            <p className="fw-semibold" style={{ fontSize: "14px" }}>
                                                No previous history found
                                            </p>
                                            <small style={{ fontSize: "12px" }}>
                                                Inspection history will appear here after future inspections.
                                            </small>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>

            {showInfoPopup && (
                <WorkInfoPopup
                    show={showInfoPopup}
                    onClose={() => setShowInfoPopup(false)}
                    content={popupContent}
                />
            )}

            <ReactModal
                isOpen={showModal1}
                onRequestClose={closeModal}
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEsc={!loading}
                style={{
                    overlay: {
                        backgroundColor: "rgba(0,0,0,0.6)",
                        backdropFilter: "blur(3px)",
                        zIndex: 30020,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    content: {
                        position: "relative",
                        inset: "unset",
                        maxWidth: "420px",
                        width: "90%",
                        borderRadius: "14px",
                        padding: "22px",
                        border: "none",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                        zIndex: 30021
                    }
                }}
            >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                    <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>Confirm Action</h3>
                </div>

                <p style={{ fontSize: "14px", color: "#555", marginBottom: "15px", lineHeight: "1.5" }}>
                    {report?.requiresAttention
                        ? "This door is already marked as external checked. Do you want to undo it?"
                        : "Are you sure you want to mark this door as external checked? Please take a photo."}
                </p>

                {!report?.requiresAttention && (
                    <>
                        <div style={{ marginBottom: "15px" }}>
                            <p style={{ fontSize: "14px", fontWeight: "500", color: "#333", marginBottom: "8px" }}>
                                Has anything changed since last inspection?
                            </p>
                            <div style={{ display: "flex", gap: "10px" }}>
                                <button
                                    type="button"
                                    onClick={() => setInspectionChanged(true)}
                                    style={{
                                        flex: 1,
                                        padding: "9px",
                                        borderRadius: "8px",
                                        border: `2px solid ${inspectionChanged === true ? "#22c55e" : "#ddd"}`,
                                        background: inspectionChanged === true ? "#f0fdf4" : "#fff",
                                        color: inspectionChanged === true ? "#16a34a" : "#555",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                        transition: "0.2s",
                                    }}
                                >
                                    Yes
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setInspectionChanged(false)}
                                    style={{
                                        flex: 1,
                                        padding: "9px",
                                        borderRadius: "8px",
                                        border: `2px solid ${inspectionChanged === false ? "#ef4444" : "#ddd"}`,
                                        background: inspectionChanged === false ? "#fef2f2" : "#fff",
                                        color: inspectionChanged === false ? "#dc2626" : "#555",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                        transition: "0.2s",
                                    }}
                                >
                                    No
                                </button>
                            </div>
                        </div>

                        <input
                            type="file"
                            accept="image/*"
                            capture="environment"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={(e) => {
                                if (e.target.files && e.target.files[0]) {
                                    setSelectedImage(e.target.files[0]);
                                }
                            }}
                        />
                        {!selectedImage ? (
                            <label
                                onClick={() => fileInputRef.current.click()}
                                style={{
                                    display: "block",
                                    border: "2px dashed #ddd",
                                    borderRadius: "10px",
                                    padding: "20px",
                                    textAlign: "center",
                                    cursor: "pointer"
                                }}
                            >
                                <div style={{ fontSize: "14px", color: "#777" }}>
                                    Tap to take a photo
                                </div>
                            </label>
                        ) : (
                            <div style={{ marginTop: "10px" }}>
                                <img
                                    src={URL.createObjectURL(selectedImage)}
                                    alt="Preview"
                                    style={{
                                        width: "100%",
                                        height: "220px",
                                        objectFit: "cover",
                                        borderRadius: "10px"
                                    }}
                                />
                                <button
                                    onClick={() => fileInputRef.current.click()}
                                    style={{
                                        marginTop: "8px",
                                        fontSize: "13px",
                                        background: "none",
                                        border: "none",
                                        color: "#007bff",
                                        cursor: "pointer"
                                    }}
                                >
                                    Retake photo
                                </button>
                            </div>
                        )}
                    </>
                )}

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "22px" }}>
                    <button
                        onClick={closeModal}
                        disabled={loading}
                        style={{
                            padding: "8px 14px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            background: "#fff",
                            // color: "#fff",
                            cursor: "pointer"
                        }}
                    >
                        Cancel
                    </button>

                    <button
                        onClick={handleRequireAttention}
                        disabled={loading || (!report?.requiresAttention && !selectedImage)}
                        style={{
                            padding: "8px 14px",
                            borderRadius: "6px",
                            border: "none",
                            background: loading || (!report?.requiresAttention && !selectedImage) ? "#ccc" : "#f59e0b",
                            color: "white",
                            cursor: loading || (!report?.requiresAttention && !selectedImage) ? "not-allowed" : "pointer",
                            fontWeight: "500"
                        }}
                    >
                        {loading ? "Processing..." : report?.requiresAttention ? "Undo" : "Confirm"}
                    </button>
                </div>
            </ReactModal>


            <Modal
                className="app-bootstrap-modal"
                backdropClassName="app-bootstrap-modal-backdrop"
                show={showWorkEditModal}
                onHide={() => setShowWorkEditModal(false)}
                centered={!isMobile}
                backdrop="static"
                keyboard={false}
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Work Required Pricing</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        {(() => {
                            const allItems = [];
                            const gapKeywords = ["lock", "hinge", "top", "bottom"];

                            (report.workNeeded || "")
                                .split(/\n|\|/)
                                .map((line) => line.trim())
                                .filter((line) => line)
                                .forEach((line) => {
                                    if (line.toLowerCase().includes("gap")) {
                                        gapKeywords.forEach((gap) => {
                                            if (line.toLowerCase().includes(gap)) {
                                                const gapText = `Adjust Gap - ${gap.charAt(0).toUpperCase() + gap.slice(1)}`;
                                                allItems.push(gapText);
                                            }
                                        });
                                    } else {
                                        allItems.push(line);
                                    }
                                });

                            const uniqueItems = Array.from(new Set(allItems));

                            return uniqueItems.map((item, index) => (
                                <Col md={6} key={index}>
                                    <div className="d-flex align-items-center gap-3 mb-3">
                                        <div className="flex-grow-1">{item}</div>
                                        <div style={{ width: "140px" }}>
                                            <InputGroup>
                                                <InputGroup.Text>
                                                    <FontAwesomeIcon icon={faPoundSign} />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    type="number"
                                                    min="0"
                                                    step="1"
                                                    value={editedPrices[item] || ""}
                                                    onChange={(e) =>
                                                        setEditedPrices((prev) => ({
                                                            ...prev,
                                                            [item]: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </InputGroup>
                                        </div>
                                    </div>
                                </Col>
                            ));
                        })()}

                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowWorkEditModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleSaveWorkPrices}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>

            <ReactModal
                isOpen={showPinModal}
                onRequestClose={() => setShowPinModal(false)}
                shouldCloseOnOverlayClick={true}
                shouldCloseOnEsc={true}
                style={{
                    overlay: {
                        backgroundColor: "rgba(0,0,0,0.6)",
                        backdropFilter: "blur(3px)",
                        zIndex: 30020,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    content: {
                        position: "relative",
                        inset: "unset",
                        maxWidth: "420px",
                        width: "90%",
                        borderRadius: "14px",
                        padding: "0",
                        border: "none",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                        zIndex: 30021,
                        overflow: "hidden"
                    }
                }}
            >
                <div style={{ backgroundColor: "red", color: "white", padding: "16px 22px" }}>
                    <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>Enter PIN</h5>
                </div>

                <div style={{ padding: "22px" }}>
                    <div style={{ marginBottom: "16px" }}>
                        <label
                            htmlFor="pinInput"
                            style={{
                                display: "block",
                                marginBottom: "8px",
                                fontSize: "14px",
                                fontWeight: "500"
                            }}
                        >
                            Enter your PIN:
                        </label>
                        <input
                            id="pinInput"
                            type="password"
                            maxLength="4"
                            value={pin}
                            onChange={(e) => setPin(e.target.value)}
                            placeholder="****"
                            style={{
                                width: "100%",
                                padding: "10px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                                fontSize: "14px",
                                outline: "none"
                            }}
                            onFocus={(e) => e.target.style.borderColor = "#0d6efd"}
                            onBlur={(e) => e.target.style.borderColor = "#ddd"}
                        />
                    </div>
                </div>

                <div style={{
                    padding: "16px 22px",
                    borderTop: "1px solid #dee2e6",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end"
                }}>
                    <button
                        onClick={() => {
                            setPin("");
                            setShowPinModal(false);
                        }}
                        style={{
                            padding: "8px 16px",
                            backgroundColor: "#6c757d",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            fontSize: "14px",
                            cursor: "pointer",
                            fontWeight: "500"
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleVerifyPin}
                        style={{
                            padding: "8px 16px",
                            backgroundColor: "#dc3545",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            fontSize: "14px",
                            cursor: "pointer",
                            fontWeight: "500"
                        }}
                    >
                        Submit
                    </button>
                </div>
            </ReactModal>

            <div>
                <ReactModal
                    isOpen={showModal}
                    onRequestClose={() => setShowModal(false)}
                    shouldCloseOnOverlayClick={false}
                    shouldCloseOnEsc={!loading}
                    onAfterOpen={() => {
                        setMessage(report?.workDone || "");
                        setSelectedFiles([]);
                        setFileNames([]);
                    }}
                    style={{
                        overlay: {
                            backgroundColor: "rgba(0,0,0,0.6)",
                            backdropFilter: "blur(3px)",
                            zIndex: 30020,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        content: {
                            position: "relative",
                            inset: "unset",
                            maxWidth: "600px",
                            width: "90%",
                            maxHeight: "90vh",
                            borderRadius: "14px",
                            padding: "0",
                            border: "none",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                            zIndex: 30021,
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column"
                        }
                    }}
                >
                    <div style={{
                        padding: "16px 22px",
                        borderBottom: "1px solid #dee2e6",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>Work Completed</h5>
                        <button
                            onClick={() => setShowModal(false)}
                            style={{
                                background: "none",
                                border: "none",
                                fontSize: "24px",
                                cursor: "pointer",
                                padding: "0",
                                lineHeight: "1",
                                color: "#000"
                            }}
                        >
                            ×
                        </button>
                    </div>

                    <div style={{ padding: "22px", overflowY: "auto", flex: "1" }}>
                        <textarea
                            className="form-control mb-3 shadow-sm"
                            placeholder="Enter details..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            style={{
                                minHeight: "120px",
                                maxHeight: "250px",
                                borderRadius: "8px",
                                transition: "box-shadow 0.3s ease",
                                width: "100%",
                                padding: "10px 12px",
                                border: "1px solid #ddd",
                                fontSize: "14px",
                                outline: "none",
                                resize: "vertical"
                            }}
                        ></textarea>

                        {report?.workDonePhoto?.length > 0 && (
                            <div className="mb-3">
                                <p className="small text-muted">Existing Photos:</p>
                                <div className="d-flex flex-wrap gap-2">
                                    {report.workDonePhoto.map((photo, index) => (
                                        <div key={index} className="position-relative" style={{ width: "200px", height: "150px" }}>
                                            <img
                                                src={photo}
                                                alt={`Work Done ${index + 1}`}
                                                className="img-fluid rounded shadow-sm"
                                                style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "10px" }}
                                                onClick={() => {
                                                    setSelectedPhoto(photo);
                                                    setShowModalDelImage(true);
                                                }}
                                            />

                                            <div
                                                className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                style={{ background: "rgba(0, 0, 0, 0.4)", borderRadius: "10px", opacity: "0", transition: "opacity 0.3s ease" }}
                                                onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
                                                onMouseLeave={(e) => (e.currentTarget.style.opacity = "0")}
                                            >
                                                <button
                                                    className="btn btn-danger d-flex align-items-center justify-content-center"
                                                    onClick={() => handleDeleteClick(photo, index)}
                                                    style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {showModalDelImage && (
                            <div
                                className="modal fade show d-flex align-items-center justify-content-center"
                                style={{ background: "rgba(0, 0, 0, 0.5)", position: "fixed", top: 0, left: 0, width: "100%", height: "100%" }}
                            >
                                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "350px" }}>
                                    <div className="modal-content text-center">
                                        <div className="modal-header">
                                            <h6 className="modal-title w-100">Confirm Delete</h6>
                                            <button className="btn-close" onClick={() => setShowModalDelImage(false)}></button>
                                        </div>
                                        <div className="modal-body">
                                            <p className="mb-2">Are you sure you want to delete this photo?</p>
                                            <img
                                                src={selectedPhoto}
                                                className="img-fluid rounded shadow-sm"
                                                style={{ maxHeight: "120px", objectFit: "cover" }}
                                                alt="Selected"
                                                onClick={() => setShowModalDelImage(false)}
                                            />
                                        </div>
                                        <div className="modal-footer">
                                            <button className="btn btn-secondary" onClick={() => setShowModalDelImage(false)}>Cancel</button>
                                            <button className="btn btn-danger" onClick={handleConfirmDelete}>Delete</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="d-flex gap-2">
                            <label className="btn btn-outline-primary w-50">
                                Upload from Files
                                <input
                                    type="file"
                                    className="d-none"
                                    accept="image/*"
                                    multiple
                                    onChange={handleFileSelection}
                                />
                            </label>

                            <label className="btn btn-outline-success w-50">
                                Take a Photo
                                <input
                                    type="file"
                                    className="d-none"
                                    accept="image/*"
                                    capture="environment"
                                    multiple
                                    onChange={handleFileSelection}
                                />
                            </label>
                        </div>

                        {/* {fileNames.length > 0 && (
                            <p className="mt-2 small text-muted">
                                Selected Files: {fileNames.map((name, index) => (
                                    <strong key={index}>{name}{index !== fileNames.length - 1 ? ', ' : ''}</strong>
                                ))}
                            </p>
                        )} */}

                        {selectedFiles.length > 0 && (
                            <div className="mt-3 d-flex flex-wrap gap-3">
                                {selectedFiles.map((file, index) => (
                                    file.type.startsWith("image/") ? (
                                        <div key={index} className="position-relative">
                                            <img
                                                src={URL.createObjectURL(file)}
                                                alt="Preview"
                                                className="img-fluid rounded shadow-sm"
                                                style={{ maxHeight: "150px", width: "200px", objectFit: "cover" }}
                                            />
                                            <button
                                                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 d-flex align-items-center justify-content-center"
                                                onClick={() => removeSelectedFile(index)}
                                                style={{
                                                    borderRadius: "50%",
                                                    padding: "5px",
                                                    width: "28px",
                                                    height: "28px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faTrash} size="xs" />
                                            </button>
                                        </div>
                                    ) : (
                                        <p key={index} className="small text-muted">{file.name}</p>
                                    )
                                ))}
                            </div>
                        )}
                    </div>

                    <div style={{
                        padding: "16px 22px",
                        borderTop: "1px solid #dee2e6",
                        display: "flex",
                        gap: "10px",
                        justifyContent: "flex-end"
                    }}>
                        <button
                            onClick={() => { setShowModal(false); setShowClearModal(true) }}
                            disabled={loading}
                            style={{
                                padding: "8px 16px",
                                backgroundColor: loading ? "#6c757d" : "#dc3545",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                fontSize: "14px",
                                cursor: loading ? "not-allowed" : "pointer",
                                fontWeight: "500"
                            }}
                        >
                            {loading ? "Clearing..." : "Clear All"}
                        </button>

                        <button
                            onClick={() => setShowModal(false)}
                            style={{
                                padding: "8px 16px",
                                backgroundColor: "#6c757d",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                fontSize: "14px",
                                cursor: "pointer",
                                fontWeight: "500"
                            }}
                        >
                            Cancel
                        </button>

                        <button
                            onClick={updateWorkDone}
                            disabled={loading}
                            style={{
                                padding: "8px 16px",
                                backgroundColor: loading ? "#6c757d" : "#28a745",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                fontSize: "14px",
                                cursor: loading ? "not-allowed" : "pointer",
                                fontWeight: "500"
                            }}
                        >
                            {loading ? "Updating..." : "Submit"}
                        </button>
                    </div>
                </ReactModal>
            </div>

            <Modal
                className="app-bootstrap-modal"
                backdropClassName="app-bootstrap-modal-backdrop"
                show={showNoAccessModal}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
            >
                <Modal.Header className="position-relative justify-content-center">
                    <div
                        className="position-absolute start-0 ps-3"
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate(-1)}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </div>
                    <Modal.Title className="text-center w-100">No Access - Survey Not Completed</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="text-center fs-5">
                        <p>Access to this door was not obtained, therefore no data is available.</p>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                className="app-bootstrap-modal"
                backdropClassName="app-bootstrap-modal-backdrop"
                show={showRequiresReviewModal}
                backdrop="static"
                keyboard={false}
                centered
                size="lg"
            >
                <Modal.Header className="position-relative justify-content-center">
                    <div
                        className="position-absolute start-0 ps-3"
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate(-1)}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </div>
                    <Modal.Title className="text-center w-100">Under Review - Survey Pending</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="text-center fs-5">
                        <p>This door is currently under review. The survey will be completed shortly.</p>
                    </div>
                </Modal.Body>
            </Modal>


            <Modal
                className="details-modal app-bootstrap-modal"
                backdropClassName="app-bootstrap-modal-backdrop"
                show={showDetailsModal}
                onHide={handleCloseDetailsModal}
                centered={!isMobile}
                backdrop="static"
                keyboard={false}
                size="xl"
                scrollable
            >
                <Modal.Header>
                    <Modal.Title>Enter Residential Door Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form ref={formRef}>
                        <Row className="mb-3">
                            <Col xs={12} md={4}>
                                <Form.Group controlId="doorNumber" className="mb-3">
                                    <Form.Label>Door Number</Form.Label>
                                    <Form.Control name="doorNumber" type="text" placeholder="Enter Door Number" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={4}>
                                <Form.Group controlId="floor" className="mb-3">
                                    <Form.Label>Door Level</Form.Label>
                                    <Form.Control name="floor" type="text" placeholder="Enter Door Level" />
                                </Form.Group>
                            </Col>
                        </Row>



                        {IsMobileReact && (
                            <>
                                <div className="d-flex gap-2 mb-3">
                                    <Button variant="primary" onClick={handleOpenCamera}>
                                        Open Camera
                                    </Button>
                                </div>

                                <Row className="mb-4">
                                    <Col xs={12} md={6}>
                                        <div className="p-3 border rounded shadow-sm h-100 bg-light">
                                            <h5 className="mb-3 text-primary">Camera Video</h5>
                                            {lastVideoUrl ? (
                                                <video
                                                    src={lastVideoUrl}
                                                    controls
                                                    muted
                                                    style={{ width: "100%", borderRadius: 8 }}
                                                />
                                            ) : (
                                                <p className="text-muted text-center mb-0">
                                                    No video captured yet
                                                </p>
                                            )}
                                        </div>
                                    </Col>


                                    <Col xs={12} md={6}>
                                        <div className="p-3 border rounded shadow-sm h-100 bg-light">
                                            <h5 className="mb-3 text-primary">Captured Photos</h5>
                                            <div className="d-flex gap-3 flex-wrap mt-2">
                                                {photo1 && (
                                                    <div className="text-center">
                                                        <img src={photo1} alt="Front" width={100} />
                                                        <div className="mt-1 small text-muted">Front</div>
                                                    </div>
                                                )}
                                                {photo2 && (
                                                    <div className="text-center">
                                                        <img src={photo2} alt="Internal" width={100} />
                                                        <div className="mt-1 small text-muted">Internal</div>
                                                    </div>
                                                )}
                                                {photo3 && (
                                                    <div className="text-center">
                                                        <img src={photo3} alt="Cert" width={100} />
                                                        <div className="mt-1 small text-muted">Cert</div>
                                                    </div>
                                                )}
                                                {photo4 && (
                                                    <div className="text-center">
                                                        <img src={photo4} alt="Back" width={100} />
                                                        <div className="mt-1 small text-muted">Back</div>
                                                    </div>
                                                )}
                                                {!photo1 && !photo2 && !photo3 && !photo4 && (
                                                    <p className="text-muted">No photos captured yet</p>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                            </>
                        )}


                    </Form>
                </Modal.Body>

                <Modal.Footer>

                    <div className="d-flex d-md-none w-100">
                        <div className="w-50 pe-1">
                            <Button variant="secondary" onClick={handleCloseDetailsModal} className="w-100">
                                Cancel
                            </Button>
                        </div>
                        <div className="w-50 ps-1">
                            <Button variant="danger" onClick={handleSubmitDetails} className="w-100">
                                Save Details
                            </Button>
                        </div>
                    </div>

                    <div className="d-none d-md-flex justify-content-end w-100 gap-2">
                        <Button variant="secondary" onClick={handleCloseDetailsModal}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={handleSubmitDetails}>
                            Save Details
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                className="app-bootstrap-modal app-bootstrap-modal--nested"
                backdropClassName="app-bootstrap-modal-backdrop app-bootstrap-modal-backdrop--nested"
                show={showCameraModal}
                onHide={handleCloseCameraModal}
                fullscreen
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Camera</Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-0" style={{ backgroundColor: 'black', position: 'relative' }}>
                    <video
                        ref={videoRef}
                        autoPlay
                        muted
                        playsInline
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                    <canvas ref={canvasRef} style={{ display: 'none' }} />

                    <div style={{
                        position: 'absolute',
                        top: 20,
                        left: 20,
                        color: 'white',
                        fontSize: 24,
                        fontWeight: 'bold',
                        backgroundColor: countdown > 0 ? 'rgba(0,0,0,0.5)' : 'rgba(0,128,0,0.7)',
                        padding: '5px 12px',
                        borderRadius: 8,
                    }}>
                        {countdown > 0 ? `Recording: ${countdown}s` : 'Recorded Successfully'}
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            bottom: 40,
                            width: '100%',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, minmax(100px, 1fr))',
                            gap: '12px',
                            justifyItems: 'center',
                            padding: '0 16px',
                        }}
                    >
                        <Button
                            variant="light"
                            disabled={!!photo1}
                            onClick={() => handleTakePhoto(1)}
                        >
                            Front
                        </Button>
                        <Button
                            variant="light"
                            disabled={!!photo2}
                            onClick={() => handleTakePhoto(2)}
                        >
                            Internal
                        </Button>
                        <Button
                            variant="light"
                            disabled={!!photo3}
                            onClick={() => handleTakePhoto(3)}
                        >
                            Cert
                        </Button>
                        <Button
                            variant="light"
                            disabled={!!photo4}
                            onClick={() => handleTakePhoto(4)}
                        >
                            Back
                        </Button>
                        <Button
                            variant="danger"
                            style={{ gridColumn: '1 / -1' }}
                            onClick={handleStopRecording}
                        >
                            Stop Recording
                        </Button>
                    </div>



                </Modal.Body>
            </Modal>

            <Modal
                className="app-bootstrap-modal"
                backdropClassName="app-bootstrap-modal-backdrop"
                show={showTenantModal}
                onHide={handleClose}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Enter Tenant Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label>Full Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={tenant.name}
                                        onChange={handleChange}
                                        placeholder="Enter full name"
                                    />
                                </Form.Group>
                            </div>

                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label>Phone Number</Form.Label>
                                    <Form.Control
                                        type="tel"
                                        name="phone"
                                        value={tenant.phone}
                                        onChange={handleChange}
                                        placeholder="Enter phone number"
                                    />
                                </Form.Group>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={tenant.email}
                                        onChange={handleChange}
                                        placeholder="Enter email address"
                                    />
                                </Form.Group>
                            </div>

                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label>Move-in Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="moveInDate"
                                        value={tenant.moveInDate}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="address"
                                        value={tenant.address}
                                        onChange={handleChange}
                                        placeholder="Enter address"
                                    />
                                </Form.Group>
                            </div>



                            <div className="col-md-6 mb-3">
                                <Form.Group>
                                    <Form.Label>Notes</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        name="notes"
                                        rows={1}
                                        value={tenant.notes}
                                        onChange={handleChange}
                                        placeholder="Additional info (optional)"
                                        style={{
                                            resize: "vertical",
                                            maxHeight: "100px",
                                        }}
                                    />
                                </Form.Group>
                            </div>


                        </div>
                    </Form>
                </Modal.Body>

                <Modal.Footer className="justify-content-end">
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <EstimateModal
                show={showEstimateModal}
                onHide={() => {
                    setShowEstimateModal(false);
                    setSelectedDoor([]);
                }}
                doorData={selectedDoor}
                doorsData={null}
                buildingData={buildingData}
                foundBuildingUid={foundReportUid}
                onGenerate={() => {
                    // console.log('Estimate generated successfully');
                }}
            />

            <PhotoSelector
                show={showPdfPhotoPicker}
                report={report}
                doorHistory={doorHistory}
                db={db}
                buildingData={buildingData}

                currentDoorId={doorId}
                currentReportUid={reportUidToUse || uid}

                onClose={() => setShowPdfPhotoPicker(false)}
                onGenerate={async (selectedPhotoFields) => {
                    setShowPdfPhotoPicker(false);

                    await exportToPDF(
                        buildingData,
                        report,
                        selectedPhotoFields
                    );
                }}
            />

        </div >
    );
};

export default DoorResiDetails;
